import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Translation resources
const resources = {
  en: {
    translation: {
      SERVICE_UNAVAILABLE_NOTICE: 'You do not have access to a service',
      BBS_CMS_CONNECTING: 'Connecting to BBS-CMS…',
      BBS_CMS_SESSION_EXPIRED: 'Session expired. Please log in again from BBS-CMS.',
      BBS_CMS_RELOAD: 'Reload',
      FORM_ATTACK_STOPPED_SUCCESSFULLY: 'Form attack stopped successfully',
      LOGOUT_ERROR: 'Logout failed. Please try again later.',
      SEO: 'SEO',
      LOGO_TITLE: 'SEO Dashboard',
      Keywords: 'Keywords',
      HOME: 'Home',
      BACKLINK: 'Backlink',
      'Date,Time': 'Date, Time',
      KEYWORD: 'Keyword',
      STATUS: 'Status',
      'Number of Websites': 'Number of Websites',
      LANGUAGE: 'English',
      SCROLL_HINT: 'Scrollable',
      Dashboard: 'Dashboard',
      'Keyword Management': 'Keyword Management',
      'Build Backlink': 'Build Backlink',
      IS_WEBSITE_BACKLINK: 'Is My Website Backlink',
      'Summary Article': 'Summary Article',
      local: 'Local',
      MANUALLY_ENTERED_KEYWORD: 'Manually Entered Keyword',
      business: 'Business',
      SEO_ARTICLE: 'SEO Article',
      REVIEW_PROMOTION: 'Review Promotion',
      REVIEW_PROMOTION_DESCRIPTION: 'This page will host features to promote and manage customer reviews.',
      REVIEW_PROMOTION_SMS_DAILY_REPORT: 'Review Promotion (SMS schedule report)',
      REVIEW_PROMOTION_SMS_DAILY_REPORT_HELP:
        'Sends a daily report (09:00 JST) of scheduled Review Promotion SMS counts per location.',
      REVIEW_PROMOTION_STATUS_SCHEDULED: 'Scheduled',
      REVIEW_PROMOTION_STATUS_SENDING: 'Sending',
      REVIEW_PROMOTION_STATUS_SENT: 'Sent',
      REVIEW_PROMOTION_STATUS_FAILED: 'Failed',
      REVIEW_PROMOTION_STATUS_CANCELLED: 'Cancelled',
      REVIEW_PROMOTION_FAILED_TO_LOAD_LOCATIONS: 'Failed to load locations.',
      REVIEW_PROMOTION_NO_LOCATIONS: 'No locations are available for Review Promotion.',
      REVIEW_PROMOTION_TAB_SETTINGS: 'Settings',
      REVIEW_PROMOTION_TAB_SMS_LIST: 'SMS Schedule',
      REVIEW_PROMOTION_SMS_DETAIL_TITLE: 'SMS schedule details',
      REVIEW_PROMOTION_SMS_LIST_DISABLED_TOAST: 'Complete the settings to use the SMS schedule list.',
      REVIEW_PROMOTION_UPDATED: 'Updated.',
      REVIEW_PROMOTION_UPDATE_FAILED: 'Update failed. Please try again later.',
      REVIEW_PROMOTION_NOTES_SAVED: 'Notes saved.',
      REVIEW_PROMOTION_NOTES_SAVE_FAILED: 'Failed to save notes. Please try again later.',
      REVIEW_PROMOTION_SEND_DATE_UPDATED: 'Send date updated.',
      REVIEW_PROMOTION_SEND_DATE_UPDATE_FAILED: 'Failed to update send date. Please try again later.',
      REVIEW_PROMOTION_HIDE: 'Hide',
      REVIEW_PROMOTION_SMS_LIST_DISABLED_HELP:
        'The SMS schedule list will be available after you save the settings and the inbound email address is issued.',
      REVIEW_PROMOTION_SEARCH: 'Search',
      REVIEW_PROMOTION_FILTERS: 'Filters',
      REVIEW_PROMOTION_FILTERS_SUMMARY_NONE: 'No filters',
      REVIEW_PROMOTION_INVALID_DATE_RANGE: 'Invalid date range (From/To).',
      REVIEW_PROMOTION_FILTER_KEYWORD: 'Keyword (name / phone / notes)',
      REVIEW_PROMOTION_FILTER_KEYWORD_PLACEHOLDER: 'e.g., Yamada / 090 / note',
      REVIEW_PROMOTION_FILTER_VISIT_DATE: 'Visit date (From/To)',
      REVIEW_PROMOTION_FILTER_SMS_SEND_DATE: 'Send date (From/To)',
      REVIEW_PROMOTION_FILTER_TARGET: 'Target',
      REVIEW_PROMOTION_TARGET_INCLUDED: 'Included',
      REVIEW_PROMOTION_TARGET_EXCLUDED: 'Excluded',
      REVIEW_PROMOTION_FILTER_STATUS: 'Status',
      REVIEW_PROMOTION_SORT: 'Sort',
      REVIEW_PROMOTION_SORT_ORDER: 'Order',
      REVIEW_PROMOTION_SORT_BY_SMS_SEND_DATE: 'Send date',
      REVIEW_PROMOTION_SORT_BY_VISIT_DATETIME: 'Visit datetime',
      REVIEW_PROMOTION_SORT_ASC: 'Ascending',
      REVIEW_PROMOTION_SORT_DESC: 'Descending',
      REVIEW_PROMOTION_LIMIT: 'Items per page',
      REVIEW_PROMOTION_TABLE_VISIT_DATETIME: 'Visit datetime',
      REVIEW_PROMOTION_TABLE_SERVICE: 'Service',
      REVIEW_PROMOTION_TABLE_NAME: 'Name',
      REVIEW_PROMOTION_TABLE_PHONE: 'Phone',
      REVIEW_PROMOTION_TABLE_TARGET: 'Target',
      REVIEW_PROMOTION_TABLE_SMS_SEND_DATE: 'Send date',
      REVIEW_PROMOTION_TABLE_SMS_SEND_DATETIME: 'Send datetime',
      REVIEW_PROMOTION_TABLE_STATUS: 'Status',
      REVIEW_PROMOTION_TABLE_NOTES: 'Notes',
      REVIEW_PROMOTION_EMPTY: 'No data.',
      REVIEW_PROMOTION_PAGINATION_RANGE: 'Showing {{from}}–{{to}}',
      REVIEW_PROMOTION_PAGINATION_TOTAL: '{{total}} total',
      REVIEW_PROMOTION_PAGINATION_PAGE: '{{page}}/{{totalPages}} pages',
      REVIEW_PROMOTION_PAGINATION_EMPTY: '0 total',
      REVIEW_PROMOTION_SEND_DATE_REQUIRED: 'Please enter a send date.',
      REVIEW_PROMOTION_SEND_DATE_MIN_TOMORROW: 'Send date must be tomorrow or later.',
      REVIEW_PROMOTION_SAVE_SEND_DATE: 'Save send date',
      REVIEW_PROMOTION_SAVE_NOTES: 'Save notes',
      REVIEW_PROMOTION_TOOLTIP_SAVE_SEND_DATE: 'Saves the send date.',
      REVIEW_PROMOTION_TOOLTIP_SAVE_NOTES: 'Saves the notes.',
      REVIEW_PROMOTION_TOOLTIP_SAVE_TARGET: 'Saves the target setting.',
      REVIEW_PROMOTION_SMS_SEND_TIME_OVERRIDE_LABEL: 'Send time (this schedule only)',
      REVIEW_PROMOTION_SMS_SEND_TIME_OVERRIDE_HELP:
        'If not set, the default send time in settings will be used (5-minute increments).',
      REVIEW_PROMOTION_SMS_SEND_TIME_DEFAULT_OPTION: 'Default ({{time}})',
      REVIEW_PROMOTION_SETTINGS_FETCH_FAILED: 'Failed to load settings. Please try again later.',
      REVIEW_PROMOTION_COPIED: 'Copied.',
      REVIEW_PROMOTION_COPY_FAILED: 'Copy failed.',
      REVIEW_PROMOTION_EMAIL_REQUIRED: 'Please enter an email address.',
      REVIEW_PROMOTION_EMAIL_INVALID: 'Invalid email address format.',
      REVIEW_PROMOTION_SMS_DAYS_INVALID: 'Days must be an integer between 1 and 90.',
      REVIEW_PROMOTION_SEND_TIME_INVALID: 'Time must be in HH:MM format.',
      REVIEW_PROMOTION_SETTINGS_SAVED: 'Settings saved.',
      REVIEW_PROMOTION_SETTINGS_SAVE_FAILED: 'Failed to save settings. Please try again later.',
      REVIEW_PROMOTION_FORWARD_TO_EMAIL: 'Forward-to email address',
      REVIEW_PROMOTION_EMAIL_PLACEHOLDER: 'example@domain.com',
      REVIEW_PROMOTION_FORWARD_TO_EMAIL_HELP:
        'Enter an email address you check regularly. Reservation emails received by the system will be forwarded here.',
      REVIEW_PROMOTION_SMS_DAYS_LABEL: 'Days after visit (1-90)',
      REVIEW_PROMOTION_SMS_DAYS_HELP: 'How many days after the visit to send the SMS (1-90).',
      REVIEW_PROMOTION_SMS_TARGET_DEFAULT_ON: 'Enable SMS target by default',
      REVIEW_PROMOTION_SMS_TARGET_DEFAULT_HELP:
        'If enabled, new reservations will be included in the SMS list by default. You can change it later per row.',
      REVIEW_PROMOTION_SEND_TIME_LABEL: 'Send time (HH:MM)',
      REVIEW_PROMOTION_SEND_TIME_HELP:
        'After this time each day, the SMS becomes eligible to send. Delivery time is not guaranteed. A daily report summarizing the SMS scheduled for the day is sent at 09:00 JST, so we recommend updating settings after 09:00.',
      REVIEW_PROMOTION_SMS_MESSAGE_LABEL: 'SMS message (max 201 chars)',
      REVIEW_PROMOTION_SMS_MESSAGE_PLACEHOLDER: 'e.g., Thank you for visiting us. Please leave a review if you can.',
      REVIEW_PROMOTION_SMS_MESSAGE_HELP:
        'You can insert customer information into the SMS using {name} and {visit_datetime}.',
      REVIEW_PROMOTION_SMS_MESSAGE_COUNT: '{{count}} / {{max}}',
      REVIEW_PROMOTION_SMS_MESSAGE_TOO_LONG: 'SMS message is too long. Please keep it within 201 characters.',
      REVIEW_PROMOTION_INBOUND_EMAIL_LABEL: 'Inbound email address',
      REVIEW_PROMOTION_INBOUND_EMAIL_HELP: 'Send (or forward) reservation notification emails to this address.',
      REVIEW_PROMOTION_INBOUND_EMAIL_SECTION_TITLE: 'Inbound email',
      REVIEW_PROMOTION_INBOUND_EMAIL_EMPTY: 'No inbound email found for this record.',
      REVIEW_PROMOTION_CANCEL_EMAIL_SECTION_TITLE: 'Cancellation email',
      REVIEW_PROMOTION_CANCEL_EMAIL_EMPTY: 'No cancellation email found for this record.',
      REVIEW_PROMOTION_INBOUND_EMAIL_SUBJECT: 'Subject',
      REVIEW_PROMOTION_INBOUND_EMAIL_FROM: 'From',
      REVIEW_PROMOTION_INBOUND_EMAIL_RECEIVED_AT: 'Received at',
      REVIEW_PROMOTION_INBOUND_EMAIL_BODY: 'Body',
      REVIEW_PROMOTION_INBOUND_EMAIL_BODY_EMPTY: '(Empty)',
      REVIEW_PROMOTION_RELOAD: 'Reload',
      WEBSITES: 'Websites',
      Want: 'Want',
      Filter: 'Filter',
      FILTER_WEBSITES: 'Filter Websites',
      'Attack List': 'Attack List',
      'Add to Attack List': 'Add to Attack List',
      'Send Mail': 'Send Mail',
      'No websites selected for the attack list': 'No websites selected for the attack list',
      REFRESH: 'Refresh',
      'Generate Blog': 'Generate Blog',
      'Submit Blog': 'Submit Blog',
      'Save Blog': 'Save Blog',
      ID: 'ID',
      EMAIL_HISTORY: 'Email History',
      ALL: 'All',
      TITLE: 'Title',
      BODY: 'Body',
      WEBSITE: 'Website',
      DOMAIN: 'Domain',
      SEO_RANK: 'SEO Rank',
      DOMAIN_RATE: 'DR',
      INTERSECTION_COUNT: 'Intersect',
      DOMAIN_TYPE: 'Domain Type',
      LIST_TYPE: 'List Type',
      ADDRESS: 'Address',
      PHONE: 'Phone',
      INQUIRY_FORM: 'Inquiry Form',
      OPENED: 'Opened',
      ACTION: 'Action',
      'Not Sent': 'Not Sent',
      Sent: 'Sent',
      UNSENDABLE: 'Unsendable',
      EXCLUDE: 'Exclude',
      Replied: 'Replied',
      'Backlink Provided': 'Backlink Provided',
      Rejected: 'Rejected',
      'Not Found': 'Not Found',
      Unknown: 'Unknown',
      LOGOUT: 'Logout',
      Previous: 'Previous',
      Next: 'Next',
      SUGGEST_OR_RELATED_KEYWORD: 'Suggest/Related keyword',
      SOCIAL_LINKS: 'Social Links',
      VALID_EMAIL: 'Valid email',
      COMPETITIVE_BACKLINK: 'Competitive Backlink',
      'No Links Found': 'No Links Found',
      'N/A': 'N/A',
      WEBSITES_FOR: 'Websites for',
      'Search Query': 'Search Query',
      Search: 'New List',
      PLATFORM: 'Platform',
      INDIVIDUAL_DOMAIN: 'Individual domain',
      MINIMUM_DOMAIN_RANK: 'Minimum Domain Rank',
      From: 'From',
      To: 'To',
      Subject: 'Subject',
      'Email Body': 'Email Body',
      SUGGEST: 'Suggest',
      RELATED_SEARCH: 'Related search',
      SUGGESTION: 'Suggestion',
      INITIAL_QUERY: 'Initial Query',
      'Blog content submitted': 'Blog content submitted',
      'Enter a topic for the blog': 'Enter a topic for the blog',
      'Please enter some content to save': 'Please enter some content to save',
      'Blog content saved to local storage': 'Blog content saved to local storage',
      'Compose Email': 'Compose Email',
      'To:': 'To:',
      'Subject:': 'Subject:',
      EMAIL_BODY: 'Email Body',
      'Subject of the email': 'Subject of the email',
      'Sending...': 'Sending...',
      'Send Email': 'Send Email',
      'Failed to send email': 'Failed to send email',
      'Email sent successfully!': 'Email sent successfully!',
      'All fields are required!': 'All fields are required!',
      'Recipient email addresses': 'Recipient email addresses',
      'Email Outreach': 'Email Outreach',
      LINE_OFFICIAL_ACCOUNT: 'LINE Official Account',
      ENTER_TALK_ID: 'Enter Talk ID *',
      REGISTER: 'Register',
      REGISTERING: 'Registering',
      LOGIN: 'Login',
      ADD_FRIEND: 'Add Friend',
      'Select Keywords and Create Articles': 'Business Articles\nSelect keywords and create articles',
      'Rewrite Existing Articles': 'Rewrite Existing Articles',
      CONFIRM_ARTICLES_ALREADY_CREATED: 'Confirm Articles Already Created',
      CONFIRM_ARTICLE_GENERATION_RETRY: 'Confirm Article Generation Retry',
      ENTER_KEYWORD_MANUALLY: 'Enter Keyword to create an article',
      ARTICLE_DETAILS: 'Article Details',
      MY_WEBSITES: 'My Websites',
      'Add Website': 'Add Website',
      LOCATION_NAME: 'Location Name',
      'Location Name': 'Location Name',
      'Character Count': 'Character Count',
      RTE_UNDO: 'Undo',
      RTE_REDO: 'Redo',
      RTE_BOLD: 'Bold',
      RTE_ITALIC: 'Italic',
      RTE_ALIGN_LEFT: 'Align left',
      RTE_ALIGN_CENTER: 'Align center',
      RTE_ALIGN_RIGHT: 'Align right',
      RTE_ALIGN_JUSTIFY: 'Justify',
      RTE_LINK: 'Link',
      RTE_LINK_PROMPT: 'Enter URL',
      RTE_IMAGE: 'Image',
      RTE_IMAGE_PROMPT: 'Enter image URL',
      RTE_SOURCE_CODE: 'Source code',
      RTE_INSERT_TABLE: 'Insert table',
      RTE_ADD_ROW: 'Add row',
      RTE_ADD_COL: 'Add column',
      RTE_DELETE_TABLE: 'Delete table',
      RTE_CUT: 'Cut',
      RTE_COPY: 'Copy',
      RTE_PASTE: 'Paste',
      RTE_SELECT_ALL: 'Select all',
      RTE_CANCEL: 'Cancel',
      RTE_APPLY: 'Apply',
      RTE_BULLET_LIST: 'Bullet list',
      RTE_ORDERED_LIST: 'Numbered list',
      RTE_INDENT: 'Indent',
      RTE_OUTDENT: 'Outdent',
      RTE_UNDERLINE: 'Underline',
      RTE_STRIKETHROUGH: 'Strikethrough',
      RTE_CLEAR_FORMATTING: 'Clear formatting',
      RTE_BLOCK_FORMAT: 'Block format',
      RTE_PARAGRAPH: 'Paragraph',
      RTE_HEADING_1: 'Heading 1',
      RTE_HEADING_2: 'Heading 2',
      RTE_HEADING_3: 'Heading 3',
      RTE_HEADING_4: 'Heading 4',
      RTE_TASK_LIST: 'Checklist',
      RTE_CODE_BLOCK: 'Code block',
      RTE_BLOCKQUOTE: 'Blockquote',
      RTE_HORIZONTAL_RULE: 'Horizontal rule',
      RTE_LIST: 'List',
      RTE_INLINE_CODE: 'Inline code',
      RTE_SUBSCRIPT: 'Subscript',
      RTE_SUPERSCRIPT: 'Superscript',
      RTE_HIGHLIGHT: 'Highlight',
      RTE_REMOVE_HIGHLIGHT: 'Remove highlight',
      RTE_DELETE_ROW: 'Delete row',
      RTE_DELETE_COLUMN: 'Delete column',
      RTE_MERGE_CELLS: 'Merge cells',
      RTE_SPLIT_CELL: 'Split cell',
      RTE_TOGGLE_HEADER_ROW: 'Toggle header row',
      RTE_TOGGLE_HEADER_COLUMN: 'Toggle header column',
      RTE_ADD_ROW_ABOVE: 'Insert row above',
      RTE_ADD_ROW_BELOW: 'Insert row below',
      RTE_ADD_COLUMN_BEFORE: 'Insert column before',
      RTE_ADD_COLUMN_AFTER: 'Insert column after',
      'Local Location': 'Local Location',
      WEBSIDE_URL: 'Website URL',
      'Confirm Submission': 'Confirm Submission',
      Yes: 'Yes',
      No: 'No',
      'Are you sure you want to add this website?': 'Are you sure you want to add this website?',
      Settings: 'Settings',
      NOTIFICATIONS: 'Notifications',
      NOTIFICATION_SETTINGS: 'Notification Settings',
      BILLING: 'Billing',
      CREDIT_MANAGEMENT: 'Credit Management',
      LOCATION_INFORMATION: 'Location Information',
      LOCATION_INFORMATION_DESC: 'View contract status for all locations under your account.',
      LOCATION_TOTAL: 'Total',
      LOCATION_PREPARING_COUNT: 'Preparing',
      LOCATION_AGREEMENT_COUNT: 'Agreement',
      LOCATION_EMPTY_SUBTITLE: 'Locations linked to your account will appear here.',
      LOCATION_LIST: 'Location List',
      CONTRACT_STATUS: 'Contract Status',
      AGREEMENT: 'Agreement',
      PREPARING: 'Preparing',
      SCHEDULED_TO_BE_CANCELED: 'Schedule to be canceled',
      CANCELED: 'Canceled',
      TEMPORARY_STOPPING: 'Temporary Stopping',
      LOCATION_AGREEMENT_CONFIRM_TITLE: 'Confirm Agreement',
      LOCATION_AGREEMENT_CONFIRM_DESC:
        'Agreeing will set the contract start date to today and change "{{name}}" from Preparing to Agreement. Continue?',
      LOCATION_AGREEMENT_SUCCESS: 'Contract status changed to Agreement.',
      LOCATION_AGREEMENT_FAILED: 'Failed to change contract status.',
      NO_LOCATIONS_FOUND: 'No locations found.',
      FIXED_PHRASE: 'Fixed Phrase',
      FIXED_PHRASE_TEMPLATES: 'Fixed Phrase Templates',
      FIX: 'Fix',
      RANDOM: 'Random',
      RANDOM_SCHEDULE_TOOLTIP: 'The random option will execute at a random time within the specified range.',
      MY_WEBSITE: 'My Website',
      CMS_INTEGRATION: 'CMS Integration',
      CMS: 'Article Management Settings',
      ARTICLE_MANAGEMENT_SETTINGS: 'Article Management Settings',
      CMS_SETTINGS: 'CMS Settings',
      WORDPRESS: 'WordPress',
      IPP: 'IPP',
      AST: 'AST',
      WP_RELAY: 'WP Relay',
      WP_MODE_OTHER: 'Other',
      BRIDGEBOOKS: 'BridgeBooks',
      BUSINESS_ARTICLES_SELECT_KEYWORDS_AND_CREATE_ARTICLES: 'Business Articles | Select keywords and create articles',
      LOCAL_ARTICLES_SELECT_KEYWORDS_AND_CREATE_ARTICLES: 'Local Articles | Select keywords and create articles',
      REWRITE_EXISTING_ARTICLES: 'Rewrite Existing Articles',
      MAIN_KEYWORDS: 'Main Keyword',
      BILLS: 'Bills',
      ENTER_KEYWORD: 'Select a location, enter a keyword, and press the Create article button',
      'Enter Keyword Here': 'Enter Keyword Here',
      GENERATE_ARTICLE: 'Generate Article',
      AI_GENERATED_CONTENT_WARNING:
        'This content is generated by AI and may contain errors or inaccuracies. Please verify and validate the content before use.',
      ARTICLE_MODE: 'Article Mode',
      Location: 'Location',
      AREA: 'Area',
      'Are you sure you want to generate the article?': 'Are you sure you want to generate the article?',
      'Find My Location': 'Find My Location',
      EMAIL_NOTIFICATION: 'Email Notification',
      EMAIL: 'Email',
      LINE_OFFICIAL_NOTIFICATION: 'LINE Official Notification',
      'Bill History': 'Bill History',
      'Profile Settings': 'Profile Settings',
      New: 'New',
      ARTICLE_WORD_COUNT: 'Article word count',
      NUMBER_OF_WORDS: 'Number of words for the article',
      '5000_CHARACTERS': '5,000 characters',
      '8000_CHARACTERS': '8,000 characters',
      '10000_CHARACTERS': 'Not specified',
      SEARCH_LOCATION: 'Search Location',
      NOT_SPECIFIED: 'Not specified',
      LIMITLESS: 'Not specified',
      LOCAL: 'Local',
      REGIONAL: 'Local',
      BUSINESS: 'Business',
      NOTIFICATION_OPTIONS: 'Notification Options',
      LINE_OFFICIAL_TALK_ID_SAVE_SUCCESS: 'Line Official Talk ID saved successfully',
      LINE_OFFICIAL_TALK_ID_SAVE_FAILED: 'Failed to save Line Official Talk ID',
      EMAIL_SAVE_SUCCESS: 'Email saved successfully',
      EMAIL_SAVE_FAILED: 'Failed to update email',
      NOTIFICATION_EMAIL_HEADING: 'Notification Email',
      NOTIFICATION_EMAIL_DESCRIPTION: 'Configure up to 3 email addresses to receive important alerts.',
      DETAILS_FOR: 'Details for',
      TYPE: 'Type',
      NO_STATUS: '-',
      EXCLUDED: 'Excluded',
      UNCREATED: 'Uncreated',
      IN_PROGRESS: 'In Progress',
      COMPLETED: 'Completed',
      Completed: 'Completed',
      completed: 'Completed',
      FAILED: 'Failed',
      PENDING: 'Pending',
      POSTED: 'Posted',
      NOT_POSTED: 'Not Posted',
      CONFIRMED: 'Confirmed',
      Confirmed: 'Confirmed',
      confirmed: 'Confirmed',
      IN_QUEUE: 'In Queue',
      PROGRESS: 'Progress',
      STARTED_AT: 'Created At',
      QUEUED_AT: 'Queued At',
      COMPLETED_AT: 'Completed At',
      CHANGE_TO_POSTED_STATUS: 'Change to Posted Status',
      CHANGE_STATUS: ' Change Status',
      ALREADY_POSTED: 'Already Posted',
      REWRITE: 'Rewrite',
      EXCLUSION: 'Exclusion',
      WORDPRESS_INTEGRATION: 'WordPress Integration',
      COPY_TITLE: 'Copy Title',
      COPY_MARKDOWN: 'Copy Markdown',
      COPY_HTML: 'Copy HTML',
      COPY_TEXT: 'Copy Text',
      COPY_AS_NOFOLLOW: 'Copy as nofollow',
      MAIN_KEYWORD: 'Keyword Management',
      ADD_MAIN_KEYWORD: 'Add Main Keyword',
      SELECT_MAIN_KEYWORD: 'Select Main Keyword',
      NO_MAIN_KEYWORD_FOUND: 'No main keywords found',
      TARGET_KEYWORD: 'Target Keywords',
      TITLE_COPIED: 'The article title has been copied to the clipboard in text format.',
      MARKDOWN_COPIED: 'The article content has been copied to the clipboard in Markdown format.',
      HTML_COPIED: 'The article content has been copied to the clipboard in HTML format.',
      TEXT_COPIED: 'The article content has been copied to the clipboard in text format.',
      TOP: 'Top',
      NO_WEBSITE: 'No websites added yet.',
      SELECTED: 'Selected',
      POSTED_STATUS_SUCCESS: 'Posted status changed successfully!',
      POSTED_STATUS_ERROR: 'Failed to update posted status!',
      SELECT_AREA: 'Select Area',
      ENTER_LOCAL: 'Enter Local',
      SELECT_FROM_PREFECTURES_LIST: 'Select from Prefectures List',
      INPUT_MANUALLY: 'Input manually',
      SELECT_LOCATION: 'Select Location',
      SELECT_PREFECTURE: 'Select Prefecture',
      SELECT_CITY: 'Select City',
      SELECT_PREFECTURE_FIRST: 'Select Prefecture first',
      SELECT_STATION: 'Select Station',
      SELECT_CITY_FIRST: 'Select City first',
      'DELETING...': 'Deleting...',
      DELETING: 'Deleting',
      DELETE: 'Delete',
      DELETE_DUPLICATE_RECORD: 'Delete Duplicate Record',
      DELETE_DUPLICATE_CONFIRMATION:
        'Are you sure you want to delete this duplicate record? This action cannot be undone.',
      DELETE_DUPLICATES_CONFIRMATION:
        'Are you sure you want to delete the selected duplicate records? This action cannot be undone.',
      DELETE_SELECTED_DUPLICATES: 'Delete Selected Duplicates',
      DUPLICATE_LIST_FILTER: 'Duplicate List Filter',
      DUPLICATE_LIST_ALERT: 'Duplicate records exist. Click "Duplicate List Filter" to display duplicate rows.',
      PREVIOUS: 'Previous',
      NEXT: 'Next',
      NO_TEMPLATES: 'No templates saved yet.',
      SAVED_TEMPLATES: 'Saved Templates',
      UPDATE_TEMPLATE: 'Update Template',
      SAVE_TEMPLATE: 'Save Template',
      GENERATE_KEYWORDS: 'Generate Keywords',
      GENERATE_WEBSITE_LIST: 'Generate a website list',
      REGISTRATION_INFO_TITLE: "Let's Get Started!",
      REGISTRATION_INFO_HEADLINE: "Let's generate article keywords and a backlink website list!",
      REGISTRATION_INFO_STEP_1:
        'To generate them, please press the "Generate Keywords" or "Generate Website List" buttons on the same screen.',
      REGISTRATION_INFO_STEP_2: 'Also, generating them will consume credits.',
      REGISTRATION_INFO_STEP_3:
        'You can press "Generate Keywords" or "Generate Website List" at any timing you prefer.',
      REGISTRATION_INFO_MESSAGE:
        'Let\'s generate article keywords and a backlink website list!\nTo generate them, please press the "Generate Keywords" or "Generate Website List" buttons on the same screen.\nAlso, generating them will consume credits.',
      CREDIT_CONFIRM_TITLE: 'Credit Consumption',
      CREDIT_CONFIRM_MESSAGE: 'Do you want to consume credits to generate the list?',
      DISPATCH_SUCCESS: 'Job dispatched successfully!',
      DISPATCH_FAILED: 'Failed to dispatch. Please try again.',
      RETRY_DISPATCHED: 'Retry dispatched successfully!',
      RETRY_FAILED: 'Failed to retry. Please try again.',
      KEYWORD_COUNT: 'Number of Keywords',
      KEYWORD_COUNT_LABEL: '{{count}} keywords requested',
      KEYWORD_COUNT_OPTION: '{{count}} keywords',
      ESTIMATED_CREDIT_CONSUMPTION: '{{count}} Keywords : {{total}} credits will be consumed',
      CREDIT_CONSUMPTION_SUMMARY: '{{count}} {{word}} : {{total}} credits will be consumed',
      SELECT_KEYWORD_COUNT_HINT: 'Select the number of keywords to generate',
      CREDIT_PREVIEW: 'Credit Preview',
      CLICK_TO_SELECT: 'Click to select this option',
      ADD_MORE_KEYWORD_LIST: 'Add More Keyword List',
      ADD_MORE_KEYWORD_LIST_DESC: 'Select additional keywords to add to {{keyword}}',
      ADD_MORE_WARNING_MAIN:
        'This will run the full keyword generation pipeline again from acquisition. Existing keywords will be preserved and new keywords will be fetched from the next page.',
      ADD_MORE_WARNING_SUB: 'This will re-run the suggestion pipeline. Existing keywords will be preserved.',
      ADD_MORE_ESTIMATED_CREDIT: 'Additional {{count}} keywords will consume approximately {{credits}} credits',
      LOAD_MORE: 'Load More',
      ADD_MORE: '+ Add',
      ADD_MORE_SUCCESS: '{{count}} additional keywords have been queued for generation',
      ADD_MORE_FAILED: 'Failed to add more keywords. Please try again.',
      SERVICE_NOT_AVAILABLE: 'Service not available',
      LOCAL_AREA_SETTINGS: 'Local Area Settings',
      AREA_CONFIGURATION: 'Area Configuration',
      AREA_CONFIGURATION_DESC: 'Configure local area settings for this keyword',
      LOADING_AREA_SETTINGS: 'Loading area settings...',
      LOCATION_BASED_SETTINGS: 'Location Based Settings',
      PREFECTURE_SETTINGS: 'Prefecture Settings',
      CITY_SETTINGS: 'City Settings',
      STATION_SETTINGS: 'Station Settings',
      REGISTER_PREFECTURES: 'Register Prefectures',
      SELECT_PREFECTURES_TO_REGISTER: 'Select the prefectures you want to register',
      VIEW_CITIES: 'View cities',
      ADD_CITY: 'Add city',
      ADD_CITIES: 'Add Cities',
      VIEW_STATIONS: 'View stations',
      ADD_STATION: 'Add station',
      ADD_STATIONS: 'Add Stations',
      SELECTED_PREFECTURE: 'Selected Prefecture',
      SELECTED_CITY: 'Selected City',
      REGISTERED_CITIES: 'Registered Cities',
      REGISTERED_STATIONS: 'Registered Stations',

      //Credit Management
      PURCHASE_CREDITS: 'Purchase Credits',
      CREDIT_USAGE: 'Credit Usage',
      PURCHASE_HISTORY: 'Purchase History',
      DEBITED_ON: 'Debited On',
      SERVICE: 'Service',
      REMAINING_CREDIT: 'Remaining Credit',
      CONSUMED_CREDIT: 'Consumed Credit',
      PREVIOUS_CREDIT: 'Previous Credit',
      CATEGORY: 'Category',
      OPERATION_TYPE: 'Operation Type',
      ARTICLE_KEYWORD: 'Article Keyword',
      TOTAL_CREDITS: 'Total Credits',
      PURCHASED_DATE: 'Date',
      PURCHASED_CREDITS: 'Purchased Credits',
      MONTHLY_CREDITS: 'Monthly Credits',
      CURRENT_REMAINING_CREDITS: 'Current Remaining Credits',
      SELECT_CREDITS: 'Select Credits to Purchase',
      TOTAL_COST: 'Total Cost',
      CUSTOM_AMOUNT: 'Custom Amount',
      CREDITS_SELECTED: 'Credits Selected',
      CONFIRM_PURCHASE: 'Confirm Purchase',
      SECURE_PAYMENT: 'Secure Payment',
      INSTANT_DELIVERY: 'Instant Delivery',
      CONGRATULATIONS: 'Congratulations',
      PURCHASE_SUCCESSFUL: 'Purchase Successful!',
      SUCCESSFULLY_PURCHASED: 'You have successfully purchased',
      CREDITS: 'credits',
      ENJOY_BENEFITS: 'Enjoy Your Benefits',
      CREDITS_READY_FOR_USE: 'Your credits are ready to use for articles and services',
      NEW_BALANCE: 'New Balance',
      START_USING_CREDITS: 'Start Using Credits',
      ENTER_CUSTOM_AMOUNT: 'Enter custom amount',
      MINIMUM: 'Minimum',
      INCREMENTS_OF: 'Increments of',
      RECURRING: 'Recurring',
      ONE_TIME: 'One-time',
      PURCHASE_CREDITS_DESC: 'Add more credits to your account to continue using our services',
      AVAILABLE_CREDITS: '利用可能クレジット',
      USED_CREDITS: 'Used Credits',
      NO_CONSUMPTION_HISTORY: 'No Consumption History',
      NO_CONSUMPTION_HISTORY_DESC:
        "You haven't used any credits yet. Start using services to see your consumption history here.",
      NO_PURCHASE_HISTORY: 'No Purchase History',
      NO_PURCHASE_HISTORY_DESC: "You haven't made any credit purchases yet. Purchase credits to get started.",
      MAKE_FIRST_PURCHASE: 'Make your first purchase',
      HOW_CREDITS_WORK: 'How Credits Work',
      REVIEW_YOUR_ORDER: 'Please review your order',
      PURCHASE_SUMMARY: 'Purchase Summary',
      CREDITS_TO_PURCHASE: 'Credits to Purchase',
      CURRENT_BALANCE: 'Current Balance',
      IMPORTANT_NOTICE: 'Important Notice',
      PURCHASE_CONFIRMATION_NOTE:
        'This action will charge your payment method immediately. Credits will be added to your account instantly.',
      BACK: 'Back',
      CONFIRM_AND_PAY: 'Confirm & Pay',
      SECURE_PAYMENT_GUARANTEED: 'Secure payment guaranteed',
      CONTINUE_TO_PAYMENT: 'Continue to Payment',
      NO_HIDDEN_FEES: 'No hidden fees',
      EMAIL_RECEIPT: 'Email receipt sent',
      CREDITS_PRICE_HINT: '{{price}} per {{credits}} credits',
      OVERALL_BALANCE: 'Overall balance',
      RENEWED_MONTHLY: 'Renewed monthly',
      ONE_TIME_PURCHASE: 'One-time purchase',

      // Credit Instructions
      CREDIT_SYSTEM_TITLE: 'Credit System Guide',
      CREDIT_SYSTEM_SUBTITLE: 'How credits are allocated, consumed, and managed',
      LAST_UPDATED: 'Last updated',

      RULE_1_TITLE: 'Monthly Allocation',
      RULE_1_DESC: 'A fixed number of credits is allocated to each location at the beginning of every month.',

      RULE_2_TITLE: 'No Monthly Rollover',
      RULE_2_DESC: 'Monthly allocated credits do not carry over to the following month.',

      RULE_3_TITLE: 'Additional Purchases',
      RULE_3_DESC: 'Additional credits can be purchased at any time.',

      RULE_4_TITLE: 'Purchased Credits Rollover',
      RULE_4_DESC: 'Purchased credits do carry over to the next month.',

      RULE_5_TITLE: 'Consumption Priority',
      RULE_5_SUBTITLE: 'Monthly credits are used first',
      RULE_5_DESC: 'Credit consumption priority is #1 (monthly) > #2 (purchased).',

      PRIORITY_AND_EXAMPLE: 'Priority & Example',

      PRIORITY_STEP_1_TITLE: 'Monthly Credits First',
      PRIORITY_STEP_1_DESC: 'System uses monthly allocated credits first',

      PRIORITY_STEP_2_TITLE: 'Purchased Credits Second',
      PRIORITY_STEP_2_DESC: 'Purchased credits are used only after monthly credits are exhausted',

      EXAMPLE_TITLE: 'Example: Monthly Reset',
      MAY_31ST: 'May 31st (End of Month)',
      JUNE_1ST: 'June 1st (New Month)',
      MONTH_RESET: 'Monthly Reset',

      FAQ_TITLE: 'Frequently Asked Questions',
      FAQ_1_Q: 'When do monthly credits reset?',
      FAQ_1_A: 'Monthly credits reset at 00:00 UTC on the first day of each month.',
      FAQ_2_Q: 'Can credits be transferred between locations?',
      FAQ_2_A: 'No, credits are specific to each location and cannot be transferred.',
      FAQ_3_Q: 'When should I purchase additional credits?',
      FAQ_3_A: 'Purchase additional credits when your remaining balance is low or when you expect higher usage.',
      FAQ_4_Q: 'What happens if I run out of credits?',
      FAQ_4_A:
        "Services requiring credits will be paused until you purchase more or receive the next month's allocation.",

      NEED_HELP: 'Need assistance with your credits?',
      STEP: 'Step',
      RULE: 'Rule',

      //My Website
      YOUR_WEBSITE: 'Your Website',
      MY_WEBSITE_MISSING_FOR_THIS_LOCATION: 'My website is missing for this location.',
      'THIS_LOCATION_ALREADY_HAS_WEBSITE_REGISTERED.PLEASE_SELECT_ANOTHER_LOCATION':
        'This location already has a website registered. Please select a different location.',
      CONFIRM_DELETE: 'Confirm Delete',
      ARE_YOU_SURE_DELETE_WEBSITE:
        'Are you sure you want to delete this website? Deleting My Website Will Also Delete Registered Wordpress Credentials & Integrations',
      CANCEL: 'Cancel',
      DONE: 'Done',
      CONFIRM: 'Confirm',
      WEBSITE_OPTIONS: 'Website Options',
      MY_WEBSITES_SUBTITLE: 'Manage your website registration and connect Google Search Console.',
      LOCATION_LABEL: 'Location',
      MANUAL_PLUS_GSC: 'Manual + GSC',
      QUICK_ADD: 'Quick Add',
      RECOMMENDED: 'Recommended',
      WEBSITE_COUNT_LABEL: '{{count}} Website{{plural}}',
      MANUAL_ENTRY: 'Manual Entry',
      ADD_YOUR_WEBSITE_URL: 'Add your website URL manually',
      GOOGLE_SEARCH_CONSOLE: 'Google Search Console',
      CONNECT_GSC_MESSAGE: 'Connect and import your verified websites from Google Search Console',
      GSC_LINKED: 'Google Search Console Account Status Linked',
      ADD_MY_WEBSITE: 'Add My Website',
      CONFIRM_SUBMISSION: 'Confirm Your Submission',
      ARE_YOU_SURE_YOU_WANT_TO_ADD_THIS_WEBSITE: 'Are you sure you want to add this website?',
      NO: 'No',
      YES: 'Yes',
      GSC_ACCOUNT_STATUS: 'Google Search Console Account Status',
      LINKED: 'Linked',
      CONNECTING: 'Connecting',
      CONNECT_TO_GSC_ACCOUNT: 'Connect to Google Search Console Account',
      PROCESSING_GSC_AUTH: 'Processing GSC authentication',
      PROCESSING: 'Processing...',
      CONTINUE: 'Continue',
      CONFIRM_WEBSITE_ADDITION: 'Confirm Website Addition',
      SELECT_YOUR_WEBSITE: 'Select your website',
      FOUND_SITES_MESSAGE:
        'Found {{count}} site{{plural}} in your Google Search Console account. Please select which website to add; only one can be active.',

      //Login
      FORGOT_PASSWORD: 'Forgot Password?',

      EMAIL_ID: 'Email ID',
      PASSWORD: 'Password',
      EMAIL_ID_REQUIRED: 'Email ID is required!',
      PASSWORD_REQUIRED: 'Password is required!',
      INVALID_EMAIL_OR_PASSWORD: 'Invalid email or password. Please try again.',

      //Forgot Password
      FORGOT_PASSWORD_TITLE: 'Forgot Password',
      PASSWORD_RESET: 'We will send password reset link on your email Id',
      LINK_SENT: 'Link Sent',
      SEND_RESET_LINK: 'Send Reset Link',
      ALREADY_HAVE_AN_ACCOUNT: 'Already have an Account?  ',

      ARTICLE_CHARACTER_COUNT: 'Article Character Count',
      SELECTED_CHARACTER_COUNT: 'Selected Character Count',

      RESET_PASSWORD: 'Reset Password',
      CONFIRM_NEW_PASSWORD: 'Confirm New Password',
      NEW_PASSWORD: 'New Password',
      CONFIRM_PASSWORD_REQUIRED: 'Confirm Password Required!',
      CHECK_YOUR_EMAIL_TO_RESET_PASSWORD: 'Check your email to reset password',

      STATUS_CHANGE_SUCCESS: 'Status has been changed.',
      STATUS_CHANGE_FAILED: 'The status change failed.',
      STATUS_ARTICLE_GENERATION: 'Status Article Generation',
      STATUS_BUILD_BACKLINK: 'Status Build Backlink',
      READY_FOR_ARTICLE_GENERATION: 'Ready For Article Generation',
      IN_PREPARATION: 'In Preparation',
      READY_FOR_BUILD_BACKLINK: 'Ready For Build Backlink',
      USER_CAN_REGISTER_1_MAIN_KEYWORD_PER_LOCATION: 'User can register 1 main keyword per location',
      CREATE_ARTICLE: 'Create Article',
      TARGET_KW: 'Target Keyword',
      ARTICLE_LIMIT_CHOICE: 'Select the number of words for the article you wish to create.',
      CONFIRM_ARTICLE_GENERATION: 'I Understand the precaution and want to create and article',
      CONFIRM_GENERATION: 'Are you sure you want to generate the article?',
      ARTICLE_GENERATION_DISCLAIMER_1:
        'When you create an article, 100 credits will be consumed. \nPlease see here for details.',
      ARTICLE_GENERATION_DISCLAIMER_1_WITH_FIRST_HAND:
        'When you create an article, 180 credits will be consumed. \nPlease see here for details.',
      ARTICLE_GENERATION_DISCLAIMER_2:
        'Articles are also automatically generated by AI. \nPlease read the content of the article carefully.',
      ARTICLE_GENERATION_DISCLAIMER_3:
        'When you retry article generation, small amount of credits will be consumed again.',
      FIRST_HAND_INFO_ADDITION: 'Add first-hand information',
      FIRST_HAND_INFO_DISCLAIMER:
        'Article generation costs 100 credits, and adding first-hand information will consume an additional 80 credits. In total, 100 + 80 = 180 credits will be consumed.',
      FIRST_HAND_INFO_DISCLAIMER_DETAILS:
        'Adding first-hand information consumes 80 credits.',
      FIRST_HAND_INFO_TOOLTIP:
        'Adding first-hand information in articles will consume an additional 80 credits.',
      FIRST_HAND_INFO_STATUS_PROCESSING: 'First-hand information being added',
      FIRST_HAND_INFO_APPLIED: 'First-hand information added',
      FIRST_HAND_INFO_ADD_BUTTON: 'Add first-hand information',
      FIRST_HAND_INFO_RETRY_BUTTON: 'Retry first-hand information',
      FIRST_HAND_INFO_CONFIRM:
        'Adding first-hand information consumes 80 credits. Proceed?',
      FIRST_HAND_INFO_QUEUED: 'First-hand information addition has been queued',
      FIRST_HAND_INFO_REQUEST_FAILED: 'Failed to request first-hand information addition',
      FIRST_HAND_INFO_OPERATION: 'First-hand information addition',
      ARTICLE_RETRY_SUCCESS: 'Article generation retried successfully',
      ARTICLE_RETRY_FAILED: 'Failed to retry article generation',
      NO_KEYWORDS_FOUND: 'No keywords found',
      RETRY_ARTICLE_GENERATION: 'Retry Article Generation',
      TRY_ADJUSTING_YOUR_SEARCH: 'Try adjusting your search',
      KEYWORD_DIFFICULTY: 'KD',
      SEARCH_VOLUME: 'SV',
      SEARCH_VOLUME_FILTER: 'Search Volume',
      TREASURE_KEYWORD_RATING: 'Treasure KW',
      TREASURE_KEYWORD_FILTER: 'Treasure Keyword',
      EXCLUDED_KEYWORDS: 'Excluded Keywords',
      SEARCH_RANKING: 'Search Ranking',
      APPLY: 'Apply',
      CLEAR: 'Clear',
      TREASURE_KEYWORD_NOT_STARTED: 'Not Started',
      TREASURE_KEYWORD_IN_PROGRESS: 'In Progress',
      TREASURE_KEYWORD_FAILED: 'Failed',
      TREASURE_KEYWORD_NOT_TREASURE: '-',
      KEYWORD_PROCESSING_MAIN_KEYWORD: 'Main Keyword',
      KEYWORD_PROCESSING_SUB_KEYWORD: 'Sub Keyword',
      KEYWORD_PROCESSING_TREASURE_KEYWORD: 'Treasure keyword',
      KEYWORD_PROCESSING_CV_DETERMINATION: 'CV determination',
      KEYWORD_PROCESSING_KW_RELEVANCE: 'Relevance',
      KEYWORD_PROCESSING_GOOGLE_SERP: 'Google SERP',
      KEYWORD_RELEVANCE: 'Relevance',
      KEYWORD_RELEVANCE_HIGH: 'High',
      KEYWORD_RELEVANCE_LOW: 'Low',
      KEYWORD_RELEVANCE_FILTER_HIGH: 'High relevance',
      KEYWORD_RELEVANCE_FILTER_LOW: 'Low relevance',
      KEYWORD_TYPE: 'KW Type',
      POSITION: 'Position',
      CONVERSION_NEAR_SCORE: 'CV',
      CV_SCORE_FILTER: 'CV Score',
      ANY_CV_SCORE: 'Any CV',
      CV_RANGE_7_10: '7-10',
      CV_RANGE_GTE_5: '5 or more',
      CV_RANGE_LT_5: '5 or less',
      CV_CUSTOM: 'Custom range',
      AI_OVERVIEW: 'AI Overview',
      RELATED_QUESTIONS: 'Related Questions',
      MEO_RESULTS: 'MEO',
      SERP_FEATURE_PRESENT: 'Present',
      SERP_FEATURE_NOT_FOUND: 'Not Found',
      SERP_FEATURE_LOAD_FAILED: 'Failed to load SERP details.',
      SERP_FEATURE_UNKNOWN: 'Unknown',
      QUESTIONS_SHORT: 'Qs',
      PLACES_SHORT: 'Places',
      AI_OVERVIEW_SUMMARY_UNAVAILABLE: 'Summary not available',
      MEO_DATA_UNAVAILABLE: 'No places found',
      LIST_OF_CREATED_ARTICLES: 'List of Created Articles',
      FILTERS: 'Filters',
      CLEAR_KEYWORD_DIFFICULTY_FILTER: 'Clear Keyword Difficulty Filter',
      ENTER_KEYWORDS_TO_EXCLUDE_COMMA_OR_LINE_SEPARATED: 'Enter keywords to exclude (comma or line separated)',
      USE_BRACKETS_FOR_EXTACT_MATCHES: 'Use [brackets] for exact matches',
      SEARCH: 'SEARCH',
      ANY_KEYWORD_DIFFICULTY: 'Any Difficulty',
      ANY_SEARCH_VOLUME: 'Any Search Volume',
      ANY_TREASURE_KEYWORD_RATING: 'Any Treasure Keyword Rating',
      ADD_EXCLUSION: 'Add Exclusion',
      KEYWORD_LIST: 'Keyword List',
      LOCAL_KEYWORD_LIST: 'Local Keyword List',
      SHOWING: 'Showing',
      TO: 'to',
      OF: 'of',
      RESULTS: 'results',
      MANUAL_FORM_SUBMISSION: 'Manual Form Submission',
      MANUAL_FORM_IFRAME: 'Manual Form Iframe',
      IFRAME: 'Iframe',
      GO_BACK: 'Go Back',
      WOULD_YOU_LIKE_TO_PROCEED: 'Would you like to proceed with creating the article?',

      // CMS
      USE_THIS_SETTING: 'Use this setting',
      USE_THIS_SETTING_TOOLTIP: 'Check to enable this CMS integration for the current location.',
      CMS_INTEGRATION_MODAL: 'Enabling CMS integration',
      ENABLE_CMS_CONFIRM_WP: 'Enabling WordPress will disable other CMS integrations (IPP/AST). Continue?',
      ENABLE_CMS_CONFIRM_IPP: 'Enabling IPP will disable other CMS integrations (WordPress/AST). Continue?',
      ENABLE_CMS_CONFIRM_AST: 'Enabling AST will disable other CMS integrations (WordPress/IPP). Continue?',
      ENABLE_CMS_CONFIRM_WP_RELAY: 'Enabling WP Relay will disable other CMS integrations. Continue?',
      CONFIRM_CMS: 'Continue',
      CMS_ENABLED_SUCCESS: 'CMS integration enabled successfully',
      CMS_DISABLED_SUCCESS: 'CMS integration disabled successfully',
      CMS_TOGGLE_FAILED: 'Failed to update CMS integration status',
      CMS_INTEGRATION: 'CMS Integration',
      CMS_INTEGRATION_DISABLED_TOOLTIP:
        'Please enable a CMS integration (WordPress, IPP, AST, or WP Relay) in settings first.',
      BRIDGEBOOKS_INTEGRATION: 'BridgeBooks Integration',
      BRIDGEBOOKS_INTEGRATION_TOOLTIP:
        'If you would like to post an article to GBP at the same time as posting to the CMS, please press the integration button.',
      APPLY_TO_BRIDGEBOOKS: 'Apply the same integration settings to BridgeBooks',
      BBS_OVERWRITE_WARNING_TITLE: 'Overwrite BridgeBooks Settings',
      BBS_OVERWRITE_WARNING_MESSAGE:
        'Schedule settings are already configured on the BridgeBooks screen. Applying these settings will overwrite the existing BridgeBooks settings. Do you want to proceed?',
      BBS_LINKAGE_OFF_WARNING_TITLE: 'Deactivate BridgeBooks Integration',
      BBS_LINKAGE_OFF_WARNING_MESSAGE:
        'Since the auto-posting setting is OFF, the BridgeBooks integration will also be turned OFF. Do you want to proceed?',
      CMS_INTEGRATION: 'CMS Integration',
      ARTICLE_MANAGEMENT_SETTINGS: 'Article Management Settings',
      BBS_INTEGRATION: 'BBS Integration',
      NO_WEBSITES_FOUND_FOR_LOCATION: 'No websites found for this location',
      WORDPRESS_ACCOUNT: 'WordPress Account',
      WP_CREDS_REGISTERED: 'WordPress credentials registered successfully',
      ENTER_WORDPRESS_USERNAME: 'Enter WordPress Username',
      ADMIN: 'admin',
      ENTER_APPLICATION_PASSWORD: 'Enter Application Password',
      XXX_YYY_ZZZ_AAA_BBB: 'XXX-YYY-ZZZ-AAA-BBB',
      REGISTER_CREDENTIALS: 'Register Credentials',
      INTEGRATIONS: 'Auto Post Settings',
      NEW_INTEGRATION: 'New Registration',
      Status: 'Status',
      ACTIVE: 'Active',
      INACTIVE: 'Inactive',
      Schedule: 'Schedule',
      ACTIVATE: 'Activate',
      EDIT: 'Edit',
      No_integrations_found: 'No integrations found',
      CREATE_YOUR_FIRST_INTEGRATION: 'Create your first integration',
      AUTO_INTEGRATION: 'Auto Integration',
      REGISTER_WP_CREDS_FIRST: 'Register WordPress credentials first',

      // Automatic Article Creation (Exclusive keys)
      AUTO_ARTICLE_INTEGRATIONS: 'Auto Article Creation Settings',
      NEW_AUTO_ARTICLE_INTEGRATION: '+ New Registration',
      NO_AUTO_ARTICLE_INTEGRATIONS_FOUND: 'No integrations found',
      CREATE_YOUR_FIRST_AUTO_ARTICLE_INTEGRATION: 'Create your first integration',
      AUTO_ARTICLE_SEO_ARTICLE: 'SEO Article',
      AUTO_ARTICLE_AUTO_INTEGRATION: 'Auto Article Creation',
      AUTO_ARTICLE_MAIN_KEYWORD: 'Main Keyword',
      AUTO_ARTICLE_SCHEDULE: 'Schedule',
      AUTO_ARTICLE_EVERY_DAY: 'Every day',
      AUTO_ARTICLE_EVERY_WEEK: 'Every week',
      AUTO_ARTICLE_EVERY_MONTH: 'Every Month',
      AUTO_ARTICLE_DAILY: 'Daily',
      AUTO_ARTICLE_WEEKLY: 'Weekly',
      AUTO_ARTICLE_MONTHLY: 'Monthly',
      AUTO_ARTICLE_AT: 'at',
      AUTO_ARTICLE_TIME: 'Time',
      AUTO_ARTICLE_MAX_ARTICLES_PER_SCHEDULE: 'Max articles per schedule',
      AUTO_ARTICLE_24H_WARNING:
        'Article generation completes within 24 hours of the scheduled creation time. If same-day automatic CMS integration is reserved, generation may not finish before the integration time.',
      SCHEDULE_ONCE_PER_DAY_TITLE: 'This schedule runs only once per day.',
      SCHEDULE_AFTER_RUN_NOTE:
        'Setting changes made after the job has started, meaning after it has run at the configured schedule time, will take effect from the next day.',
      SCHEDULE_BEFORE_RUN_NOTE:
        'Setting changes made before the job has started, meaning before the configured schedule time has been reached and the job has run, will take effect from the same day. (Changes must be set for a future date and time.)',
      AUTO_ARTICLE_SORT_ORDER: 'Article Sort Order',
      AUTO_ARTICLE_RELEVANCE_ORDER: 'Relevance Order',
      AUTO_ARTICLE_RELEVANCE_NOT_SPECIFIED: 'Not specified',
      AUTO_ARTICLE_RELEVANCE_HIGH_PRIORITY_EXCEPT_TREASURE: 'High priority (Treasure KWs as exception)',
      AUTO_ARTICLE_RELEVANCE_HIGH_PRIORITY_ALL: 'High priority',
      AUTO_ARTICLE_RELEVANCE_HIGH_ONLY_EXCEPT_TREASURE: 'High only (Treasure KWs as exception)',
      AUTO_ARTICLE_RELEVANCE_HIGH_ONLY_ALL: 'High only',
      AUTO_ARTICLE_RELEVANCE_ORDER_TOOLTIP:
        'Not specified: Write from the top in the default sort order of the list screen\nHigh priority (Treasure KWs as exception): Treasure KWs → Non-treasure KWs (High → Low → Not judged)\nHigh priority: All KWs in the order High → Low → Not judged\nHigh only (Treasure KWs as exception): Treasure KWs → Only "High" among non-treasure KWs\nHigh only: Write only KWs with relevance "High"',
      AUTO_ARTICLE_RELEVANCE_HIGH_ONLY_NOTICE:
        '*Applies to keywords that have a relevance judgment.\n  If there are only keywords without a relevance judgment (unjudged or not applicable), selecting "High only" will not generate articles.',
      AUTO_ARTICLE_AUTHOR_INFORMATION: 'Author Information',
      AUTO_ARTICLE_DO_NOT_USE: 'Do not use',
      AUTO_ARTICLE_USE: 'Use',
      AUTO_ARTICLE_LIMIT_CHOICE: 'Select the number of words for the article you wish to create.',
      AUTO_ARTICLE_8000_CHARACTERS: '8,000 characters',
      AUTO_ARTICLE_LIMITLESS: 'Not specified',
      ARTICLE_SORT_RECOMMENDED: 'Traffic priority order',
      ARTICLE_SORT_CV_SCORE: 'CV priority order',
      TREASURE_KW_PRIORITY: 'Traffic priority order',
      CV_PRIORITY: 'CV priority order',
      PRIORITY_SETTING_UPDATED: 'Priority setting updated successfully',
      ARTICLE_SORT_ORDER_SELECTION: 'Select article generation order',
      AUTO_ARTICLE_LANGUAGE: 'Language',
      AUTO_ARTICLE_JAPANESE: 'Japanese',
      AUTO_ARTICLE_ENGLISH: 'English',
      AUTO_ARTICLE_OTHER_COMPANY_BRAND_INFO: 'Other company brand information',
      AUTO_ARTICLE_INCLUDE: 'Include',
      AUTO_ARTICLE_EXCLUDE: 'Exclude',
      AUTO_ARTICLE_MANUAL_PROMPT_ADDITION: 'Manual prompt addition',
      AUTO_ARTICLE_ENTER_CUSTOM_PROMPT: 'Enter custom prompt text if needed...',
      AUTO_ARTICLE_CANCEL: 'Cancel',
      AUTO_ARTICLE_UPDATE: 'Update',
      AUTO_ARTICLE_SAVE: 'Save',
      AUTO_ARTICLE_ACTIVE: 'Active',
      AUTO_ARTICLE_INACTIVE: 'Inactive',
      AUTO_ARTICLE_INSUFFICIENT_CREDIT: 'Insufficient credit',
      AUTO_ARTICLE_SAVE_CREDIT_WARNING:
        'Please note that articles will not be generated if there are insufficient credits.',
      AUTO_ARTICLE_MAX_ARTICLES: 'Max articles',
      AUTO_ARTICLE_EDIT: 'Edit',
      AUTO_ARTICLE_DELETE: 'Delete',
      AUTO_ARTICLE_SELECT_DAYS: 'Select days',
      AUTO_ARTICLE_SELECT_MONTH_DAY: 'Select day of the month',
      AUTO_ARTICLE_DAY_OF_MONTH: 'Day {{day}}',
      AUTO_ARTICLE_MONDAY: 'Monday',
      AUTO_ARTICLE_TUESDAY: 'Tuesday',
      AUTO_ARTICLE_WEDNESDAY: 'Wednesday',
      AUTO_ARTICLE_THURSDAY: 'Thursday',
      AUTO_ARTICLE_FRIDAY: 'Friday',
      AUTO_ARTICLE_SATURDAY: 'Saturday',
      AUTO_ARTICLE_SUNDAY: 'Sunday',
      AUTO_ARTICLE_DONE: 'Done',
      AUTO_ARTICLE_CLEAR: 'Clear',
      AUTO_ARTICLE_HOUR_TEXT: 'Hour',
      AUTO_ARTICLE_MINUTE_TEXT: 'Minute',
      AUTO_ARTICLE_BATCH_CAUTION:
        'Article generation completes within {{hours}} hours of the scheduled creation time. If same-day automatic CMS integration is reserved, generation may not finish before the integration time.',
      WP_DELETE_CONFIRMATION: 'Delete Integration',
      ARE_YOU_SURE_DELETE_WP:
        'Are you sure you want to delete this WordPress integration? This action cannot be undone.',
      AUTO_ARTICLE_FAILED_TO_LOAD_SETTINGS: 'Failed to load settings',
      AUTO_ARTICLE_SETTINGS_DELETED: 'Auto-generate settings deleted successfully',
      AUTO_ARTICLE_FAILED_TO_DELETE_SETTINGS: 'Failed to delete settings',
      AUTO_ARTICLE_MAX_ARTICLES_INVALID: 'Max articles per schedule must be at least 1',
      AUTO_ARTICLE_AUTHOR_INFO_REQUIRED: 'Please select whether to use Author Information',
      AUTO_ARTICLE_SETTINGS_SAVED: 'Auto-generate settings saved successfully',
      AUTO_ARTICLE_FAILED_TO_SAVE_SETTINGS: 'Failed to save settings',
      INTEGRATION_METHOD: 'Integration Method',
      DRAFT: 'Draft',
      PUBLISH: 'Publish',
      SCHEDULE: 'Schedule',
      EVERY_DAY: 'Every day',
      EVERY_WEEK: 'Every week',
      SELECT_DAYS: 'Select days',
      Monday: 'Monday',
      Tuesday: 'Tuesday',
      Wednesday: 'Wednesday',
      Thursday: 'Thursday',
      Friday: 'Friday',
      Saturday: 'Saturday',
      Sunday: 'Sunday',
      TIME: 'Time',
      MAX_ARTICLES_PER_SCHEDULE: 'Max articles per schedule',
      SELECT_ARTICLE_STATUS: 'Select article status',
      SELECT_STATUS: 'Select status',
      Completed: 'Completed',
      Confirmed: 'Confirmed',
      Done: 'Done',
      UPDATE: 'Update',
      SAVE: 'Save',
      POST_TO_WORDPRESS: 'Post to WordPress',
      SELECT_POST_TYPE: 'Select post type',
      SELECT_WHICH_POST_TYPE: 'Select which post type to publish to',
      SELECT_INTEGRATION_METHOD: 'Select how you want to publish',
      POST_TIMING: 'Post Timing',
      SELECT_TIME: 'Select when to post this article',
      POST_NOW: 'Post Now',
      SET_DATE_AND_TIME: 'Set Date and Time',
      SAVED_WP_INTEGRATION_SETTINGS: 'Successfully Stored Wordpress Integration settings',
      INTEGRATION_ACTIVATED_SUCCESSFULLY: 'Integration activated successfully',
      FAILED_TO_ACTIVATE_INTEGRATION: 'Failed to activate integration',
      INTEGRATION_DELETED_SUCCESSFULLY: 'Integration deleted successfully',
      FAILED_TO_DELETE_INTEGRATION: 'Failed to delete integration',
      UPDATED_INTEGRATION: 'Integration updated successfully',
      FAILED_TO_UPDATE_INTEGRATION: 'Failed to update integration',
      PLEASE_REGISTER_WP_CREDS_FIRST: 'Please register WordPress credentials first',
      FAILED_TO_REGISTER_WP_CREDS: 'Invalid WordPress username or application password',
      FAILED_TO_LOAD_WORDPRESS_SETTINGS: 'Failed to load WordPress settings',
      FAILED_TO_LOAD_LOCATIONS: 'Failed to load locations',
      DAILY: 'Daily',
      WEEKLY: 'Weekly',
      MONTHLY: 'Monthly',
      SCHEDULE_AT: 'at',
      ENTER_IPP_DOMAIN: 'Enter IPP Domain',
      EXAMPLE_COM: 'example.com',
      HTTPS_EXAMPLE_COM: 'https://example.com',
      ENTER_AST_DOMAIN: 'Enter AST Domain',
      POST_TYPE: 'Post Type',
      NEW_POST_TYPE: 'New Post Type',
      PARENT_TYPE: 'Parent Type',
      CATEGORIES_IDS: 'Categories Ids',
      NOTE: 'Note',
      NEW_PARENT_TYPE: 'New Parent Type',
      NEW_CATEGORIES_IDS: 'New Categories IDs',
      UPDATE_PARENT_TYPE: 'Update Parent Type',
      UPDATE_CATEGORIES_IDS: 'Update Categories IDs',
      ADD_PARENT_TYPE: 'Add Parent Type',
      ADD_CATEGORIES_IDS: 'Add Categories IDs',
      ENTER_NOTE: 'Enter a note...',
      SUBMIT: 'Submit',
      UPDATE_CONFIRMATION: 'Update Confirmation',
      ARE_YOU_SURE_UPDATE: 'Are you sure you want to save these changes?',
      DELETE_CONFIRMATION: 'Delete Confirmation',
      ARE_YOU_SURE_DELETE: 'Are you sure you want to delete this item? This action cannot be undone.',
      ENTER_ID: 'Enter ID',
      ENTER_PASSWORD: 'Enter Password',
      CATEGORIES: 'Categories',
      TAG: 'Tag',
      NEW_CATEGORY: 'New Category',
      NEW_TAG: 'New Tag',
      CATEGORY_NAME: 'Category Name',
      NO_NAME: 'No Name',
      ALREADY_LINKED: 'Already Linked',
      PUBLISHED: 'Published',
      SCHEDULED: 'Scheduled',
      INTEGRATED: 'Integrated',
      NOT_LINKED: 'Not Linked',
      CODE_ARTICLE_ID: 'Code/Article_id',
      DIRECTORY_ID: 'Directory ID',
      DIRECTORY: 'Directory',
      SELECT_AST_TYPE: 'Select AST Type',
      USE_CODE_HINT: 'Use code for new AST/ Use Article Id for old AST',
      NEW_AST: 'New AST',
      OLD_AST: 'Old AST',
      TAG_NAME: 'Tag Name',
      ADD_TAG: 'Add Tag',
      UPDATE_TAG: 'Update Tag',
      CATEGORY_SET: 'Category Set',
      CATEGORY: 'Category',
      ARTICLE_ID: 'Article Id',
      CODE: 'Code',
      UPDATE_CATEGORY: 'Update Category',
      POST_TO_AST: 'Post to AST',
      POST_TO_NEW_AST: 'Post to New AST',
      POST_TO_OLD_AST: 'Post to Old AST',
      POST_TO_IPP: 'Post to IPP',
      IPP_INTEGRATION: 'IPP Integration',
      AST_INTEGRATION: 'AST Integration',
      WP_RELAY_INTEGRATION: 'WP Relay Integration',
      WP_RELAY_SETTINGS: 'WP Relay Settings',
      WP_RELAY_ACCOUNT_IDENTIFIER: 'Account Identifier',
      WP_RELAY_ACCOUNT_IDENTIFIER_PLACEHOLDER: 'admin',
      WP_RELAY_AUTH_URL: 'Auth Endpoint URL',
      WP_RELAY_AUTH_URL_PLACEHOLDER: 'https://example.com/cms-integration/auth/api/?key=...',
      WP_RELAY_AUTH_SAVED: 'WP Relay settings saved successfully',
      WP_RELAY_SETTINGS_DELETED: 'WP Relay settings deleted successfully',
      POST_TO_WP_RELAY: 'Post to WP Relay',
      REPLACE_URL: 'Replace URL',
      WP_RELAY_VERIFY_DISABLED_TOOLTIP: 'WP Relay cannot re-fetch post status or URL.',
      SELECT_CMS: 'Select CMS',
      NO_INTEGRATIONS_CONFIGURED: 'No integrations configured',
      IPP_AUTH_SAVED: 'IPP credentials saved successfully',
      FAILED_TO_SAVE_AUTH: 'Failed to save credentials',
      AST_AUTH_SAVED: 'AST credentials saved successfully',
      SETTING_SAVED: 'Setting saved successfully',
      FAILED_TO_SAVE_SETTING: 'Failed to save setting',
      SETTING_DELETED: 'Setting deleted successfully',
      FAILED_TO_DELETE_SETTING: 'Failed to delete setting',
      FAILED_TO_LOAD_CMS_SETTINGS: 'Failed to load CMS settings',
      ARTICLE_POSTED_SUCCESSFULLY: 'Article posted successfully',
      FAILED_TO_POST_ARTICLE: 'Failed to post article',
      AUTO_ARTICLE_GENERATE: 'Auto Article Creation',
      AUTO_GENERATE: 'Auto Article Creation',
      CSS_SETTINGS: 'CSS Settings',
      CSS_SETTINGS_INTEGRATION: 'CSS Settings',
      CSS_ENABLED: 'Enabled',
      CSS_DISABLED: 'Disabled',
      CSS_CONTENT_PLACEHOLDER:
        '/* Example */\nh2 { color: #333; }\np { line-height: 1.8; }\n.article-body img { max-width: 100%; }',
      CSS_SAVED: 'CSS settings saved successfully',
      FAILED_TO_SAVE_CSS: 'Failed to save CSS settings',
      FAILED_TO_LOAD_CSS: 'Failed to load CSS settings',
      EDIT_CSS: 'Edit CSS',
      SAVE_CSS: 'Save CSS',
      CSS_TOOLTIP:
        'Write valid CSS. When applied, selectors are scoped to the article wrapper (.article-content-wrapper) so styles never leak to the rest of the page. @import and @font-face are kept as-is.',
      CSS_COPY_HTML_LABEL: 'When copying in HTML format',
      CSS_COPY_HTML_TOOLTIP:
        'When ON, the active CSS is included when you copy the article as HTML from the article detail screen.',
      CSS_CMS_LABEL: 'When integrating articles',
      CSS_CMS_TOOLTIP:
        'When ON, the active CSS is included when articles are sent to WordPress, WP Relay, IPP, or AST. BBS is not affected.',
      CSS_ACTIVE_BADGE: 'Active',
      SET_AS_ACTIVE: 'Set as active',
      NEW_CSS: 'New CSS',
      DELETE_CSS: 'Delete',
      NO_CSS_YET: 'No CSS created yet',
      CSS_NAME_PLACEHOLDER: 'CSS name',
      CSS_ACTIVE_UPDATED: 'Active CSS updated',
      CSS_DELETED: 'CSS deleted',
      CSS_DELETE_CONFIRM: 'Delete this CSS? This cannot be undone.',
      CSS_ON: 'ON',
      CSS_OFF: 'OFF',
      CSS_DELIVERY_TITLE: 'Delivery channels',
      CSS_DELIVERY_DESCRIPTION: 'Choose where the active CSS profile should be applied.',
      CSS_EMPTY_TITLE: 'No CSS profiles yet',
      CSS_EMPTY_DESCRIPTION: 'Create a profile to style copied and integrated article content.',
      CSS_CREATE_FIRST: 'Create your first CSS',
      CSS_CREATE_FIRST_HINT: 'Create a CSS profile first to enable this channel.',
      CSS_LEGACY_COPY_ONLY: 'Legacy mode supports HTML copying only.',
      CSS_LEGACY_CMS_DISABLED: 'CMS integration is unavailable in legacy mode.',
      CSS_LEGACY_NOTICE: 'The API is using the legacy single-CSS format. You can edit the existing CSS and HTML-copy setting, but multiple profiles and CMS integration require the updated API.',
      CSS_CREATED: 'CSS profile created',
      CSS_NEW_PROFILE_NAME: 'New CSS Profile',
      CSS_PROFILES_TITLE: 'CSS profiles',
      CSS_PROFILES_DESCRIPTION: 'Save multiple designs and choose one active profile for delivery.',
      CSS_SAVED_PROFILES: 'Saved profiles',
      CSS_LINES: 'lines',
      CSS_UNNAMED: 'Unnamed CSS',
      CSS_PROFILE_ID: 'Profile',
      CSS_NAME_LABEL: 'Profile name',
      CSS_CONTENT_LABEL: 'CSS content',
      CSS_CHARACTERS: 'characters',
      CSS_UNSAVED_CHANGES: 'Unsaved changes',
      CSS_NO_UNSAVED_CHANGES: 'All changes saved',
      CSS_EDITOR_TITLE: 'CSS editor',
      CSS_EDITOR_SCOPE_HINT: 'Selectors are scoped to .article-content-wrapper when CSS is delivered. The active profile is used for Copy HTML and CMS integration according to the channel settings above.',
      CSS_DELETE_TITLE: 'Delete CSS profile?',
      CSS_DELETE_DESCRIPTION: 'This profile will be removed. If it is active, another saved profile will become active automatically.',
      COPY_CSS: 'Copy CSS',
      CSS_COPIED: 'CSS copied to clipboard',
      FAILED_TO_COPY_CSS: 'Failed to copy CSS',
      CSS_COPY_DISABLED_HINT: 'Create a CSS profile and enable a delivery channel to copy the active CSS.',
      CSS_TOGGLE_CONFIRM_TITLE: 'Confirm change?',
      CSS_TOGGLE_CONFIRM_DESCRIPTION:
        'Turn "{{channel}}" {{state}}? The active CSS profile will be delivered according to this setting.',

      // Structured Data Settings
      STRUCTURED_DATA: 'Structured Data',
      STRUCTURED_DATA_SETTINGS: 'Structured Data Settings',
      STRUCTURED_DATA_SETTINGS_TITLE: 'Structured Data Settings',
      STRUCTURED_DATA_DELIVERY_TITLE: 'Structured Data Delivery Settings',
      STRUCTURED_DATA_DELIVERY_DESC:
        'Enable automatic injection of structured data when copying HTML or publishing articles to this CMS.',
      STRUCTURED_DATA_MANAGEMENT_TITLE: 'Structured Data Management',
      STRUCTURED_DATA_MANAGEMENT_DESC:
        'Manage JSON-LD and structured data scripts for this website. Enabled profiles can be delivered automatically when copying HTML or publishing to CMS.',
      STRUCTURED_DATA_PROFILES: 'Structured Data Profiles',
      STRUCTURED_DATA_PROFILES_HINT: 'Select one active profile to enable for this location.',
      STRUCTURED_DATA_SAVED_PROFILES: 'Saved Profiles',
      STRUCTURED_DATA_ACTIVE_BADGE: 'Active',
      STRUCTURED_DATA_ACTIVE: 'Active',
      STRUCTURED_DATA_ON: 'ON',
      STRUCTURED_DATA_OFF: 'OFF',
      STRUCTURED_DATA_COPY_HTML_LABEL: 'Structured Data (When copying in HTML format)',
      STRUCTURED_DATA_COPY_HTML_TOOLTIP:
        'When ON, the active structured data script is included when you copy the article as HTML from the article detail screen.',
      STRUCTURED_DATA_CMS_LABEL: 'Structured Data (When integrating articles)',
      STRUCTURED_DATA_CMS_TOOLTIP:
        'When ON, the active structured data script is appended to the article content when sending to the CMS.',
      STRUCTURED_DATA_NO_ACTIVE_HINT:
        'No active structured data record found. Please create and enable a profile in the Structured Data tab to use these delivery toggles.',
      STRUCTURED_DATA_EMPTY_TITLE: 'No Structured Data Configured',
      STRUCTURED_DATA_EMPTY_DESC:
        'Generate structured data automatically from preset templates matching CMS requirements, or create a custom profile manually.',
      GENERATE_STRUCTURED_DATA: 'Generate Structured Data',
      GENERATE_FROM_TEMPLATE: 'Generate from Template',
      GENERATE_MODAL_SUBTITLE: 'Select a template format from CMS presets and configure parameters for this website.',
      SELECT_TEMPLATE_FORMAT: '1. Select Template Format',
      CONFIGURE_PARAMETERS: '2. Configure Dynamic Parameters',
      NEW_STRUCTURED_DATA: 'New Blank Record',
      NEW_STRUCTURED_DATA_NAME: 'New Structured Data',
      NEW_RECORD: 'New Record',
      COPY_SCRIPT: 'Copy Script',
      STRUCTURED_DATA_COPIED: 'Structured data script copied to clipboard',
      FAILED_TO_COPY_STRUCTURED_DATA: 'Failed to copy structured data',
      STRUCTURED_DATA_CREATED: 'Structured data record created',
      STRUCTURED_DATA_GENERATED: 'Structured data generated successfully',
      STRUCTURED_DATA_SAVED: 'Structured data saved successfully',
      STRUCTURED_DATA_ACTIVE_UPDATED: 'Active structured data record updated',
      STRUCTURED_DATA_DELETED: 'Structured data record deleted',
      FAILED_TO_SAVE_STRUCTURED_DATA: 'Failed to save structured data',
      FAILED_TO_LOAD_STRUCTURED_DATA: 'Failed to load structured data',
      FAILED_TO_CREATE_STRUCTURED_DATA: 'Failed to create structured data record',
      FAILED_TO_GENERATE_STRUCTURED_DATA: 'Failed to generate structured data',
      FAILED_TO_DELETE_STRUCTURED_DATA: 'Failed to delete structured data',
      FAILED_TO_SET_ACTIVE_STRUCTURED_DATA: 'Failed to set active structured data',
      STRUCTURED_DATA_NAME_PLACEHOLDER: 'Enter setting name (this item does not affect structured data)',
      STRUCTURED_DATA_USAGE_HINT:
        'When active, this script is injected into articles according to the delivery toggles on the WP, IPP, or AST tabs.',
      DELETE_STRUCTURED_DATA_TITLE: 'Delete Structured Data Profile?',
      DELETE_STRUCTURED_DATA_DESC:
        'Are you sure you want to delete this structured data record? If this was active, another record will automatically become active.',
      STRUCTURED_DATA_TOGGLE_CONFIRM_TITLE: 'Confirm Structured Data Setting Change',
      STRUCTURED_DATA_TOGGLE_CONFIRM_DESCRIPTION:
        'Turn "{{channel}}" {{state}}? The active structured data profile will be delivered according to this setting.',
      TEMPLATE_WP_STANDARD: 'WordPress Standard',
      TEMPLATE_WP_STANDARD_DESC:
        'A script that automatically retrieves the logo image and post date from one specified location (CSS selector) each, and generates structured data.',
      TEMPLATE_WP_RESPONSIVE: 'WordPress Responsive (PC / SP)',
      TEMPLATE_WP_RESPONSIVE_DESC:
        'For sites where the logo image and post date are displayed in different locations on the PC version and the mobile version. A script that automatically retrieves them from both locations (CSS selectors) each, and generates structured data.',
      TEMPLATE_IPP: 'IPP',
      TEMPLATE_IPP_DESC:
        'A script that automatically determines whether a page is an article page based on the URL hierarchy, reads the displayed content of the breadcrumb list (#pan element), and reflects it in the structured data.',
      TEMPLATE_AST_NEW: 'New AST',
      TEMPLATE_AST_NEW_DESC:
        "A template that traces the category hierarchy back to the root (top page) to automatically build breadcrumb information, and retrieves article/page information directly from AST's database to build the structured data (unlike other CMSs, this is processed server-side).",
      TEMPLATE_AST_OLD: 'Old AST',
      TEMPLATE_AST_OLD_DESC:
        'A script that reads the displayed content of the breadcrumb list (#breadcrumb element) and the depth of the URL hierarchy, and automatically builds the nested structure of the structured data according to the hierarchy (for the older version of AST).',
      TEMPLATE_LABEL_WP_STANDARD: 'WordPress Standard',
      TEMPLATE_LABEL_WP_RESPONSIVE: 'WordPress Responsive (PC/SP)',
      TEMPLATE_LABEL_IPP: 'IPP',
      TEMPLATE_LABEL_AST_NEW: 'New AST',
      TEMPLATE_LABEL_AST_OLD: 'Old AST',
      WP: 'WP',
      WP_PC_SP: 'WP PC/SP',
      AST_NEW: 'New AST',
      AST_OLD: 'Old AST',
      CUSTOM: 'Custom',
      PROFILE_NAME: 'Profile Name',
      TEMPLATE_TYPE: 'Template Type',
      SCHEMA_SCRIPT_CONTENT: 'Schema / Script Content',
      UNNAMED_PROFILE: 'Unnamed Profile',
      GENERATE_AND_SAVE: 'Generate & Save',
      TOP_PAGE_NAME: 'Top Page Name',
      SITE_URL_LABEL: 'Site URL',
      CUSTOMER_NAME: 'Customer / Site Name',
      AUTHOR_PAGE_URL: 'Author / Company Page URL',
      ARTICLE_PAGE_NAME: 'Target Article Page Name',
      SUBMISSION_DIRECTORY: 'Target Directory Slug',
      URL_PATH_LENGTH: 'URL Path Length Count',
      LOGO_ELEMENT_SELECTOR: 'Logo Element CSS Selector',
      DATE_ELEMENT_SELECTOR: 'Date Element CSS Selector',
      PC_LOGO_SELECTOR: 'PC Logo CSS Selector',
      SP_LOGO_SELECTOR: 'SP Logo CSS Selector',
      PC_DATE_SELECTOR: 'PC Date CSS Selector',
      SP_DATE_SELECTOR: 'SP Date CSS Selector',
      LOGO_IMAGE_URL: 'Direct Logo Image URL',
      ARTICLE_CODE: 'Article Code',
      AUTHOR_PAGE_PATH: 'Author Page Path',

      // Keyword Management
      KEYWORD_MANAGEMENT: 'Keyword Management',
      MANUAL_ARTICLE_KEYWORD_MANAGEMENT_TOOLTIP: 'Article lists and automatic article posting can be configured per main keyword.\nWhen creating an article manually, you can choose which main keyword to link it to.\nThe linking to a main keyword has no effect whatsoever on the content of the article that is created.',
      REGISTERED_MAIN_KEYWORDS: 'Registered Main Keywords',
      NATIONAL_TYPE: 'National Type',
      PREFECTURE_TYPE: 'Prefecture Type',
      CITY_TYPE: 'City Type',
      MUNICIPALITY_TYPE: 'Municipality Type',
      STATION_TYPE: 'Station Type',
      CHANGE: 'Change',
      VIEW: 'View',
      USE: 'Use',
      NOT_USE: 'Not Use',
      PREFECTURE_TYPE_POP_UP_TEXT: 'Do you change the Use or Not-Use?',
      PREFECTURE_BLANK_SEARCH_TEXT: 'Please enter the prefecture name',
      CITY_BLANK_SEARCH_TEXT: 'Please enter the city name',
      REGISTRATION_WARNING_TEXT:
        'Once Registered, the information cannot be modified.\nTo make changes, a new registration must be made using credits.',
      PREFECTURE_TYPE_INSTRUCTION_TEXT: `The generated local keywords will be in the format: "Main keyword + selected 47 prefectures".\nExamples: Air Conditioner Cleaning Hokkaido / Air Conditioner Cleaning Aomori / ...`,
      CITY_TYPE_INSTRUCTION_TEXT: `The generated local keywords will be:\n"Main keyword + selected prefecture" and "Main keyword + selected municipality".\nExamples: Air Conditioner Cleaning Tokyo / Air Conditioner Cleaning Minato-ku / Air Conditioner Cleaning Ota-ku /...`,
      STATION_TYPE_INSTRUCTION_TEXT: `The generated local keywords will be:\n"Main keyword + the prefecture of the selected municipality," "Main keyword + selected municipality," and "Main keyword + selected station name".\nExamples: Air Conditioner Cleaning Tokyo / Air Conditioner Cleaning Itabashi-ku / Air Conditioner Cleaning Narimasu Station...`,
      CONFIRM_REGISTRATION_TEXT: 'Do you want to generate local keywords based on the selected conditions?',
      SELECT_ALL: 'Select All',
      DESELECT_ALL: 'Deselect All',
      ALREADY_REGISTERED: '[ Already Registered ]',
      REGISTRATION: 'Registration',
      CLOSE: 'Close',
      RESET: 'Reset',
      REGISTERED_PREFECTURES: 'Registered Prefectures',
      SELECT_LOCAL_KEYWORDS: 'Local Articles\nSelect keywords and create articles',
      ADD_NEW_CITY: 'Add New City',
      ADD_NEW_STATION: 'Add New Station',
      NO_KEYWORDS: 'No keywords registered yet',
      REGISTER_MAIN_KEYWORD: 'Register new main keyword',
      ENTER_MAIN_KEYWORD: 'Please enter your main keywords.',
      MAIN_KEYWORD_HINT: 'Use a clear keyword relevant to your location and service.',
      CONFIRM_KEYWORD: 'Confirm Keyword',
      CONFIRM_KEYWORD_EXCLUSION: 'Confirm Keyword Exclusion',
      ARE_YOU_SURE_YOU_WANT_TO_REGISTER: 'Are you sure you want to register this as the main keyword?',
      UPDATE_ARTICLE: 'Update Article',
      // ALL_LOCATION: "All Location",
      LOCATION_SEARCH: 'Select or type location',
      ALL_LOCATION: 'All Location',
      SEARCH_KEYWORD: 'Search Keyword',
      DOWNLOAD_CSV: 'Download CSV',
      UPLOAD_KEYWORDS: 'Upload Keywords',
      SL_NO: 'No.',
      CSV_CLOSE: 'Close',
      CSV_CONFIRM: 'Confirm',
      BUILD_BACKLINK_CSV_LIST: 'Build Backlink CSV List',
      BUSINESS_KEYWORD_CSV_LIST: 'Business Article Keyword CSV List',
      UPLOAD_BUILD_BACKLINK_CSV: 'Upload Build Backlink CSV File',
      NO_CSV_FOUND: 'No CSV files found. Create your first one!',
      CONFIRM_CREATE_CSV: 'Confirm CSV Creation',
      CONFIRM_CREATE_CSV_MESSAGE:
        'Are you sure you want to create a CSV for the selected location?\nThis process may take some time.',
      EXCLUDE_EXCLUDED_KEYWORDS_IN_CSV: 'Exclude excluded keywords from CSV download',
      CONFIRM_UPLOAD_CSV: 'Confirm CSV Upload',
      CONFIRM_UPLOAD_CSV_MESSAGE: 'Are you sure you want to upload the selected CSV?\nThis process may take some time.',
      CREATE_CSV: 'Create CSV',
      CREATED_AT: 'Created At',
      ACTIONS: 'Actions',
      NOT_STARTED: 'Not Started',
      REMAINING: 'Remaining',
      DOWNLOADED: 'Downloaded',
      DOWNLOAD: 'Download',
      DOWNLOADING: 'Downloading',
      WARNING_TEXT_DELETE_CITY_STATION_TYPE: `Are you sure you want to delete this?\n*From [Local Articles > Select keywords and create articles], keywords will be deleted.\nHowever, please rest assured that keywords for which articles have already been created will remain.`,

      // KEYWORD EXCLUSION
      KEYWORD_EXCLUSION_DISCLAIMER_TITLE: 'Keyword Exclusion Notice',
      KEYWORD_EXCLUSION_DISCLAIMER_MESSAGE: 'Excluding a keyword means it cannot be used later for article generation',
      EXCLUDE_KEYWORD_SUCCESS: 'The keyword was excluded successfully',
      EXCLUDE_KEYWORD_FAILED: 'Failed to exclude the keyword',

      //THUMBNAIL UPLOAD
      ARTICLE_THUMBNAIL: 'Article Featured Image',
      SELECT_THUMBNAIL: 'Select Featured Image',
      UPLOAD_THUMBNAIL: 'Generate/Upload Image',
      REMOVE_THUMBNAIL: 'Remove Featured Image',
      THUMBNAIL_UPLOAD_SUCCESS: 'Featured Image uploaded successfully',
      THUMBNAIL_UPLOAD_FAILED: 'Failed to upload Featured Image',
      THUMBNAIL_REMOVED: 'Featured Image removed',
      THUMBNAIL_REMOVE_FAILED: 'Failed to remove Featured Image',
      UPLOADING: 'Uploading...',
      LOADING: 'Loading...',
      THUMBNAIL_HELP: 'Upload an image to use as the featured image for your post.',
      PLEASE_SELECT_IMAGE_FILE: 'Please select an image file',
      PLEASE_SELECT_IMAGE_FIRST: 'Please select an image first',
      IMAGE_SIZE_EXCEEDE: 'Image size must be less than 5MB',
      CURRENT_THUMBNAIL: 'Current Featured Image',
      SELECTED_IMAGE: 'Selected Image',
      SELECT_IMAGE_HELP: 'Click to select an image file',
      CANCEL_SELECTION: 'Cancel',
      IMAGE_SIZE_EXCEEDED_1MB: 'Image size must be less than 5MB',
      IMAGE_SIZE_EXCEEDED_5MB: 'Image size must be less than 5MB',
      WP_IMAGE_SIZE_LIMIT_TEXT: 'Please upload images of 5MB or less (JPG / PNG / GIF / WebP).',
      UPLOADING_COMPRESSING: 'Uploading and compressing...',
      THUMBNAIL_READY: 'Featured Image is uploaded and will be included with the post',
      CHANGE_THUMBNAIL: 'Generate/Upload Image',

      ARTICLE_IMAGE_TAB_GENERATE: 'Generate with AI',
      ARTICLE_IMAGE_TAB_UPLOAD: 'Upload your own image',
      ARTICLE_IMAGE_OPTIONAL: 'Optional',
      ARTICLE_IMAGE_TARGET_AUDIENCE: 'Target Audience',
      ARTICLE_IMAGE_OPTIONS_HINT: 'No selection is required. By default, an image matching the article content will be generated.',
      ARTICLE_IMAGE_OPTIONS_HINT_STRONG: 'No selection is required.',
      ARTICLE_IMAGE_OPTIONS_HINT_DESC: 'By default, an image matching the article content will be generated.',
      ARTICLE_IMAGE_GENERATE_NOTICE_WAIT: 'Image generation takes a few minutes. Please check back later.',
      ARTICLE_IMAGE_GENERATE_NOTICE_TASTE: 'Even if you select a target audience or design taste, the result may not always match your preferred taste.',
      ARTICLE_IMAGE_GENDER: 'Gender',
      ARTICLE_IMAGE_GENDER_MALE: 'Male',
      ARTICLE_IMAGE_GENDER_FEMALE: 'Female',
      ARTICLE_IMAGE_AGE_GROUP: 'Age Group',
      ARTICLE_IMAGE_AGE_NOT_SELECTED: 'Not selected',
      ARTICLE_IMAGE_AGE_10S: '10s',
      ARTICLE_IMAGE_AGE_20S: '20s',
      ARTICLE_IMAGE_AGE_30S: '30s',
      ARTICLE_IMAGE_AGE_40S: '40s',
      ARTICLE_IMAGE_AGE_50S: '50s',
      ARTICLE_IMAGE_AGE_60S: '60s',
      ARTICLE_IMAGE_AGE_70S: '70s',
      ARTICLE_IMAGE_AGE_80S: '80s',
      ARTICLE_IMAGE_AGE_90S: '90s',
      ARTICLE_IMAGE_AGE_OR_ABOVE: 'and above',
      ARTICLE_IMAGE_AGE_OR_BELOW: 'and below',
      ARTICLE_IMAGE_DESIGN_STYLE: 'Design Style',
      ARTICLE_IMAGE_CLEAR_ALL: 'Clear all selections',
      ARTICLE_IMAGE_CANCEL: 'Cancel',
      ARTICLE_IMAGE_GENERATE: 'Generate image with these settings',
      ARTICLE_IMAGE_REGENERATE: 'Regenerate with these settings',
      ARTICLE_IMAGE_GENERATING: 'Generating...',
      ARTICLE_IMAGE_USE_IMAGE: 'Use this image',
      ARTICLE_IMAGE_UPLOAD_TITLE: 'Upload Image',
      ARTICLE_IMAGE_UPLOAD_ZONE: 'Click to select an image, or drag and drop',
      ARTICLE_IMAGE_UPLOAD_HINT: 'Supported formats: JPG / PNG / GIF / WebP. Max 5MB. Recommended size: 1200×630px or larger',
      ARTICLE_IMAGE_REMOVE_IMAGE: 'Remove',
      ARTICLE_IMAGE_UNSUPPORTED_TYPE: 'Please select a JPG, PNG, GIF, or WebP image.',
      ARTICLE_IMAGE_STATUS_PENDING: 'Pending',
      ARTICLE_IMAGE_STATUS_QUEUED: 'Queued',
      ARTICLE_IMAGE_STATUS_IN_PROGRESS: 'In progress',
      ARTICLE_IMAGE_STATUS_COMPLETED: 'Completed',
      ARTICLE_IMAGE_STATUS_FAILED: 'Failed',
      ARTICLE_IMAGE_STATUS_NONE: 'None',
      ARTICLE_IMAGE_ACCEPTED: 'Image generation has been accepted.',
      ARTICLE_IMAGE_GENERATE_SUCCESS: 'Article image generation is complete.',
      ARTICLE_IMAGE_GENERATE_FAILED: 'Article image generation failed.',
      ARTICLE_IMAGE_GENERATE_START_FAILED: 'Failed to start image generation.',
      ARTICLE_IMAGE_TASTES_LOAD_FAILED: 'Failed to load design styles.',
      ARTICLE_IMAGE_FREE_INPUT: 'Free Input',
      ARTICLE_IMAGE_FREE_INPUT_PLACEHOLDER:
        'A couple of short lines is recommended. Please note this text may not always be reflected exactly as written.',
      ARTICLE_IMAGE_FREE_REMAINING: 'Free generations left: {{remaining}}',
      ARTICLE_IMAGE_CREDIT_NOTICE: 'This attempt will consume {{credits}} credits.',
      ARTICLE_IMAGE_CREDIT_CONFIRM_TITLE: 'Confirm',
      ARTICLE_IMAGE_CREDIT_CONFIRM_MESSAGE:
        'You have exceeded the number of free attempts.\n<strong>Do you want to consume {{credits}} credits and continue?</strong>',
      ARTICLE_IMAGE_CONFIRM_CONTINUE: 'Continue',
      ARTICLE_IMAGE_INSUFFICIENT_CREDITS: 'Insufficient credits.',
      ARTICLE_IMAGE_FREE_REMAINING_NONE: 'No free generations left',
      ARTICLE_IMAGE_MISSING_IMAGE: 'There is no image to edit.',
      ARTICLE_IMAGE_MANUAL_NOT_EDITABLE: 'Manually uploaded images cannot be edited.',
      ARTICLE_IMAGE_ARTICLE_NOT_FOUND: 'Article not found.',
      ARTICLE_IMAGE_MISSING_LOCATION: 'Location information is missing.',
      ARTICLE_IMAGE_MISSING_TITLE: 'Article title is missing.',
      ARTICLE_IMAGE_MISSING_COMPOSITION: 'Article composition is missing.',
      ARTICLE_IMAGE_MISSING_AUTHOR_TEXT: 'Author information is not set, so image generation cannot be used.',
      ARTICLE_IMAGE_MISSING_TEMPLATE: 'The prompt template is not configured.',
      ARTICLE_IMAGE_EDIT_LABEL: 'Edit Instruction',
      ARTICLE_IMAGE_EDIT_PLACEHOLDER: "e.g. Please change the car's color to red",
      ARTICLE_IMAGE_EDIT_APPLY: 'Apply Edit',
      ARTICLE_IMAGE_EDIT_ACCEPTED: 'Image edit has been accepted.',
      ARTICLE_IMAGE_EDIT_START_FAILED: 'Failed to start image editing.',
      ARTICLE_IMAGE_EDIT_COMPLETE: 'Article image editing is complete.',
      ARTICLE_IMAGE_EDIT_FAILED: 'Article image editing failed.',
      ARTICLE_IMAGE_EDITING: 'Image editing in progress...',
      ARTICLE_IMAGE_EDIT_REMAINING: 'Free generations left: {{remaining}}',
      ARTICLE_IMAGE_EDIT_CREDIT_NOTICE: 'This edit will consume {{credits}} credits.',
      ARTICLE_IMAGE_SAVE_PNG: 'Save as PNG',
      ARTICLE_IMAGE_SAVE_FAILED: 'Failed to save the image.',
      ARTICLE_IMAGE_IN_FLIGHT: 'Image generation is already running.',
      ARTICLE_IMAGE_GENERATION_STATUS: 'Image generation status',
      ARTICLE_IMAGE_ARTICLE_TITLE: 'Article title',
      ARTICLE_IMAGE_PAGE_PREVIEW: 'Page preview',
      ARTICLE_IMAGE_PAGE_PREVIEW_SUBTITLE: 'Check how the main visual and article opening will look',
      ARTICLE_IMAGE_PREVIEW_KEYWORD_LABEL: 'Keyword used to create article: ',
      ARTICLE_IMAGE_PREVIEW_BODY: 'Article',
      ARTICLE_IMAGE_PREVIEW_TIP: 'This preview shows the start of the article (up to 500 characters).',
      ARTICLE_IMAGE_HAS_THUMBNAIL: 'Has featured image',
      ARTICLE_IMAGE_CURRENT_IMAGE: 'Current image',
      ARTICLE_IMAGE_REMOVE_FAILED: 'Failed to remove the image.',
      ARTICLE_IMAGE_TASTE_PHOTOREALISTIC: 'Photorealistic',
      ARTICLE_IMAGE_TASTE_PHOTOREALISTIC_SUB: 'For store/service introductions',
      ARTICLE_IMAGE_TASTE_BUSINESS: 'Business Illustration',
      ARTICLE_IMAGE_TASTE_BUSINESS_SUB: 'For B2B/explainer articles',
      ARTICLE_IMAGE_TASTE_ANIME: 'Anime',
      ARTICLE_IMAGE_TASTE_ANIME_SUB: 'For approachable articles',
      ARTICLE_IMAGE_TASTE_FLAT: 'Flat Design',
      ARTICLE_IMAGE_TASTE_FLAT_SUB: 'For general SEO articles',
      ARTICLE_IMAGE_TASTE_DCG: 'DCG',
      ARTICLE_IMAGE_TASTE_DCG_SUB: 'For IT/AI/futuristic themes',
      ARTICLE_IMAGE_TASTE_INFOGRAPHIC: 'Infographic',
      ARTICLE_IMAGE_TASTE_INFOGRAPHIC_SUB: 'For data-driven explainers',
      ARTICLE_IMAGE_TASTE_WATERCOLOR: 'Watercolor',
      ARTICLE_IMAGE_TASTE_WATERCOLOR_SUB: 'For travel/lifestyle content',
      ARTICLE_IMAGE_TASTE_CINEMATIC: 'Cinematic',
      ARTICLE_IMAGE_TASTE_CINEMATIC_SUB: 'For premium services',

      //CSV
      MANUAL_KEYWORD_UPLOAD: 'Manual Keyword Upload',
      DOWNLOAD_SAMPLE_CSV: 'Download Sample CSV',
      CSV_UPLOADED_SUCCESSFULLY: 'CSV uploaded successfully',
      CSV_UPLOAD_FAILED: 'CSV upload failed',
      CSV_UPLOAD_STATUS_CHECK_FAILED: 'CSV upload status check failed',
      UPLOAD_CSV: 'Upload CSV',
      CONFIRM_UPLOAD: 'Confirm Upload',
      Creating: 'Creating...',
      Loading_CSV_list: 'Loading CSV list...',
      FILE_NOT_READY_YET: 'The file is not ready yet',
      UPLOAD_FILE: 'Upload File',
      UPLOADED_FILES: 'Uploaded Files',

      // Bulk Article Generation
      BULK_ARTICLE_CREATION: 'Bulk Article Generation',
      NO_KEYWORDS_SELECTED: 'No Keywords Selected',
      NOT_MORE_THAN_20_KEYWORDS_SELECTED: 'Creating more then 20 articles is not allowed',
      ARTICLE_GENERATION_FAILED: 'Article Creation Failed',
      DUPLICATE_KEYWORD_DETECTED: 'Duplicate keyword detected. Please enter a different keyword.',
      BULK_ARTICLE_GENERATION_FAILED: 'Bulk Article Creation Failed',
      BULK_ARTICLE_GENERATION_COMPLETED: 'Bulk Article Creation Success',
      BULK_ARTICLE_GENERATION_STARTED: 'Bulk Article Creation Started',
      PHRASE_MATCH: 'Phrase Match',
      COMPETITOR_ORGANIC: 'Competitor Organic',
      MY_WEBSITE_ORGANIC: 'My Website Organic',
      MANUAL_KEYWORD_INPUT: 'Manual Keyword Input',
      SELECTED_KEYWORDS: 'selected keywords',
      CREATE_ARTICLE_BULK: 'Create Bulk Article',
      SUCCEEDED: 'Succeeded',

      //Language
      ENGLISH: 'English',
      JAPANESE: 'Japanese',
      ARTICLE_LANGUAGE: 'Language',
      LIST_SEND: 'List / Send',
      CHECK_MAIL: 'Check Mails',
      MANAGE_BACKLINK_STATUS: 'Check / Manage Backlink Status',
      CHECK_SEND_RESULT: 'Check Send Results / Resend',
      OTHER_ACTIONS: 'Other Actions',

      //Manual Prompt
      ARTICLE_REVISION_TOOLTIP:
        'After creating an article, you can set a prompt to revise or add to the content.\n\n Example:\n- If there is no information about recruitment, please add details related to recruitment.\n- Please add keywords such as bulky waste collection, bulky waste, and waste item disposal.',
      MANUAL_PROMPT_ADDITION: 'Manual prompt addition',
      MANUAL_PROMPT: 'Manual Prompt',

      // User Profile / Template Management
      LOCATION_NOT_FOUND_MESSAGE: 'Location not found',
      TEMPLATE_NOT_FOUND_MESSAGE: 'Template not found',
      USER_PROFILE_DESCRIPTION_1:
        'Automatic form submission will be performed from the inquiry forms of each website to acquire backlinks.',
      USER_PROFILE_DESCRIPTION_2:
        'Inquiry forms have various input fields such as company name, full name, email address, etc.',
      USER_PROFILE_DESCRIPTION_3:
        'On this screen, please set in advance the values you want to enter in the inquiry form.',
      USER_PROFILE_DESCRIPTION_4:
        'Example: If you register the company name as [株式会社ABC], and the inquiry form has a field for the company name, the value [株式会社ABC] will be automatically entered and the form will be submitted.',
      USER_PROFILE: 'My Profile',
      COPY_BTN: 'Copy',
      EDIT_BTN: 'Edit',
      DELETE_BTN: 'Delete',
      SELECT_OPTION: 'Select Option',
      EMAIL_ADDRESS: 'Email Address *',
      LAST_NAME: 'Last Name *',
      FIRST_NAME: 'First Name *',
      LAST_NAME_KATAKANA: 'Last Name (Katakana)',
      FIRST_NAME_KATAKANA: 'First Name (Katakana)',
      LAST_NAME_HIRAGANA: 'Last Name (Hiragana)',
      FIRST_NAME_HIRAGANA: 'First Name (Hiragana)',
      PHONE_NUMBER_ONE: 'Phone Number 1 *',
      REPLY_TEXT: 'Reply Text',
      TEMPLATE_NAME: 'Template Name *',
      COMPANY_NAME: 'Company Name *',
      DEPARTMENT_NAME: 'Department Name',
      POSITION_PROFILE: 'Position',
      INDUSTRY: 'Industry',
      NUMBER_OF_EMPLOYEES: 'Number of Employees',
      HOMEPAGE_URL: 'Homepage URL *',
      EDITING_BTN: '⏳ Updating...',
      DELETING_BTN: '⏳ Deleting...',
      UPDATE_INQUIRE_BTN: 'Regenerate Inquire Email Template',
      UPDATE_REPLY_BTN: 'Update Reply Template',
      PATTERN_NAME_REQUIRED: 'Pattern name required!',
      DATA_CREATED: 'Data Created',
      ERROR_LOADING_TEMPLATE: 'Error loading template:',
      NO_CONTENT_TO_COPY: 'No content to copy!',
      COPIED: 'Copied!',
      NO_TEMPLATE_SELECTED: 'No template selected!',
      CONFIRM_DELETE_TEMPLATE: 'Are you sure to delete this template?',
      TEMPLATE_DELETED: 'Template Deleted',
      DELETE_FAILED: 'Delete failed!',
      CONFIRM_EDIT_TEMPLATE: 'Are you sure to edit this template?',
      TEMPLATE_UPDATED: 'Template Updated',
      UPDATE_FAILED: 'Update failed!',
      INQUIRY_TEXT: 'Inquiry Text',
      TEXT: 'Text',
      ADD_INQUIRY_PATTERN: 'Add Inquiry Pattern',
      ADD_REPLY_PATTERN: 'Add Reply Pattern',
      PATTERN_NAME: 'Pattern Name',
      DATA_UPDATED: 'Data updated successfully!',
      DATA_DELETED: 'Data deleted successfully!',
      SOMETHING_WENT_WRONG: 'Something went wrong. Please try again later.',
      FILL_ALL_FIELD: 'Fill all filed',
      DELETE_CONFIRM: 'Are you sure you want to delete?',
      COPY_SUCCESS: 'Copied successfully',
      CREATE_USER_TEMPLATE_PROFILE: 'Create new user profile',
      HOMEPAGE_NAME: 'Homepage Name *',
      HOMEPAGE_OVERVIEW: 'Homepage Overview',
      COMPANY_NAME_KATAKANA: 'Company name Katakana *',
      PHONE_NUMBER: 'Phone Number',
      FULL_NAME: 'Full Name',
      PHONE_NUMBER_TWO: 'Phone Number 2 *',
      PHONE_NUMBER_THREE: 'Phone Number 3 *',
      POSTAL_CODE_ONE: 'Postal Code 1',
      POSTAL_CODE_TWO: 'Postal Code 2',
      PREFECTURE: 'Prefecture',
      CITY: 'City',
      ADDRESS_LINE_ONE: 'Address Line 1',
      ADDRESS_LINE_TWO: 'Address Line 2',
      PROFILE_SUBJECT: 'Subject *',
      FULL_NAME_KATAKANA: 'Full Name (Katakana)',
      POSTAL_CODE: 'Postal Code',
      CHOOSE_INQUIRY_STYLE: 'Choose Inquiry Style',
      CHOOSE_TEMPLATE: 'Choose Template',
      INQUIRY_MESSAGE_PREVIEW: 'Inquiry Message Preview',
      SELECT_AN_INQUIRY_STYLE_TO_PREVIEW: 'Select an inquiry style to preview the message',
      PERSONAL_DETAILS: 'Personal Details',
      COMPANY_DETAILS: 'Company Details',
      USE_TEMPLATE: 'Use Template',
      NO_TEMPLATES_AVAILABLE: 'No Template Available',
      CONTENT_LIMIT_EXCEEDED: 'Content limit exceeded. Please enter less than {{limit}} characters.',
      ANCHOR: 'Anchor',
      PUBLISHED_URL: 'Published URL',
      UPLOAD_TEMPLATE_CSV: 'Upload Template CSV',
      UPLOAD_VALID_CSV: 'Please upload a valid CSV file.',

      // LIST/SEND
      MAIN_KEYWORD_PLACEHOLDER: 'main keyword',
      CLEAR_FILTER: 'Clear Filter',
      RE_FILTER: 'Re-filter',
      SHOW: 'Show',
      PER_PAGE: 'per page',
      SEARCH_PLACEHOLDER: 'Search...',
      MAIL: 'Mail',
      FORM: 'Form',
      AUTO_FORM_SUBMISSION: 'Auto Form Submission',
      PLEASE_SELECT_WEBSITES_FIRST: 'Please select websites first',
      SUBMIT_SELECTED_WEBSITES: 'Submit {{count}} selected website(s)',
      QUERY_TYPE: 'Query Type',
      CONTACT_FORM: 'Contact Form',
      COPY_TITLE_TO_CLIPBOARD: 'Copy title to clipboard',
      COPY_URL_TO_CLIPBOARD: 'Copy URL to clipboard',
      COPY_LOCATION_NAME_TO_CLIPBOARD: 'Copy location name to clipboard',
      OPEN_CONTACT_FORM: 'Open contact form',
      NO_WEBSITES_FOUND: 'No websites found',
      TRY_ADJUSTING_YOUR_FILTERS_OR_REFRESH_THE_LIST: 'Try adjusting your filters or refresh the list',
      N_A: 'N/A',
      FOUND: 'Found',
      NOT_FOUND: 'Not Found',
      CREATING: 'Creating',
      LOADING_CSV_LIST: 'Loading CSV list...',
      SEND: 'Send',
      SKIPPED: 'Skipped',
      ERROR_FETCHING_CSV_LIST: 'Failed to fetch CSV list',
      PLEASE_SELECT_A_LOCATION_FIRST: 'Please select a location first',
      CSV_CREATION_STARTED: 'CSV creation started! It will be available shortly!',
      CSV_CREATION_FAILED: 'Failed to create CSV. Please try again.',
      CSV_DOWNLOAD_SUCCESS: 'CSV download successfully',
      FILE_DOWNLOAD_FAILED: 'Failed to download file',
      CSV_DELETED: 'CSV deleted successfully',
      COPIED_TO_CLIPBOARD: 'Copied to clipboard!',
      COPY_FAILED: 'Failed to copy',
      PLEASE_SELECT_AT_LEAST_ONE_WEBSITE: 'Please select at least one website',
      FORM_SUBMISSION_FAILED: 'Failed to submit forms. Please try again.',
      CSV_DELETE_FAILED: 'Failed to delete CSV',
      UNSELECT_ALL: 'Unselect All',
      SELECT_ALL_PAGES: 'Select All Pages',
      SELECT_ALL_PAGES_TOOLTIP:
        'All items will be selected; however, when you click the Manual Form Submission button and navigate to the next screen, only the website lists with "Failed" and "Skipped" status will be displayed.\n*Unsendable, Excluded, and Cancelled are statuses assigned through user action, so they are controlled not to appear on the Manual Form Attack screen in order to prevent duplicate sending.',
      SELECTING_ALL: 'Selecting...',
      SELECTION_UPDATED: 'Selection updated: {{count}} records',
      SELECTION_UPDATE_FAILED: 'Failed to update selection',
      EXCLUDED_ITEMS_SUCCESS: 'Successfully excluded {{count}} items',
      EXCLUDED_ITEMS_FAILED: 'Failed to save excluded items',
      NO_FILE_CHOSEN: 'No file chosen',
      FILE_NAME: 'File Name',
      PROGRESSED_AT: 'Progressed At',

      // Screen/Module Constants
      CHECK_MANAGE_BACKLINK_STATUS: 'Backlink Manage',
      OTHER_ACTION: 'Other Action',
      NOTIFICATION_FOR_LIST_SEND: "There are still lists that can be sent! Let's press the send button!",
      NOTIFICATION_FOR_MANUAL_SUBMISSION:
        'There are some sites where automatic form submission failed! Please send the form manually!',
      NOTIFICATION_FOR_CHECK_MAIL:
        'Emails have arrived! Check the OK responses and question responses, and proceed to publication for the OK ones!',
      NOTIFICATION_FOR_MANAGE_BACKLINK:
        'There are sites where publication is still incomplete! If the other party has not completed it, try sending a reminder!',
      NOTIFICATION_FOR_CHECK_SEND_RESULT:
        'Please check the results of the automatic email or form submissions! You can also resend them by changing the email address or URL!',
      NOTIFICATION_FOR_OTHER_ACTIONS:
        "There are lists where the status couldn't be classified correctly! Please update the status as needed!",

      // Check Send Result
      RESEND_MAIL: 'Resend Mail',
      RESEND_FORM: 'Resend Form',
      RESEND_FORM_CONFIRMATION:
        'A form attack will be forcibly performed again on the selected website.\nPlease note that the form attack will be performed even on sites that have already been sent to, or sites that were skipped due to detecting text such as "no sales solicitations," and that the result may not change even if the form attack is performed again.\nIf you agree to these notes, please execute the form resend.',
      FAILED_TO_LOAD_TEMPLATES: 'Failed to load templates',
      PLEASE_SELECT_AT_LEAST_ONE_ROW: 'Please select at least one row to move',
      MOVE_TO_CHECK_MAIL: 'Move to Check Mail',
      MAIL_ADDRESS: 'Mail address',
      FORM_URL: 'Form URL',
      FORM_STATUS: 'Form Status',
      NG_WORD_STATUS: 'NG Word Status',
      ENTER_NEW_EMAIL: 'Enter new email',
      ENTER_NEW_FORM_URL: 'Enter new form URL',
      FORM_SEND_RESULTS: 'Form Send Results',
      MAIL_SEND_RESULTS: 'Mail Send Results',

      // Check Mails
      FAILED_TO_UPDATE_DATA: 'Failed to update data',
      MOVE_TO_READY_FOR_PUBLICATION: 'Move to "Ready for Publication"',
      BULK_EDIT: 'Bulk Edit',
      EMAIL_TYPE: 'Email Type',
      SUBJECT: 'Subject',
      REPLY_FROM: 'Reply From',
      INITIAL_SENTIMENT: 'Initial Sentiment',
      GENERAL_SENTIMENT: 'General Sentiment',
      REPLY_BODY: 'Reply Body',
      SELECT_INITIAL_SENTIMENT: 'Select initial sentiment',
      SELECT_GENERAL_SENTIMENT: 'Select general sentiment',
      EDIT_SENTIMENT: 'Edit Sentiment',
      SENTIMENT_REPLY_TEXT: 'Sentiment Reply',
      BULK_EDIT_SENTIMENTS: 'Bulk Edit Sentiments',
      SELECTED_ROWS_COUNT: 'Selected {{count}} rows',
      PLEASE_SELECT_AT_LEAST_ONE_SENTIMENT: 'Please select at least one sentiment to update',
      REPLY_APPROVED: 'Reply: Approved',
      REPLY_REJECTED: 'Reply: Rejected',
      REPLY_QUESTION: 'Reply: Question',
      REPLY_OTHER: 'Reply: Other',
      MAIL_RESPONSE: 'Mail Response',
      HUMAN: 'Human',
      AUTOMATED: 'Automated',
      SELECT_EMAIL_TYPE: 'Select Email Type',
      ALREADY_MOVED_FOR_PUBLICATION: 'Already moved for publication',
      SAVE_NOTE: 'Save Note',
      NO_REPLY_CONTENT: 'No reply content',
      MAIL_RESPONSE_COPIED: 'Mail response copied to clipboard!',
      MAIL_RESPONSE_COPY_FAILED: 'Failed to copy mail response',

      // Check Manage Backlink
      OWN: 'Own',
      OTHER: 'Other',
      NOTES: 'Notes',
      NOTES_PLACEHOLDER: 'Notes',
      COPY_URL: 'Copy URL',
      NEITHER_PUBLISHED: 'Neither Published',
      NOT_PUBLISHED_ON_OTHER_SITE: 'Not Published on Other Site',
      PUBLISHED_ON_OTHER_SITE: 'Published on Other Site',
      NOT_PUBLISHED_ON_OWN_SITE: 'Not Published on Own Site',
      PUBLISHED_ON_OWN_SITE: 'Published on Own site',
      BOTH_PUBLISHED: 'Both Published',

      // Manual Form Submission
      USER_INFORMATION: 'User Information',
      MANUAL_FORM_SUBMISSION_PROGRESS: 'Manual Form Submission Progress',
      NEW_MAIL_ADDRESS: 'New mail address',
      NEW_FORM_URL: 'New form URL',
      EDIT_FORM_SUBMISSION_DETAILS: 'Edit Form Submission Details',
      NEW_EMAIL_ADDRESS: 'New Email Address',
      ENTER_NEW_EMAIL_ADDRESS: 'Enter new email address',
      SENT: 'Sent',
      SKIP: 'Skip',
      COPY: 'Copy',
      RETRY: 'Retry',
      SKIP_TO_NEXT: 'Skip to Next',
      SKIP_THE_WEBSITE: 'Skip This Website?',
      CONFIRMATIO_SKIP_THE_WEBSITE: 'Are you sure you want to skip this website? You can come back to it later.',
      SUBMISSION_SUMMERY: 'Submission Summary',
      FORM_ATTACK_AUTO_STARTED_AT: 'Auto Form Attack Started At',
      FORM_ATTACK_AUTO_END_AT: 'Auto Form Attack End At',
      FORM_ATTACK_MANUAL_STARTED_AT: 'Manual Form Attack Started At',
      FORM_ATTACK_MANUAL_END_AT: 'Manual Form Attack End At',
      FORM_ATTACK_REASON: 'Failing Reason',
      TOTAL: 'Total',
      URL_IS_INVALID: 'URL is invalid',
      INQUIRY_FORM_NOT_FOUND: 'Inquiry form not found',
      NO_SALES_NOTICE_DETECTED: 'Detected "No Sales" notice',
      EXCLUDED_DOMAIN: 'Do not submit due to excluded domain',
      DUPLICATE_SUBMISSION: 'Do not submit due to duplicate submission',
      FORM_IN_IFRAME: 'Form is inside an iframe, so automatic input is not possible',
      UNSUPPORTED_INQUIRY_FORM: 'Unsupported inquiry form',
      WEBSITE_ANALYSIS_NOT_POSSIBLE: 'Website analysis not possible',
      TIMEOUT: 'Request timed out',
      BLOG_COMMENT_FORM: 'Detected a comment section such as a blog',
      RESERVATION_FORM: 'Detected a form such as a reservation form',
      DOCUMENT_MEMBER_FORM: 'Detected a form such as a document request or member registration',
      NO_APPLICABLE_INQUIRY_TYPE: 'No suitable option was found',
      TEXT_HALF_WIDTH_ONLY: 'Text should be half-width only',

      // user profile
      CONFIRM_ALERT: 'Are you sure?',
      MAKE_DEFAULT: 'Make default',
      DEFAULT: 'Default',
      CONFIRMATION_ALERT_DEFAULT_TEXT: 'Are you sure you want to perform this action?',
      CONFIRMATION_ALERT_DEFAULT_TITLE: 'Confirm Action',
      CSV_LIST: 'CSV List',
      FULL_NAME_HIRAGANA: 'Full Name (Hiragana)',

      // article rewrite
      CREATE_REWRITE_ARTICLE: 'Create Rewrite Article',
      FIRST_HAND_INFO_IN_QUEUE: 'First-hand information being added',
      REWRITE_IN_QUEUE: 'Rewrite In Queue',
      REWRITE_CLIENT_PROMPT_CONSTRUCTED: 'Prompt Constructed',
      REWRITE_ARTICLE_STARTED: 'Article Started',
      REWRITE_ARTICLE_COMPLETED: 'Rewrite Completed',
      REWRITE_ARTICLE_FAILED: 'Failed',
      RETRY_REWRITE_ARTICLE: 'Retry Rewrite Article',
      REWRITE_ARTICLE: 'Rewrite Article',
      REWRITE_ARTICLE_CONFIRMATION_TITLE: 'Rewrite an existing article',
      REWRITE_ARTICLE_CONFIRMATION_MESSAGE:
        'Are you sure you want to rewrite the already created article for this keyword?',
      REWRITE_ARTICLE_BULK: 'Rewrite Bulk Articles',
      REWRITE_ARTICLE_BULK_CONFIRMATION_TITLE: 'Rewrite existing articles in bulk',
      REWRITE_ARTICLE_BULK_CONFIRMATION_MESSAGE:
        'Are you sure you want to rewrite the already created articles in bulk for the selected keywords?',
      ARTICLE_FAILED: 'Failed',
      REWRITE_KEYWORD_CSV_LIST: 'Rewrite Keywords CSV List',
      NO_ARTICLES_FOUND: 'No articles found',

      // user profile
      UPDATE_CONFIRM_USER_TEMPLATE:
        "If you have changed the company name, contact person's name, email address, website URL, website name, anchor text, published url or website summary, please save the changes, then click the [Update inquiry text] or [Update reply email template] button, check the changes, and make any necessary changes.",
      GENERATING_TEXT: 'Generating...',
      LOADING_TEXT: 'Loading...',
      LOADING_AVAILABLE_SITES: 'Loading available sites...',
      INQUIRY_DESCRIPTION_TEXT: 'You can enter up to {{limit}} characters. Current total: {{count}} characters.',
      TEXT_LIMIT_EXCEEDED:
        'The text limit has been exceeded. Maximum allowed: {{limit}} characters. You can re-generate the text.',
      REPLY_DESCRIPTION_TEXT: 'You can enter up to {{limit}} characters. Current total: {{count}} characters.',

      TEMPLATE_NAME_PLACEHOLDER: 'Template Name',
      COMPANY_NAME_PLACEHOLDER: 'Template Company Ltd.',
      COMPANY_NAME_KATAKANA_PLACEHOLDER: 'Kabushiki Gaisha Template',
      DEPARTMENT_NAME_PLACEHOLDER: 'Public Relations',
      POSITION_PROFILE_PLACEHOLDER: 'General Staff',
      INDUSTRY_PLACEHOLDER: 'Website development, app development, etc.',
      NUMBER_OF_EMPLOYEES_PLACEHOLDER: '100',
      URL_PLACEHOLDER: 'https://www.●●●',
      HOMEPAGE_NAME_PLACEHOLDER: 'Homepage Name',
      HOMEPAGE_OVERVIEW_PLACEHOLDER:
        'Provides services supporting website development, MEO measures, app development, and overall digital marketing',
      EMAIL_ADDRESS_PLACEHOLDER: 'test@example.com',
      LAST_NAME_PLACEHOLDER: 'Yamada',
      FIRST_NAME_PLACEHOLDER: 'Taro',
      LAST_NAME_KATAKANA_PLACEHOLDER: 'Yamada',
      FIRST_NAME_KATAKANA_PLACEHOLDER: 'Taro',
      LAST_NAME_HIRAGANA_PLACEHOLDER: 'Yamada',
      FIRST_NAME_HIRAGANA_PLACEHOLDER: 'Taro',
      PHONE_NUMBER_ONE_PLACEHOLDER: '03',
      PHONE_NUMBER_TWO_PLACEHOLDER: '1234',
      PHONE_NUMBER_THREE_PLACEHOLDER: '5678',
      POSTAL_CODE_ONE_PLACEHOLDER: '123',
      POSTAL_CODE_TWO_PLACEHOLDER: '4567',
      PREFECTURE_PLACEHOLDER: 'Tokyo',
      CITY_PLACEHOLDER: 'Template Ward',
      ADDRESS_LINE_ONE_PLACEHOLDER: 'Template 1-1-1',
      ADDRESS_LINE_TWO_PLACEHOLDER: 'Template Building 1F',
      PROFILE_SUBJECT_PLACEHOLDER:
        "I am contacting you not to make a sales inquiry, but to introduce your company's web content.",
      ANCHOR_PLACEHOLDER: 'Anchor Text',

      TRANSACTIONS: 'Transactions',
      TEAM_MEMBERS: 'Team Members',
      EMAIL_OUTREACH: 'Email Outreach',
      LEADS: 'Leads',
      WELCOME: 'Welcome',
      CHECK_MANAGE_BACKLINK: 'Check / Manage Backlink',
      ANALYTICS: 'Analytics',
      SEARCH_CONSOLE: 'Search Console',
      CALENDAR: 'Calendar',
      BLANK_PAGE: 'Blank Page',
      GETTING_STARTED: 'Getting Started',
      FEATURES: 'Features',
      DOCUMENTATION: 'Documentation',
      ACCOUNT_MANAGEMENT: 'Account Management',
      STATUS_UPDATE_SUCCESS: 'Status updated to {{actionName}} successfully',
      STATUS_UPDATE_FAILED: 'Failed to update status to {{actionName}}',
      ALL_WEBSITES_PROCESSED: 'All websites processed!',
      SKIPPED_TO_NEXT_WEBSITE: 'Skipped to next website',
      SKIPPED_TO_FIRST_WEBSITE: 'Skipped to first website',
      MOVED_TO_PREVIOUS_WEBSITE: 'Moved to previous website',
      CONFIRM_MARK_AS: 'Yes, Mark as {{actionName}}',
      CONFIRM_MARK_WEBSITE: 'Are you sure you want to mark this website as {{actionName}}?',
      CONFIRM_DESC_SENT: ' This will mark the form as successfully submitted.',
      CONFIRM_DESC_UNSENDABLE: ' This will mark the form as unsendable.',
      CONFIRM_DESC_EXCLUDED: ' This will exclude this website from future submissions.',
      CONFIRM_DESC_REMOVED: ' This will cancel and remove this website from the list.',
      CONFIRM_GO_BACK: 'Yes, Go Back',
      GO_PREVIOUS_TITLE: 'Go to Previous Website?',
      GO_PREVIOUS_CONFIRM: 'Are you sure you want to go back to the previous website?',
      SENTIMENT_UPDATE_SUCCESS: 'Sentiment updated successfully',
      SENTIMENT_UPDATE_FAILED: 'Failed to update sentiment',
      SELECT_ROWS_TO_EDIT: 'Please select rows to edit',
      NO_ROWS_SELECTED: 'No rows selected',
      ROWS_UPDATED_SUCCESS: '{{count}} rows updated successfully',
      DATA_UPDATE_FAILED: 'Failed to update data',
      SUCCESS: 'Success',
      ERROR: 'Error',
      FORMS_SUBMITTED_SUCCESS: 'Successfully submitted {{count}} form(s) for processing',
      DOMAIN_RATING: 'Domain Rating',
      URL_TYPE: 'URL Type',
      RANK_GTE: 'Rank ≥',
      EXCLUDE_DOMAINS: 'Exclude Domains',
      REPLIED_AT: 'Replied At',
      TOTAL_ITEMS_FOUND: `{{total}} item(s)`,
      MOVE_TEMPLATE_EDIT: 'Move to Template Edit',
      SELECTED_ALL_RECORDS: 'Selected all {{count}} records across all pages',

      // MainKeyword
      AREA_CONFIGURATION_FOR: 'Area Configuration for',
      NO_ITEMS_FOUND: 'No items found',

      CHECKBOX_ALERT_MESSAGE: 'Check this box to skip confirmation alerts when moving next or previous.',
      CHECKBOX_ALERT_BUTTON_MESSAGE: 'Check this box to skip alerts when submitting any of the actions below.',

      // --- Article Details: GBP Post Modal ---
      POST_TO_GBP: 'Post to Google Business Profile',
      CONFIGURE_PUBLICATION_SETTINGS: 'Configure publication settings',
      SELECT_BBS_LOCATION: 'Select BBS Location',
      THIS_LOCATION_HAS_ACTIVE_INTEGRATION: 'This location has an active integration',
      POST_LINK: 'Post Link',
      ENTER_BUTTON_LINK_PLACEHOLDER: 'https://example.com/promotion',
      SCHEDULE_DATE: 'Schedule Date',
      THUMBNAIL_READY_FOR_POSTING: 'Thumbnail ready for posting',
      ARTICLE_POSTED_TO_BBS_SUCCESSFULLY: 'Article posted to BBS successfully!',
      FAILED_TO_POST_TO_BBS: 'Failed to post to BBS',

      // --- Article Details: Preview Modal ---
      GENERATE_PREVIEW: 'Generate Preview',
      PREVIEW_AND_EDIT: 'Preview and Edit',
      VERIFY_CONTENT_BEFORE_PUBLISHING: 'Verify content before publishing',
      POST_CONTENT: 'Post Content',
      EDITABLE_CONTENT_TIP: 'You can edit the content here',
      ENTER_GBP_POST_CONTENT: 'Enter GBP post content...',
      GBP_CONTENT_TIP_MESSAGE: 'Tip: GBP posts have a character limit of 1500.',
      POST_DETAILS: 'Post Details',
      ATTACHED_IMAGE: 'Attached Image',
      PUBLICATION_TIMING: 'Publication Timing',
      POST_IMMEDIATELY: 'Post Immediately',
      TARGET_LOCATION: 'Target Location',
      ACTION_BUTTON_LINK: 'Action Button Link',
      SAVE_AND_USE: 'Save and Use',
      GBP_CONTENT_SAVED_SUCCESSFULLY: 'GBP content saved successfully',
      FAILED_TO_SAVE_GBP_CONTENT: 'Failed to save GBP content',
      PREVIEW_GENERATED_SUCCESSFULLY: 'Preview generated successfully',
      FAILED_TO_GENERATE_PREVIEW: 'Failed to generate preview',
      EDIT_PREVIEW_CONTENT: 'Edit Preview Content',

      // --- BBS Integration Settings: Account & Mapping ---
      BBS_INTEGRATION: 'BBS/GBP Integration',
      BBS_ACCOUNT: 'BBS Account',
      BBS_ACCOUNT_DESCRIPTION: 'Manage your connection to the BBS platform.',
      ENTER_BBS_EMAIL: 'Enter BBS Email',
      ENTER_BBS_PASSWORD: 'Enter BBS Password',
      LOGIN_TO_BBS: 'Login to BBS',
      BBS_LOGIN_SUCCESSFUL: 'BBS login successful',
      FAILED_TO_LOGIN_BBS: 'Failed to login to BBS',
      BBS_CONNECTED: 'BBS Connected',
      DISCONNECT_BBS_ACCOUNT_CONFIRMATION: 'Are you sure you want to disconnect the BBS account?',
      DISCONNECT: 'Disconnect',
      BBS_DISCONNECTED_SUCCESSFULLY: 'BBS disconnected successfully',
      FAILED_TO_DISCONNECT_BBS: 'Failed to disconnect BBS',
      LOCATION_NOT_MAPPED_MSG: 'This location is not mapped to a BBS location.',
      CONNECT_LOCATION_TO_BBS: 'Connect Location to BBS',
      MAP_LOCATIONS_DESCRIPTION: 'Select the BBS location that corresponds to your SEO location.',
      SELECTED_SEO_LOCATION: 'Selected SEO Location',
      SELECT_BBS_LOCATION_TO_MAP: 'Select BBS Location to Map',
      SELECT_ONE_BBS_LOCATION_DESCRIPTION: 'Only one BBS location can be mapped per SEO location.',
      CONFIRM_MAPPING: 'Confirm Mapping',
      MAPPED_BBS_LOCATION: 'Mapped BBS Location',
      LOCATION_MAPPED_SUCCESSFULLY: 'Location mapped successfully',
      FAILED_TO_MAP_LOCATION: 'Failed to map location',

      // --- BBS Integration Settings: Scheduler ---
      LOCATION_INTEGRATION_SETTINGS: 'Location Integration Settings',
      LOCATION_INTEGRATION_DESCRIPTION: 'Configure auto-posting and scheduling for this location.',
      CURRENT_INTEGRATION: 'Current Integration',
      BBS_LOCATIONS: 'BBS Locations',
      CREATE_INTEGRATION: 'Create Integration',
      NO_INTEGRATION_SETTINGS: 'No integration settings found.',
      DELETE_INTEGRATION_CONFIRMATION: 'Are you sure you want to delete this integration?',
      DELETE_INTEGRATION_CONFIRM_BUTTON: 'Delete',
      INTEGRATION_ACTIVATED: 'Integration activated',
      INTEGRATION_DEACTIVATED: 'Integration deactivated',
      INTEGRATION_SETTINGS_SAVED: 'Integration settings saved',
      FAILED_TO_SAVE_INTEGRATION: 'Failed to save integration',
      ARTICLE_STATUSES: 'Article Statuses',
      DAYS_SELECTED: 'Days Selected',
      DEACTIVATE: 'Deactivate',
      EVERY_MONTH: 'Every Month',
      CONNECT_NOW: 'Connect',
      REPLY_TEMPLATE: 'Reply Template',
      NO_TEMPLATE_EXISTS: 'No template exists.',
      BUILD_BACKLINK_CSV: 'Build Backlink CSV',
      TEMPLATE_CSV: 'Template CSV',
      ARTICLE_CHAR_COUNT: '{length} / 1500 characters',
      OPTIONAL: '(Optional)',
      ACTION_REQUIRED: 'Action Required',
      EMAIL_PLACEHOLDER: 'Enter your BBS login email address/ID',
      PASSWORD_PLACEHOLDER: 'Enter your password',

      // Platform Configuration
      MANAGE_PLATFORM_SETTINGS: 'Manage and configure your platform settings',

      // Badge Configuration
      PLATFORM_CONFIGURATION: 'Platform Configuration',
      LOADING_MAIN_KEYWORDS: 'Loading Main Keywords',
      NO_LOCATION_FOUND: 'No location found',
      LOADING_LOCATIONS: 'Loading Locations',
      BADGE_CONFIGURATION: 'Badge Configuration',
      BADGE_CONFIGURATIONS_DISABLED: 'Badge Permissions Disabled',
      LOCATION_WISE_BADGE_CONFIGURATION: 'Location-wise Badge Configuration',
      BADGE_CONFIGURATION_UPDATED: 'Badge Configuration Updated',
      BADGE_CONFIGURATION_DESCRIPTION: 'Configure badge visibility for different screens and actions',
      SHOW_BADGE_COUNT: 'Show Badge Count',
      BADGE_CONFIGURATION_HELP_TEXT:
        'Enable or disable badges for different sections. Badges help users identify pending actions and notifications.',
      ENABLE_BADGE_COUNT_TO_CONFIGURE: "Enable 'Show Badge Count' to configure individual badges",
      PLEASE_SELECT_LOCATION_TO_CONFIGURE_BADGES: 'Please select a location to configure badges',
      LOCATION_REQUIRED: 'Location is required',

      ANY: 'Any',
      MANUAL: 'Manual',
      AUTO: 'Auto',
      MONTHLY_QUERY_KWP: 'Monthly Query (KWP)',
      MONTHLY_QUERY: 'Monthly Query',
      CSV_UPLOAD: 'CSV Upload',

      QUERY_TYPE_TOOLTIP: 'Select the query type.',
      EMAIL_TOOLTIP: 'Email address for contact or notifications.',
      LIST_TYPE_TOOLTIP: 'Choose the list type.',
      INQUIRY_FORM_TOOLTIP: 'Configure the inquiry form.',
      DOMAIN_TOOLTIP: 'Associated domain name.',
      WEBSITE_TOOLTIP: 'Associated website URL.',
      DOMAIN_RATE_TOOLTIP: 'Domain rating score.',
      SEO_RANK_TOOLTIP: 'Search engine ranking.',
      TITLE_TOOLTIP: 'Display title.',
      NG_WORD_STATUS_TOOLTIP: 'Status of NG word filtering.',
      EMAIL_TYPE_TOOLTIP: 'Associated email type.',
      INITIAL_SENTIMENT_TOOLTIP: 'Initial sentiment evaluation.',
      GENERAL_SENTIMENT_TOOLTIP: 'Overall sentiment evaluation.',

      // Download CSV
      LOCAL_KEYWORD_CSV_LIST: 'Local Keyword CSV Exports',
      DOWNLOAD_CREDIT_HISTORY: 'Download Credit History',
      CREDIT_HISTORY_CSV_LIST: 'Credit History CSV Exports',
      MANAGE_YOUR_CREDIT_HISTORY_EXPORTS: 'Manage your credit history export files',
      CREATE_NEW_CSV: 'Create New CSV',
      NO_CSV_FOUND_DESC: "You haven't exported any credit history yet. Create your first export to get started.",
      CREATE_YOUR_FIRST_CSV: 'Create Your First CSV',
      PERIOD: 'Period',
      FILE_SIZE: 'File Size',
      TOTAL_FILES: 'Total Files',
      READY_TO_DOWNLOAD: 'Ready to download',
      IN_PROGRESS_FILES: 'In progress',
      CREATE_NEW_EXPORT: 'Create New Export',
      CSV_EXPORT_HELP: 'CSV files are kept for 30 days',
      SELECTED_PERIOD: 'Selected Period',
      CHANGE_START_MONTH: 'Change Start Month',
      CSV_FILE_INFO: 'CSV File Information',
      CSV_FILE_DETAILS: 'All credit transactions including time stamps and details are included.',
      EXPORT_YOUR_CREDIT_DATA: 'Export your credit data',
      DATA_WILL_START_FROM: 'Data will start from',
      COMPLETE_DATA: 'Complete data',
      SECURE_EXPORT: 'Secure export',
      INSTANT_PROCESSING: 'Instant processing',
      SECURE_DOWNLOAD: 'Secure download',

      MONTH: 'Month',
      YEAR: 'Year',

      // Email Replies
      EMAIL_CONVERSATION: 'Email Conversation',
      FROM: 'From',
      NO_MESSAGES: 'No messages found',
      REPLY_TO: 'Reply To',
      UNTRACK_EMAILS: 'Untrack Emails',
      CONFIRM_UNTRACK_EMAILS: 'Are you sure you want to untrack this email conversation? This action cannot be undone.',
      EMAIL_UNTRACKED: 'Email conversation untracked successfully',
      FAILED_TO_UNTRACK_EMAIL: 'Failed to untrack email conversation',
      SELECT_RECIPIENT: 'Select Recipient',
      LOADING_RECIPIENTS: 'Loading recipients...',
      NEW: 'New',
      SEARCH_BY_SENDER_RECEIVER_OR_SUBJECT: 'Search by sender, receiver, or subject',
      NO_EMAIL_REPLIES_FOUND: 'No email replies found',
      SELECT: 'Select',
      CONFIRM_ATTACH_EMAIL_REPLY_TO_ATTACK_LIST:
        'Are you sure you want to attach the selected email reply to the attack list? This will associate the email conversation with the attack list for better tracking and management.',
      EMAIL_REPLY_ATTACHED: 'Email reply attached to attack list successfully',
      FAILED_TO_ATTACH_EMAIL_REPLY: 'Failed to attach email reply to attack list',
      ARE_YOU_SURE: 'Are you sure?',
      SEND_REPLY: 'Send Reply',
      SEND_REPLY_TOOLTIP: 'Send a reply email directly to the sender of this message.',
      ME: 'Me',
      REPLY: 'Reply',
      TYPE_YOUR_REPLY: 'Type your reply here...',
      DELETED: 'Deleted',
      SEND_EMAIL: 'Send Email',
      ATTACH_TO_ATTACK_LIST: 'Attach to Attack List',
      LOADING_ATTACK_LIST: 'Loading attack list...',
      SEARCH_BY_SITE_NAME_OR_URL: 'Search by site name or URL',
      ATTACH_SUCCESS: 'Attached successfully',
      ATTACH_ERROR: 'Failed to attach',
      CONFIRM_DELETE_EMAIL_REPLY: 'Are you sure you want to delete this email reply? This action cannot be undone.',
      EMAIL_REPLY_DELETED: 'Email reply deleted successfully',
      FAILED_TO_DELETE_EMAIL_REPLY: 'Failed to delete email reply',
      UNDO_SUCCESSFUL: 'Undo successful',
      UNDO_FAILED: 'Failed to undo action',
      ARE_YOU_SURE_TO_UNDO_ATTACHING_EMAIL_REPLY:
        'Are you sure you want to undo attaching this email reply to the attack list? This will disassociate the email conversation from the attack list.',

      // Password Update
      UPDATE_PASSWORD: 'Update Password',
      CURRENT_PASSWORD: 'Current Password',
      PASSWORD_UPDATED_SUCCESSFULLY: 'Password updated successfully',
      FAILED_TO_UPDATE_PASSWORD: 'Failed to update password. Please check your current password and try again.',
      ENTER_NEW_PASSWORD: 'Enter new password',
      ENTER_CURRENT_PASSWORD: 'Enter current password',
      PASSWORD_UPDATE_FAILED: 'Failed to update password. Please check your current password and try again.',
      LOCATION_SCHEDUALR_CONFIGURATION: 'Form Attack Schedule Settings',
      LOCATION_WISE_SCHEDULER_CONFIG_TITLE: 'Form Attack Schedule Settings',
      LOCATION_WISE_SCHEDULER_CONFIG_DESCRIPTION:
        'Set allowed days, start/end time, and timezone for automated form attacks per location.',
      ALLOWED_DAYS: 'Allowed Days',
      START_TIME: 'Start Time',
      END_TIME: 'End Time',
      TIMEZONE: 'Timezone',
      SCHEDULER_CONFIGURATION_UPDATED: 'Scheduler configuration updated successfully.',
      ERROR_LOADING_CONFIGURATIONS: 'Error loading configuration.',
      SUNDAY: 'Sun',
      MONDAY: 'Mon',
      TUESDAY: 'Tue',
      WEDNESDAY: 'Wed',
      THURSDAY: 'Thu',
      FRIDAY: 'Fri',
      SATURDAY: 'Sat',
      SELECT_TIMEZONE: 'Select Timezone',
      CACHE_CLEAR: 'Cache Clear',
      CLEAR_ALL_CACHE: 'Clear all caches.',

      // Form attact settings
      SCHEDULE_SETTINGS: 'Schedule Settings',
      VALIDATING: 'Validating...',
      SCHEDULE_VALID: 'Schedule Valid',
      SCHEDULE_INVALID: 'Schedule Invalid',
      VALIDATE_SCHEDULE: 'Validate Schedule',
      PLEASE_CONFIGURE_SCHEDULE_FIRST: 'Please configure the schedule first',
      SCHEDULE_VALIDATION_SUCCESS: 'Schedule validation completed successfully',
      SCHEDULE_VALIDATION_FAILED: 'Schedule validation failed. Please check your settings',
      SCHEDULER_CONFIGURATION_HELP_TEXT:
        'These settings determine when form submissions can be processed from this location',
      PLEASE_SELECT_LOCATION_TO_CONFIGURE_SCHEDULE: 'Please select a location to configure schedule settings',
      END_TIME_MUST_BE_AFTER_START_TIME: 'End time must be after start time',

      // SMTP Configuration
      SMTP_CONFIGURATION: 'SMTP Configuration',
      CONFIGURE_SMTP_SETTINGS_FOR_EMAIL_DELIVERY:
        'Configure SMTP settings for email delivery. Templates must exist with the email address you want to configure.',
      LOADING_CONFIGURATION: 'Loading configuration...',
      SMTP_SETTINGS: 'SMTP Settings',
      MAILER: 'Mailer',
      SMTP_HOST: 'SMTP Host',
      PORT: 'Port',
      ENCRYPTION: 'Encryption',
      USERNAME: 'Username',
      FROM_ADDRESS: 'From Address',
      FROM_NAME: 'From Name',
      TEST_CONNECTION: 'Test Connection',
      SAVE_CONFIGURATION: 'Save Configuration',
      TESTING: 'Testing...',
      CONNECTION_SUCCESSFUL: 'Connection Successful',
      CONNECTION_FAILED: 'Connection Failed',
      CONNECTION_TEST_SUCCESS: 'Connection test completed successfully',
      CONNECTION_TEST_FAILED: 'Connection test failed. Please check your settings',
      SMTP_CONFIGURATION_UPDATED_SUCCESS: 'SMTP configuration updated successfully',
      HOST_REQUIRED: 'Host is required',
      PORT_REQUIRED: 'Port is required',
      USERNAME_REQUIRED: 'Username is required',
      FROM_ADDRESS_REQUIRED: 'From address is required',
      FROM_NAME_REQUIRED: 'From name is required',
      SMTP_CONFIGURATION_HELP_TEXT: 'These settings will be used for all email communications from this location',
      NO_LOCATION_SELECTED: 'No Location Selected',
      PLEASE_SELECT_LOCATION_TO_CONFIGURE_SMTP: 'Please select a location to configure SMTP settings',
      SMTP: 'SMTP',
      SENDMAIL: 'Sendmail',
      PHP_MAIL: 'PHP Mail',
      SIMPLE_MAIL_TRANSFER_PROTOCOL: 'Simple Mail Transfer Protocol',
      SENDMAIL_PROGRAM: 'Sendmail program',
      PHP_MAIL_FUNCTION: 'PHP mail() function',
      TLS: 'TLS',
      SSL: 'SSL',
      NONE: 'NONE',
      PORT_587: 'Port 587',
      PORT_465: 'Port 465',
      PORT_25: 'Port 25',

      SUGGESTION_KEYWORD: 'Suggestion Keyword',

      // Email verification configration
      EMAIL_VERIFICATION: 'Email Verification',
      EMAIL_VERIFICATION_DESCRIPTION:
        'Verify your email address to send replies. Click the Verify button to complete the process.',
      VERIFICATION_STATUS: 'Verification Status',
      LOCATION: 'Location',
      VERIFIED: 'Verified',
      INITIATED: 'In Progress',
      NO_VERIFICATION_DATA: 'No verification data available',
      NO_VERIFICATION_DATA_DESCRIPTION: 'Templates with email addresses will appear here',
      VIEW_DETAILS: 'View Details',
      VERIFY_EMAIL: 'Verify Email',
      RETRY_VERIFICATION: 'Retry Verification',
      VERIFICATION_IN_PROGRESS: 'Verification in progress. Please check your email.',
      VERIFICATION_EMAIL_SENT_TO: 'Verification email sent to {{email}}',
      ERROR_FETCHING_VERIFICATION_LIST: 'Error fetching verification list',
      VIEW_DETAILS_FEATURE_COMING_SOON: 'View details feature coming soon',
      EMAIL_VERIFICATION_DETAILS: 'Associated Template Details',
      TEMPLATE_ID: 'Template ID',
      SENDING: 'Sending...',
      EMAIL_VERIFIED_SUCCESS: 'This email address has been successfully verified.',
      EMAIL_VERIFICATION_PENDING_HELP:
        'This email address is pending verification. Click the Verify button to send a verification email.',
      EMAIL_VERIFICATION_FAILED_HELP: 'Verification failed. Click Retry to send another verification email.',
      PLEASE_CHECK_YOUR_EMAIL: 'Please check your email',
      VERIFICATION_CONFIRMATION_MESSAGE:
        'If you click the Verify button, a verification email will be sent to your email address. To complete the verification, please click the link provided in the email body.',
      VERIFY: 'Verify',
      VERIFY_EMAIL_CONFIRM: 'Send verification email?',
      RETRY_VERIFICATION_CONFIRM: 'Retry verification?',
      VIEW_DETAILS_TOOLTIP: 'View template details',
      VERIFY_EMAIL_TOOLTIP: 'Send verification email to this address',
      RETRY_VERIFICATION_TOOLTIP: 'Retry sending verification email',
      TEMPLATE_DETAILS: 'Template Details',
      BASIC_INFORMATION: 'Basic Information',
      CONTACT_INFORMATION: 'Contact Information',
      ADDRESS_INFORMATION: 'Address Information',
      DEPARTMENT: 'Department',
      INQUIRE_TEMPLATES: 'Inquire Templates',
      REPLY_TEMPLATES: 'Reply Templates',
      ERROR_FETCHING_TEMPLATE_DETAILS: 'Error fetching template details',
      UNTRACK_EMAILS_DESCRIPTION:
        'These are untracked emails that are not automatically associated with any website in the list. You need to attach each email to the appropriate website. Once attached, the email conversations will be tracked automatically.',

      // Propose Articles
      PROPOSE_ARTICLES: 'Propose Articles',
      PROPOSE_ARTICLES_DESCRIPTION:
        'Extract articles from your SEO owner site and manage generated proposal history per location.',
      EXTRACTED_ARTICLES: 'Extracted Articles',
      PROPOSAL_HISTORY: 'Proposal History',
      EXTRACTED_ARTICLES_PLACEHOLDER:
        'Extracted article URLs, titles, and headings for this location will appear here.',
      PROPOSAL_HISTORY_PLACEHOLDER: 'Generated proposal results and email replies for this location will appear here.',
      PROPOSE_ARTICLES_SELECT_LOCATION_HINT: 'Please select a location to continue.',
      EXTRACTION_HISTORIES: 'Extraction Histories',
      SL: 'SL',
      SITE_URL: 'URL',
      ARTICLE_URL: 'Article URL',
      HEADING: 'Heading',
      OUTBOUND_HEADING: 'Outbound Heading',
      NO_EXTRACTION_HISTORIES: 'No extraction histories found.',
      EXTRACTION_ERROR: 'Error',
      ARTICLE_ENABLED: 'Article enabled.',
      ARTICLE_DISABLED: 'Article disabled.',
      BULK_ENABLE_ARTICLES: 'Enable Selected',
      BULK_DISABLE_ARTICLES: 'Disable Selected',
      BULK_DELETE_ARTICLES: 'Delete Selected',
      BULK_ARTICLES_ENABLED: '{{count}} article(s) enabled.',
      BULK_ARTICLES_DISABLED: '{{count}} article(s) disabled.',
      BULK_ARTICLES_DELETED: '{{count}} article(s) deleted.',
      SELECTED_COUNT: '{{count}} selected',
      ENABLED_STATUS: 'Enabled',
      FILTER_BY_ENABLED_STATUS: 'Status filter',
      FILTER_BY_EXTRACTION_HISTORY: 'Extraction site',
      EXTRACTED_ARTICLE_DETAILS: 'Article Details',
      EXTRACTED_ARTICLE_EDIT: 'Edit Article',
      ARTICLE_UPDATED: 'Article updated successfully.',
      ARTICLE_DELETED: 'Article deleted successfully.',
      DELETE_EXTRACTED_ARTICLE_CONFIRM: 'Are you sure you want to delete this extracted article?',
      BULK_DELETE_EXTRACTED_ARTICLES_CONFIRM:
        'Are you sure you want to delete {{count}} selected extracted article(s)? This cannot be undone.',
      DELETE_PROPOSAL_CONFIRM: 'Are you sure you want to delete this proposal history?',
      PROPOSAL_DELETED: 'Proposal deleted successfully.',
      PROPOSAL_CANNOT_EDIT_WHILE_RUNNING: 'Cannot edit while proposal generation is in progress.',
      PROPOSAL_CANNOT_DELETE_WHILE_RUNNING: 'Cannot delete while proposal generation is in progress.',
      CLEAR_PROPOSAL_HISTORY: 'Clear Proposal History',
      CLEAR_PROPOSAL_HISTORY_CONFIRM: 'Are you sure you want to delete all proposal history for this location?',
      PROPOSAL_HISTORIES_CLEARED: 'All proposal histories have been cleared.',
      LAST_CRAWLED_AT: 'Last Crawled At',
      NO_EXTRACTED_ARTICLES: 'No extracted articles found. Run an extraction to get started.',
      RUNNING: 'Running',
      EXTRACT_ARTICLES: 'Extract Articles',
      EXTRACT_ARTICLES_MODAL_TITLE: 'Heading Extraction Tool',
      EXTRACT_ARTICLES_MODAL_DESCRIPTION: 'Enter the site details below to scrape and extract article URLs.',
      EXTRACT_ARTICLES_STARTED: 'Article extraction has been started.',
      RECRAWL_STATUS: 'Recrawl Status',
      RECRAWL_START_TIME: 'Recrawl Start',
      RECRAWL_COMPLETED_AT: 'Recrawl Completed',
      RECRAWL_SITE: 'Recrawl Site',
      RECRAWL_SITE_CONFIRM: 'Re-crawl all articles from this site? This may take several minutes.',
      RECRAWL_STARTED: 'Site recrawl has been started.',
      RECRAWL_ARTICLE: 'Recrawl URL',
      ARTICLE_RECRAWLED: 'Article recrawled successfully.',
      NOT_RECRAWLABLE: 'Recrawl is only available after the initial extraction completes.',
      EXTRACT_DATA: 'Extract Data',
      EXTRACTING: 'Extracting...',
      EXTRACT_REGISTER_TEMPLATE_FIRST:
        'No homepage URL found for this location. Please register a user profile template first.',
      SITE_TYPE: 'Site Type',
      SITE_TYPE_OTHERS: 'Others',
      SITEMAP_URL: 'Sitemap URL',
      PROPOSAL_DATE: 'Proposal Date',
      TARGET_SITE: 'Target Site',
      PROPOSED_TITLE: 'Proposed Title',
      NO_PROPOSAL_HISTORY: 'No proposal history found.',
      PROPOSAL_HISTORY_DETAILS: 'Proposal History Details',
      PROPOSAL_HISTORY_LOCATION_ID: 'Location ID',
      PROPOSAL_HISTORY_ATTACK_LIST_ID: 'Attack List ID',
      PROPOSAL_HISTORY_MAIN_KEYWORD_ID: 'Main Keyword ID',
      PROPOSAL_HISTORY_EXTRACT_ARTICLE_ID: 'Extract Article ID',
      PROPOSAL_HISTORY_PROJECT_KEY: 'Project Key',
      PROPOSAL_HISTORY_TARGET_URL: 'Target URL',
      PROPOSAL_HISTORY_TARGET_NAME: 'Target Name',
      PROPOSAL_HISTORY_TARGET_TITLE: 'Target Title',
      PROPOSAL_HISTORY_TARGET_DESCRIPTION: 'Target Description',
      PROPOSAL_HISTORY_PROPOSAL_TEXT: 'Proposal Text',
      PROPOSAL_HISTORY_REVERSE_TEXT: 'Reverse Text',
      PROPOSAL_HISTORY_USED_HEADING: 'Used Heading',
      PROPOSAL_HISTORY_USED_HEADINGS: 'Used Headings',
      PROPOSAL_HISTORY_IS_PARTNER_SPECIFIED: 'Partner Specified',

      // Proposal email reply
      PROPOSAL_ALL_PROPOSALS: 'Generate Proposal',
      PROPOSAL_GROUP_SELECT: 'Proposal website',
      PROPOSAL_EXTRA_SITE_URL: 'Add another website URL',
      PROPOSAL_EXTRA_SITE_ADD: 'Generate for URL',
      PROPOSAL_EXTRA_SITE_INVALID_URL: 'Please enter a valid website URL.',
      FAILED_TO_LOAD_PROPOSAL_GROUP: 'Failed to load proposal websites.',
      PROPOSAL_ALREADY_GENERATED: 'View Proposal History',
      PROPOSAL_GENERATION_STARTED: 'Proposal generation has been started.',
      PROPOSAL_GENERATION_IN_PROGRESS: 'Generating the proposal. This may take a little time, so please check back later.',
      PROPOSAL_GENERATION_FAILED: 'Proposal generation failed.',
      PROPOSAL_STATUS_PENDING: 'generating',
      PROPOSAL_STATUS_FAILED: 'failed',
      PROPOSAL_RETRY: 'Retry proposal',
      PROPOSAL_GENERATION_COMPLETED: 'Proposal generation completed.',
      PROPOSAL_FIELD_UPDATED: 'Proposal field updated successfully.',
      PROPOSAL_DISPLAY: 'Display',
      PROPOSAL_REGENERATE_EMAIL: 'Regenerate Email',
      PROPOSAL_REGENERATE_INTRODUCTION: 'Regenerate Introduction',
      PROPOSAL_INSERT_INITIAL_REPLY: 'Insert Initial Reply',
      PROPOSAL_INSERT_NOT_YET_PUBLISHED: 'Insert Not Yet Published by Other Party',
      PROPOSAL_INSERT_ALREADY_PUBLISHED: 'Insert Already Published by Other Party',
      PROPOSAL_INSERT_FOLLOW_UP: 'Insert Follow-up',
      PROPOSAL_PUBLISHED_ARTICLE_URL: 'Published Article URL',
      PROPOSAL_PLACEMENT_LOCATION_TAG: 'Placement Location/Tag',
      PROPOSAL_DESIRED_PLACEMENT_URL: 'Desired Placement URL',
      PROPOSAL_PARTNER_INTERNAL_URLS: 'Partner Internal URLs',
      PROPOSAL_PARTNER_INTERNAL_URLS_SELECT: 'Select a partner article URL',
      PROPOSAL_UNABLE_TO_FETCH_TITLE: 'Unable to fetch title',
      OPEN_IN_NEW_TAB: 'Open in new tab',
      PROPOSAL_PUBLISHED_ARTICLE_TITLE: 'Published Article Title',
      PROPOSAL_INITIAL_REPLY: 'Initial Reply',
      PROPOSAL_NOT_YET_PUBLISHED: 'Not Yet Published by Other Party',
      PROPOSAL_ALREADY_PUBLISHED: 'Already Published by Other Party',
      PROPOSAL_FOLLOW_UP: 'Follow-up',
      PROPOSAL_CLICK_TO_INSERT: 'Click to insert into reply body',
      PROPOSAL_CONTENT_EMPTY: 'No content available to insert.',
      FAILED_TO_LOAD_PROPOSAL_DATA: 'Failed to load proposal data.',
      PROPOSAL_REGENERATE_EMAIL_STARTED: 'Email regeneration started.',
      PROPOSAL_REGENERATE_INTRO_STARTED: 'Introduction regeneration started.',
      PROPOSAL_REGENERATE_EMAIL_COMPLETED: 'Email bodies regenerated successfully.',
      PROPOSAL_REGENERATE_INTRO_COMPLETED: 'Introduction and email bodies regenerated successfully.',
      FIELD: 'Field',
      CONTENT: 'Content',

      // Dashbaord
      DASHBOARD: 'Dashboard',
      SEO_SCORE: 'SEO Score',
      DOMAIN_RATING: 'Domain Rating',
      ARTICLES_CREATED: 'Articles Created',
      FORMS_SENT: 'Forms Sent',
      BACKLINKS_ACQUIRED: 'Backlinks Acquired',
      REVIEW_ALL: 'Review All',
      AUTO_SEND: 'Auto Send',
      MANUAL_SEND: 'Manual Send',
      MANAGEMENT: 'Management',
      CHECK_EMAIL: 'Check Email',
      THIS_MONTH: 'this month',
      NOT_FETCHED_YET: 'Not fetched yet',
      SEO_PERFORMANCE: 'SEO Performance',
      GSC_DISCONNECTED: 'GSC Disconnected',
      LINK_ACCOUNT: 'Link Account',
      DATA_FEED_ACTIVE: 'Data Feed Active',
      CLICKS: 'Clicks',
      IMPRESSIONS: 'Impressions',
      AVG_CTR: 'Avg CTR',
      NO_DATA_AVAILABLE: 'No Data Available',
      START_DATE: 'Start Date',
      END_DATE: 'End Date',
      LAST_7_DAYS: 'Last 7 days',
      LAST_30_DAYS: 'Last 30 days',
      LAST_3_MONTHS: 'Last 3 months',
      LAST_MONTH: 'Last month',
      DATE_RANGE: 'Date Range',
      SELECT_DATE_RANGE: 'Select date range',
      SELECT_DATES: 'Select Dates',
      CLICKS_IMPRESSIONS: 'Clicks / Impressions',
      CTR_PERCENT: 'CTR (%)',
      RESET_TO_CURRENT_MONTH: 'Reset to current month',
      TRY_DIFFERENT_DATE_RANGE: 'Try selecting a different date range',
      COUNT: 'Count',
      ADDITIONAL_INFO: 'Additional Information',
      TOP_QUERIES: 'Top Queries',
      TOP_PAGES: 'Top Pages',
      COUNTRY: 'Country',
      DEVICES: 'Devices',
      QUERY: 'Query',
      PAGE: 'Page',
      KEY: 'Key',
      CTR: 'CTR',
      FETCH_DATE: 'Fetch Date',
      LOADING_MORE: 'Loading more...',
      ARTICLE_CREATION_SETTINGS: 'Article Creation Settings',
      BACKLINK_SETTINGS: 'Backlink Settings',
      AUTHOR_INFO_DESCRIPTION:
        'Please configure the author information to be used for article creation.\nArticles will be generated based on the configured content.',
      AUTHOR_NAME: 'Author Name',
      AUTHOR_TEXT: 'Author Text',
      BUSINESS_NAME: 'Business Name',
      TEL: 'Phone number',
      SERVICE_AREA: 'Service Area',
      NEARBY_STATION: 'Nearby Station',
      BUSINESS_TYPE: 'Business Type/Category',
      AUTHOR_INFORMATION: 'Author Information',
      ARTICLE_THUMBNAIL: 'Article Thumbnail',
      DO_NOT_USE: 'Do not use',
      AUTHOR_INFO_RESTRICTION_NOTE: 'You Need To Register Author Information to use them in Article creation',
      SAVE_AUTHOR_PROFILE: 'Save Author Profile',
      ARTICLE_AUTHOR_PROFILE_SAVED: 'Author Profile saved successfully.',
      UPDATED_AT: 'Updated At',
      ADD_MORE_SITE_BTN: 'Add More websites',
      ADD_MORE_SITE_TITLE: 'Add more websites',
      ADD_MORE_SITE_DESC:
        'You are about to add {{limit}} websites at once ({{credit}} credits will be deducted). Are you sure you want to proceed?',
      ADD_MORE_SITE_DESC_KEYWORD:
        'If there are fewer than {{limit}} websites in the remaining website list, please process "Add Main Keyword" first before adding more sites.',
      ADD_MORE_WEBSITES_FAILED: 'Failed to add more websites. Please try again later.',
      WEBSITE_LIMIT_ALERT:
        'You have reached the maximum number of websites allowed. Please add some websites by clicking the "Add More websites" button to continue.',
      PARTIAL: 'Partial',
      EXACT: 'Exact',
      FILTERS_ACTIVE: 'filters active',
      CLEAR_ALL: 'Clear All',
      APPLY_FILTERS: 'Apply Filters',
      EXCLUDE_DOMAINS_PLACEHOLDER: `Partial: excludes any domain containing the text (e.g., "test" → test.com, support.test.com)
Exact: excludes the root domain + all subdomains (e.g., "test.com" → test.com, www.test.com, support.test.com)`,
      EXCLUDE_DOMAINS_HELP: 'Enter domain names separated by commas',
      BUSINESS_AUTHOR_INFORMATION_USED: 'Business | Author Information Used',
      CONFIRMATION_ALERT_CREDIT_BADGE: 'Credit deduction applies',
      WEBSITE_CANCEL_ALERT: 'Cancel',
      WEBSITE_CONFIRM_ALERT: 'Confirm',
      WEBSITE_ADD_MAIN_KEYWORD: 'Add Main Keyword',
      ADD_ALL_SITE_TITLE: 'Add All Websites',
      ADD_ALL_SITE_DESC: 'You are about to add {{count}} websites at once. Are you sure you want to proceed?',
      ADD_MORE_WEBSITES_SUCCESS: 'Additional websites have been added successfully!',

      // Sub keyword
      ADD_SUB_KEYWORD: 'Add Sub Keyword',
      ADD_SUB_KEYWORD_DESC: 'Enter a sub‑keyword (business keyword) for the main keyword.',
      SUB_KEYWORD: 'Sub Keyword',
      SUB_KEYWORD_PLACEHOLDER: 'e.g. affordable SEO services',
      CREATE: 'Create',
      SUB_KEYWORD_CREATED_SUCCESS: 'Sub keyword created successfully',
      SUB_KEYWORD_CREATE_FAILED: 'Failed to create sub keyword',
      ARTICLE_GENERATION: 'Article Generation',
      BACKLINK_BUILDING: 'Backlink Building',
      GENERATE: 'Generate',
      RETRY_GENERATION: 'Retry generation',
      GENERATE_NOW: 'Generate now',
      ADD_YOUR_FIRST_KEYWORD: 'Add your first keyword to get started',
      ADD_SUB_KEYWORD_TOOLTIP: 'Add sub keyword for {{keyword}}',
      CONFIRM_SUB_KEYWORD: 'Confirm Sub Keyword',
      ARE_YOU_SURE_YOU_WANT_TO_REGISTER_SUB_KEYWORD: 'Are you sure you want to register this sub‑keyword?',
      PLEASE_REVIEW_BEFORE_REGISTERING: 'Please review the information before registering',
      THIS_ACTION_WILL_CONSUME_CREDITS: 'This action will consume credits from your account',
      CONFIRM_REGISTRATION: 'Confirm Registration',
      SUB_KEYWORD_HINT: 'Enter a specific keyword related to your main keyword',
      SEARCH_PREFECTURE: 'Search Prefectures',
      SEARCH_CITY: 'Search Cities',
      SUB_KEYWORDS: 'Sub Keywords',
      SUGGESTED: 'Suggested',
      VIEW_SUB_KEYWORD_DETAILS: 'View sub keyword details',
      DELETE_SUB_KEYWORD: 'Delete sub keyword',
      LOADING_SUB_KEYWORDS: 'Loading sub keywords...',
      NO_SUB_KEYWORDS: 'No sub keywords added yet',
      ADD_FIRST_SUB_KEYWORD: 'Add your first sub keyword',
      ARE_YOU_SURE_DELETE_SUB_KEYWORD: 'Are you sure you want to delete this sub keyword?',
      STARTED: 'Started',
      FAIL_REASON: 'Fail Reason',
      ARTICLE_GENERATION_IN_PROGRESS: 'Article generation in progress',
      ARTICLE_GENERATION_NOT_STARTED: 'Article generation not started',
      SUB_KEYWORD_REGISTRATION_INFO_TITLE: 'Sub Keyword Registered Successfully!',
      SUB_KEYWORD_REGISTRATION_INFO_HEADLINE: 'Your sub-keyword has been successfully registered!',
      SUB_KEYWORD_REGISTRATION_INFO_STEP_1: 'You can now generate content for this sub-keyword.',
      SUB_KEYWORD_REGISTRATION_INFO_STEP_2: 'Generating content for this sub-keyword will consume credits.',
      SUB_KEYWORD_REGISTRATION_INFO_STEP_3: 'You can generate content at any time by clicking the generate button.',
      GOT_IT: 'Got It',

      // Sub Keyword Select
      SELECT_SUB_KEYWORD: 'Select Sub Keyword',
      NO_SUB_KEYWORD_FOUND: 'No sub-keywords found',
      SELECT_LOCATION_FIRST: 'Please select a location first',
      SELECT_MAIN_KEYWORD_FIRST: 'Please select a main keyword first',
      ARTICLE_MAIN_KEYWORD: 'Main Keyword',
      ARTICLE_SUB_KEYWORD: 'Sub Keyword',
      KEYWORD_INPUT_TYPE: 'KW Input Type',

      // Sidebar routes
      BACKLINKS: 'Backlinks',
      SETTINGS: 'Settings',

      BIZ_ARTICLES: 'Business Articles',
      LOCAL_ARTICLES: 'Local Articles',
      REWRITE_ARTICLES: 'Rewrite Articles',
      CONFIRM_ARTICLES: 'Confirm Articles',
      CREATE_ARTICLES: 'Create Articles',

      CHECK_SEND_RESULTS: 'Check Send Results',
      CHECK_MAILS: 'Check Mails',
      MANAGE_BACKLINKS: 'Manage Backlinks',
      MANUAL_SUBMISSION: 'Manual Submission',

      COMMON: 'Common',
      MY_SITES: 'My Websites',
      KEYWORDS: 'Keywords',
      PROFILE: 'Profile',
      NOTIFS: 'Notifications',

      ARTICLE_MANAGEMENT: 'Article Management',
      BRIDGE: 'BridgeBooks',
      PLATFORM_CONFIG: 'Platform Config',

      ATTACH_EMAIL: 'Attach Email',

      CLICK_TO_VIEW: 'Click to view',

      WEBSITE_URL: 'Website URL',
      ADDING: 'Adding...',
      YES_ADD_WEBSITE: 'Yes, Add Website',
      ONLY_ONE_WEBSITE_ALLOWED: 'Only one website can be added per location',
      ACTIVATING: 'Activating...',
      ADDED_ON: 'Added on',
      ADD_YOUR_FIRST_WEBSITE: 'Add your first website to get started',
      PLEASE_WAIT: 'Please wait',
      LOADING_GSC_STATUS: 'Loading GSC status...',
      ACCOUNT_CONNECTED: 'Your Google Search Console account is connected',
      REFRESH_STATUS: 'Refresh status',
      CONNECT_TO_GSC_MESSAGE:
        'Connect your Google Search Console account to automatically verify and manage your websites',

      STOP_FORM_ATTACK: 'Stop Form Attack',
      STOP_FORM_ATTACK_DESCRIPTION:
        'Are you sure you want to stop the form attack? If you confirm, all websites that have not yet started will be stopped',
      STOP_FORM_ATTACK_SUCCESS: 'Form attack stopped successfully',
      STOP_FORM_ATTACK_FAILED: 'Failed to stop form attack',

      // Password Update
      CONFIRM_PASSWORD: 'Confirm Password',
      PASSWORD_SECURITY_MESSAGE: 'Secure your account with a strong password',
      PASSWORD_STRENGTH: 'Password strength',
      WEAK: 'Weak',
      MEDIUM: 'Medium',
      STRONG: 'Strong',
      UPDATING: 'Updating...',
      PASSWORD_REQUIREMENTS: 'Use a strong password with at least 8 characters including letters and numbers',

      // Profile Settings
      ACCOUNT_SETTINGS: 'Account Settings',
      MANAGE_SECURITY_SETTINGS: 'Manage your security settings',
      EDITOR_BOLD: 'Bold',
      EDITOR_ITALIC: 'Italic',
      EDITOR_LINK: 'Link',
      EDITOR_UNLINK: 'Unlink',
      EDITOR_BULLET_LIST: 'Bullet List',
      EDITOR_NUMBERED_LIST: 'Numbered List',
      EDITOR_ENTER_URL: 'Enter URL (e.g. https://example.com):',
      EMAIL_FORWARDING_TITLE: 'Email Forwarding Required',
      EMAIL_FORWARDING_DESCRIPTION:
        'Please set up forwarding in your mailer to receive replies directly in your panel.',
      FORWARDING_ADDRESS: 'Forwarding Address',
      I_HAVE_SET_IT_UP: "I've set it up",
      CONFIGURE_LATER: 'Configure later',
      INQUIRY_BODY_GENERATION_TITLE: 'Inquiry body generation',
      INQUIRY_BODY_GENERATION_DESCRIPTION:
        'Automatically generate the inquiry body based on the content of the registered template',
      INQUIRY_BODY_GENERATION_WARNING:
        'The inquiry body has been generated by AI and may contain errors or inaccurate information.\nPlease review and verify the content before use.',
      CHANGE_RECEIPINT: 'Change Recipient',
      CLICK_TO_FILTER_BY_LOCATION: 'Click to filter by location',

      NOT_FOUND: 'Not Found',
      NOT_FOUND_NEW: 'Not Found',
      NOT_FOUND_NG: 'Not Found',
      FOUND_NG: 'Found',
      CANCEL_FOR_ADD_MORE_SITE: 'Cancel',
      CONFIRM_FOR_ADD_MORE_SITE: 'Confirm',
      UNTRACKED_REPLIES: 'Untracked Replies',
      COMMON_DOMAIN_FILTER: 'Domain Exclude Settings',
      COMMON_DOMAIN_FILTER_TOOLTIP:
        'If enabled, common domains (Gmail, Yahoo, etc.) are filtered out from the forecast. If disabled, they will be included.',
      SEARCH_EMAILS_OR_SUBJECT: 'Search by email or subject...',
      MESSAGE_BODY: 'Message Body',
      TOTAL_ITEMS_FOUND: 'Total {{total}} items found',
      SENDER: 'Sender',
      RECEIVER: 'Receiver',
      BODY: 'Body',
      ENTRIES_FOUND: 'entries found',
      LOADING_DATA: 'Loading Data',
      PARTICIPANTS: 'Participants',
      'SUBJECT_&_CONTENT': 'Subject & Content',
      SUBJECT_PREVIEW: 'Subject Preview',
      MESSAGE_CONTENT: 'Message Content',
      COPY_BODY: 'Copy Body',
      NO_REPLIES_FOUND: 'No replies found',
      SELECT: 'Select',
      ATTACH_TO_ATTACK_LIST: 'Attach to Attack List',
      ATTACHING: 'Attaching...',
      FORECAST: 'Forecast',
      SELECT_ENTRY: 'Manual Selection',
      ATTACH_EMAIL_CONFIRMATION: 'Confirm Attachment',
      ARE_YOU_SURE_TO_ATTACH: 'Are you sure you want to attach this email to the selected website?',
      YES_ATTACH: 'Yes, Attach',
      SELECT_AN_ENTRY_TO_ASSOCIATE_WITH_THIS_EMAIL: 'Select an entry to associate with this email',
      ATTACHED_SUCCESSFULLY: 'Email attached successfully!',
      FAILED_TO_ATTACH: 'Failed to attach email',
      ERROR_ATTACHING_EMAIL: 'An error occurred while attaching the email',
      UNTRACK_ATTACH_SECURITY_REJECTED:
        'This email cannot be attached because it does not belong to this location or receiving address.',
      AI_FORECAST: 'Forecast',
      EMAIL_BODY: 'Email Body',
      MANUAL_SELECTION: 'Manual Selection',
      ANALYZING_CONVERSATION: 'Analyzing Conversation...',
      FINDING_PROBABLE_MATCHES: 'Finding probable matches from your attack list',
      NO_SUGGESTIONS_FOUND: 'No Suggestions Found',
      TRY_MANUAL_SELECTION_TAB: 'Try searching in the Manual Selection tab',
      LOADING_ENTRIES: 'Loading Entries...',
      NO_RESULTS_FOUND: 'No results found for your search',
      MESSAGE_DETAILS: 'Message Details',
      COPY_MESSAGE: 'Copy Message',
      COPIED: 'Copied!',
      SEE_MORE: 'see more',
      DETACH_EMAIL: 'Detach Email',
      CONFIRM_DETACH_EMAIL: 'Are you sure you want to detach this email? It will be returned to the Untracked list.',
      DETACHED_SUCCESSFULLY: 'Email detached successfully.',
      DETACH_FAILED: 'Failed to detach email.',
      DETACH_CONVERSATION_TITLE: 'Detach Conversation',
      DETACH_CONVERSATION_DESCRIPTION:
        'Are you sure you want to detach this conversation from the current attack list item? This will disassociate the email thread.',
      CONFIRM_DETACH: 'Confirm Detach',
      DETACH_SUCCESS: 'Conversation detached successfully',
      DETACH_INFO_MISSING: 'Required information to detach is missing',
      OTHER_COMPANY_BRAND_INFO: 'Other company brand information',
      INCLUDE: 'Include',
      EXCLUDE_BRAND_PROMPT_TEXT:
        '実在する社名、病院名、店名、製品・サービス名を内容に含めないでください。ただし著者情報が出力されている場合は、必ず残してください。',
      WAITING_FOR_RETRY: 'Waiting for retry',
      ARTICLES_HEADER_KEYWORD_TOOLTIP: 'Specifies the main keyword targeted for SEO analysis.',
      ARTICLES_HEADER_STATUS_TOOLTIP: 'Indicates the current stage of the article generation process.',
      ARTICLES_HEADER_TYPE_TOOLTIP: 'Categorizes the keyword based on user intent or search type.',
      ARTICLES_HEADER_POSITION_TOOLTIP: 'The current ranking of your website for this keyword.',
      ARTICLES_HEADER_MY_WEBSITE_POSITION_TOOLTIP: "Your website's current ranking in search results for this keyword.",
      ARTICLES_HEADER_SEARCH_VOLUME_TOOLTIP: 'Estimated number of monthly searches for this keyword.',
      ADDITIONAL_INFO_KEY_QUERY_TOOLTIP: 'The search query that users typed into Google.',
      ADDITIONAL_INFO_KEY_PAGE_TOOLTIP: 'The URL of the page that appeared in search results.',
      ADDITIONAL_INFO_KEY_COUNTRY_TOOLTIP: 'The country from which the search was performed.',
      ADDITIONAL_INFO_KEY_DEVICE_TOOLTIP: 'The type of device used for the search (desktop, mobile, or tablet).',
      ADDITIONAL_INFO_CLICKS_TOOLTIP: 'Number of clicks recorded in Google Search Console.',
      ADDITIONAL_INFO_IMPRESSIONS_TOOLTIP: 'Number of times your page appeared in search results.',
      ADDITIONAL_INFO_CTR_TOOLTIP: 'Click-through rate: clicks divided by impressions.',
      ADDITIONAL_INFO_POSITION_TOOLTIP: 'Average position in Google search results (lower is better).',
      ADDITIONAL_INFO_FETCH_DATE_TOOLTIP: 'Date when data was fetched from Google Search Console.',
      ADDITIONAL_INFO_UPDATED_AT_TOOLTIP: 'Date and time when this record was last updated.',
      ARTICLES_HEADER_TREASURE_KEYWORD_RATING_TOOLTIP:
        'A rating indicating how valuable or "treasure-like" this keyword is for SEO.',
      ARTICLES_HEADER_KEYWORD_DIFFICULTY_TOOLTIP: 'A score representing how hard it is to rank for this keyword.',
      ARTICLES_HEADER_CONVERSION_NEAR_SCORE_TOOLTIP:
        'Score indicating the probability of conversion for visitors from this keyword.',
      ARTICLES_HEADER_KW_RELEVANCE_TOOLTIP:
        'Indicates how relevant this keyword is to your business for article targeting.',
      ARTICLES_HEADER_AI_OVERVIEW_TOOLTIP: 'Indicates if an AI Overview (SGE) is present in the SERP.',
      ARTICLES_HEADER_RELATED_QUESTIONS_TOOLTIP: 'Indicates if "People Also Ask" questions are present in the SERP.',
      ARTICLES_HEADER_MEO_TOOLTIP: 'Indicates if Map Pack/Local results are present for this keyword.',
      ARTICLES_HEADER_TITLE_TOOLTIP: 'The title of the generated article.',
      ARTICLES_HEADER_URL_TOOLTIP: 'The destination URL where the article is or will be published.',
      INDEX_REQUEST_POPUP_DISPLAY: 'Display of Index Request Popup',
      INDEX_REQUEST_POPUP_TOOLTIP:
        'This setting applies per location and controls whether the index guide popup is shown on article detail.',
      POSTED_ARTICLE_URL: 'Posted Article URL',
      INDEX_REQUEST: 'Index Request',
      INDEX_GUIDE_MESSAGE:
        'When an article has been published, submitting a registration request to Google for the article URL can lead to better results, so please proceed with the index submission request.',
      INDEX_GUIDE_PENDING_MESSAGE:
        'Index submission is still pending. After publishing the article to your CMS, register the article URL and proceed with the index submission request in Google Search Console.',
      PROCEED_TO_GSC_INDEX_PAGE: "Proceed to Google's registration request page",
      INDEX_GUIDE_IMAGE_ALT: 'Google Search Console URL Inspection guide',
      GSC_INDEX_LINK_ERROR: 'Failed to open Google Search Console index page.',
      POSTED_ARTICLE_URL_SAVED: 'Posted article URL saved successfully.',
      INDEX_GUIDE_PANEL_TITLE: 'Google Index Guide',
      INDEX_SUBMISSION: 'Index submission',
      INDEX_SUBMISSION_COMPLETED: 'Index submission completed',
      INDEX_SUBMISSION_PENDING: 'Not submitted',
      INDEX_SUBMISSION_REQUIRES_URL: 'Register posted article URL first',
      ARTICLES_HEADER_INDEX_SUBMISSION_TOOLTIP: 'Mark when you submitted the URL in Google Search Console',
      VERIFY_WORDPRESS_POST: 'Verify WordPress post',
      WP_POST_STATUS_LABEL: 'WordPress status',
      WP_POST_STATUS_DRAFT: 'Draft',
      WP_POST_STATUS_PUBLISHED: 'Published',
      WP_POST_STATUS_SCHEDULED: 'Scheduled',
      WP_POST_STATUS_DELETED: 'Deleted',
      WP_POST_SYNC_SUCCESS: 'WordPress post status updated.',
      WP_POST_SYNC_FAILED: 'Failed to verify WordPress post status.',
      WP_POST_STATUS_UPDATE_SUCCESS: 'Post status updated.',
      WP_POST_STATUS_UPDATE_FAILED: 'Failed to update post status.',
      WP_RELAY_STATUS_REQUIRES_URL: 'Save the posted article URL before changing the status.',
      WP_RELAY_STATUS_SELECT_HINT: 'Select Draft or Published, then save with the posted URL.',
      WP_RELAY_URL_STATUS_SAVE_SUCCESS: 'Posted URL and status saved.',
      WP_RELAY_URL_STATUS_SAVE_FAILED: 'Failed to save posted URL or status.',
      INDEX_REQUEST_REQUIRES_PUBLISHED: 'Index Request is available after the WordPress post is published.',
      ARTICLES_HEADER_CATEGORY_TOOLTIP: 'The CMS category assigned to this article.',
      ARTICLES_HEADER_MEMO_TOOLTIP: 'Internal notes or comments regarding this entry.',
      ARTICLES_HEADER_CREATED_AT_TOOLTIP: 'The date and time when this record was originally created.',
      ARTICLES_HEADER_QUEUED_AT_TOOLTIP: 'The time when the article generation task was added to the processing queue.',
      ARTICLES_HEADER_COMPLETED_AT_TOOLTIP: 'The time when the article generation process was successfully finished.',
      ARTICLES_HEADER_CMS_INTEGRATION_TOOLTIP: 'Status of publishing the article to the connected CMS.',
      ARTICLES_HEADER_BBS_INTEGRATION_TOOLTIP: 'Status of integrating the content with BBS/GBP platforms.',
      ARTICLES_HEADER_STARTED_AT_TOOLTIP: 'The time when the article generation process actually started.',
      ARTICLES_HEADER_LOCATION_TOOLTIP: 'The geographical location associated with this keyword.',
      ARTICLES_HEADER_INPUT_TYPE_TOOLTIP:
        'Indicates how the keyword was entered into the system (e.g., manually or suggested).',
      ARTICLES_HEADER_CHARACTER_COUNT_TOOLTIP: 'The total number of characters in the generated article.',
      ARTICLES_HEADER_SELECTED_CHARACTER_COUNT_TOOLTIP: 'The target character count range selected for generation.',
      BACKLINKS_HEADER_ID_TOOLTIP: 'The unique identifier for this record.',
      BACKLINKS_HEADER_TITLE_TOOLTIP: 'The title or anchor text associated with the backlink.',
      BACKLINKS_HEADER_WEBSITE_TOOLTIP: 'The source website URL where the backlink is located.',
      BACKLINKS_HEADER_DOMAIN_TOOLTIP: 'The root domain of the backlink source.',
      BACKLINKS_HEADER_OWN_TOOLTIP: 'Indicates the domain rate or ownership status of the backlink.',
      BACKLINKS_HEADER_DOMAIN_RATE_TOOLTIP: 'Domain Rating (DR) score of the source website.',
      BACKLINKS_HEADER_INTERSECTION_COUNT_TOOLTIP:
        'The number of sites referenced when building the list that link to the domain in this row.',
      BACKLINKS_HEADER_NUMBER_OF_WEBSITES_TOOLTIP: 'The total count of websites associated with this entry.',
      BACKLINKS_HEADER_PROGRESSED_AT_TOOLTIP: 'The timestamp when the backlink check process started.',
      BACKLINKS_HEADER_COMPLETED_AT_TOOLTIP: 'The timestamp when the backlink check process was finalized.',
      BACKLINKS_HEADER_SUBJECT_TOOLTIP: 'The subject line of the outreach email.',
      BACKLINKS_HEADER_REPLY_FROM_TOOLTIP: 'The sender address of the received reply.',
      BACKLINKS_HEADER_INITIAL_SENTIMENT_TOOLTIP: 'Initial AI-analyzed sentiment of the response.',
      BACKLINKS_HEADER_GENERAL_SENTIMENT_TOOLTIP: 'Overall sentiment score based on the entire conversation.',
      BACKLINKS_HEADER_MEMO_TOOLTIP: 'Additional notes regarding the backlink status or communication.',
      BACKLINKS_HEADER_OTHER_TOOLTIP: 'Other related backlink information.',
      BACKLINKS_HEADER_SAVE_TOOLTIP: 'Save this backlink record.',
      BACKLINKS_HEADER_OPEN_TOOLTIP: 'Open the backlink source URL.',
      BACKLINKS_HEADER_PHONE_TOOLTIP: 'Phone number associated with the contact.',
      BACKLINKS_HEADER_ADDRESS_TOOLTIP: 'Physical address associated with the contact.',
      BACKLINKS_HEADER_DOMAIN_TYPE_TOOLTIP: 'The type or category of the domain.',
      BACKLINKS_HEADER_REPLIED_AT_TOOLTIP: 'The timestamp when a reply was received.',
      BACKLINKS_HEADER_ACTIONS_TOOLTIP: 'Available actions for this backlink.',
      BACKLINKS_HEADER_NOTES_TOOLTIP: 'General notes or remarks.',
      BACKLINKS_HEADER_SL_NO_TOOLTIP: 'Serial number for sorting.',
      BACKLINKS_HEADER_FILE_NAME_TOOLTIP: 'The name of the source file.',
      BACKLINKS_HEADER_STATUS_TOOLTIP: 'Current status of the backlink outreach.',
      BACKLINKS_HEADER_DATE_TIME_TOOLTIP: 'Date and time of the event.',
      BACKLINKS_HEADER_KEYWORD_TOOLTIP: 'Keyword associated with the backlink research.',
      BACKLINKS_HEADER_EMAIL_TOOLTIP: 'Email address used for outreach.',
      BACKLINKS_HEADER_EMAIL_TYPE_TOOLTIP: 'Type of email account used.',
      BACKLINKS_HEADER_HISTORY_TOOLTIP: 'Communication history for this backlink.',
      BACKLINKS_HEADER_SEO_RANK_TOOLTIP: 'SEO ranking metrics for the source domain.',
      BACKLINKS_HEADER_FORM_STATUS_TOOLTIP: 'Current status of the form submission process.',
      BACKLINKS_HEADER_NG_WORD_STATUS_TOOLTIP: 'Status indicating if any prohibited (NG) words were found.',
      BACKLINKS_HEADER_FORM_URL_TOOLTIP: 'The URL of the inquiry or contact form.',
      FORECAST_SUGGESTIONS: 'Suggested matches',
      HIDE_COMMON_DOMAINS: 'Hide Common Domains',
      HIDE_COMMON_DOMAINS_TOOLTIP:
        'Excludes generic email providers (like Gmail, Yahoo, Outlook) from the list to help you focus on business-specific emails.',
      HIDE: 'Hide',
      HIDE_CONFIRMATION_MESSAGE: 'Are you sure you want to hide this email? It will be removed from this list.',
      EMAIL_REPLY_SUCCESSFULLY_HIDE: 'Email reply has been hidden successfully.',
      SOMETHING_WENT_WRONG: 'Something went wrong. Please try again.',
      RESTORE_HIDDEN_EMAILS: 'Restore Hidden Emails',
      RESTORE_CONFIRMATION_MESSAGE: 'Are you sure you want to restore all hidden emails for this location?',
      RESTORE_HIDDEN_EMAILS_TOOLTIP:
        'Restores all emails that were previously hidden for this location back into the untracked replies list.',
      EMAILS_RESTORED_SUCCESSFULLY: 'Hidden emails have been restored successfully.',
      ONLY_HIDDEN: 'Show Hidden',
      HIDDEN_REPLIES: 'Hidden Email Replies',
      SHOW: 'Show',
      SHOW_REPLY: 'Show Reply',
      ARE_YOU_SURE_YOU_WANT_TO_SHOW_THIS_REPLY: 'Are you sure you want to show this reply in the main list?',
      ARE_YOU_SURE_YOU_WANT_TO_HIDE_THIS_REPLY:
        'Are you sure you want to hide this email? It will be moved to the hidden list.',
      HIDE_REPLY: 'Hide Reply',
      SHOW_HIDDEN_EMAILS_TOOLTIP: 'When enabled, only displays emails that you have previously hidden.',
      EMAIL_REPLY_SUCCESSFULLY_RESTORED: 'Email reply has been restored successfully.',

      // GO TO PAGE
      GO_TO_PAGE: 'Go to page:',
      GO: 'Go',

      // Manual Form Submission Iframe
      IFRAME_UNAVAILABLE: 'The webpage at {url} may be temporarily unavailable or may have moved to a new URL.',
      IFRAME_RESTRICTION:
        "Alternatively, it could not be displayed within the tool due to restrictions on the website's side.",
      IFRAME_ACCESS_DIRECTLY:
        'If you wish to fill out the inquiry form, please access the website directly and fill it out from there.',
      IFRAME_USE_RIGHT_VALUES:
        'Please use the values shown in each field on the right side of this screen as the text to enter in the inquiry form.',
      IFRAME_UPDATE_STATUS:
        'Also, if you submit the inquiry form outside of this tool, please return to this screen and update the submission status in the lower right section.',
      IFRAME_X_FRAME_BLOCKED: 'This website cannot be displayed in an iframe.',
      IFRAME_X_FRAME_BLOCKED_DESC: 'The website has security settings that prevent it from being embedded.',
      OPEN_WEBSITE_DIRECTLY: 'Open Website Directly',
      IFRAME_TIMEOUT: 'Website response timed out.',
      IFRAME_TIMEOUT_DESC: 'The website is taking too long to load.',
      IFRAME_INVALID_URL: 'Invalid website address.',
      IFRAME_INVALID_URL_DESC: 'The specified URL is incorrect or cannot be accessed.',
      THE_WEBSITE: 'the website',

      // WORDPRESS POST TYPE
      NAME: 'Name',
      SLUG: 'Slug',
      DESCRIPTION: 'Description',
      NO_POST_TYPES_FOUND: 'No post types found',
      ADD_POST_TYPE: 'Add Post Type',
      EDIT_POST_TYPE: 'Edit Post Type',
      ENTER_POST_TYPE_NAME: 'Enter post type name',
      ENTER_SLUG: 'Enter slug (e.g., blog-post)',
      SLUG_WILL_BE_USED_IN_URL: 'Slug will be used in the URL',
      ENTER_DESCRIPTION: 'Enter description (optional)',
      DELETE_POST_TYPE: 'Delete Post Type',
      ARE_YOU_SURE_DELETE_POST_TYPE: 'Are you sure you want to delete this post type?',
      FUTURE: 'Future',
      UNKNOWN: 'Unknown',
      FAILED_TO_LOAD_WEBSITES: 'Failed to load websites',
      WORDPRESS_CREDENTIALS_REGISTERED_SUCCESSFULLY: 'WordPress credentials registered successfully',
      FAILED_TO_SAVE_POST_TYPE: 'Failed to save post type',
      FAILED_TO_DELETE_POST_TYPE: 'Failed to delete post type',
      SAVING: 'Saving...',
      PLEASE_FILL_REQUIRED_FIELDS: 'Please fill in all required fields',
      SLUG_IS_REQUIRED: 'Slug is required',
      ENTER_LABEL: 'Enter label (e.g., Blog Post)',
      LABEL: 'Label',
      INACTIVE_POST_TYPES_WILL_NOT_BE_AVAILABLE: 'Inactive post types will not be available for selection',
      POST_TYPE_CREATED: 'Post type created successfully.',
      POST_TYPE_DELETED: 'Post type deleted successfully.',
      POST_TYPE_UPDATED: 'Post type updated successfully.',
      EDIT_INTEGRATION: 'Edit Integration',
      NEW_AUTO_INTEGRATION: 'New Auto Integration',
      CONFIGURE_AUTO_INTEGRATION_SETTINGS: 'Configure auto integration settings',
      AUTO_INTEGRATION_ENABLED_DESC: 'Auto integration is enabled and will run automatically',
      AUTO_INTEGRATION_DISABLED_DESC: 'Toggle to enable auto integration',
      POST_TYPES: 'Post Types',
      SELECT_POST_TYPES: 'Select post types...',
      NO_POST_TYPES_AVAILABLE: 'No post types available',
      LOADING_POST_TYPES: 'Loading post types...',
      SELECT_AT_LEAST_ONE_POST_TYPE: 'Please select at least one post type',
      NO_POST_TYPES_CREATED: 'No post types created yet. Please create one first.',
      SELECTED_POST_TYPES: 'Selected Post Types',
      UPDATE_INTEGRATION: 'Update Integration',
      PLEASE_SELECT_AT_LEAST_ONE_POST_TYPE: 'Please select at least one post type',
      SELECT_AT_LEAST_ONE_STATUS: 'Please select at least one status',
      ARTICLES_PER_RUN: 'articles per run',
      SELECT_AT_LEAST_ONE_DAY: 'Please select at least one day',
      ARTICLE_STATUS: 'Article Status',
      TOGGLE_TO_ENABLE_AUTO_INTEGRATION: 'Toggle to enable auto integration',
      NO_ACTIVE_POST_TYPES: 'No active post types available',
      POSTS_WILL_BE_USED_AS_DEFAULT: 'Posts will be used as default',
      SCHEDULE_TYPE: 'Schedule Type',
      SELECT_SCHEDULE_TYPE: 'Select schedule type',
      DEFAULT_POST_TYPE: 'Default Post Type',
      WP_POST_TYPE_POSTS_LABEL: 'Posts',
      NO_OPTIONS_AVAILABLE: 'No options available',
      DESTINATION: 'Destination',
      DESTINATION_TYPE: 'Destination Type',
      RECURRENCE: 'Recurrence',
      POSTING_DESTINATION: 'Posting Destination',
      SELECT_DESTINATION: 'Select Posting Destination',
      SELECT_PARENT_TYPE: 'Select Parent Type',
      SELECT_PARENT_TYPE_OPTIONAL: 'Select Parent Type (Optional)',
      SELECT_CATEGORY_ID: 'Select Category ID',
      SELECT_CATEGORY_ID_OPTIONAL: 'Select Category ID (Optional)',
      SELECT_CATEGORY: 'Select Category',
      SELECT_CATEGORY_OPTIONAL: 'Select Category (Optional)',
      SELECT_TAG: 'Select Tag',
      SELECT_TAG_OPTIONAL: 'Select Tag (Optional)',
      SELECT_ARTICLE_ID: 'Select Article ID',
      PARENT_TYPE_REQUIRED: 'Parent Type is required',
      CATEGORY_REQUIRED: 'Category is required',
      ARTICLE_ID_REQUIRED: 'Article ID is required',
      PLEASE_SELECT_POSTING_DESTINATION: 'Please select a posting destination',
      PLEASE_SELECT_AT_LEAST_ONE_DESTINATION: 'Please select at least one posting destination',
      AUTO_POSTING_SCHEDULE_SETTINGS: 'Auto Article Posting Schedule Settings',
      IPP_SCHEDULE_DESC: 'Set scheduled automatic posting to IPP with future publication reservation',
      AST_SCHEDULE_DESC: 'Set scheduled automatic posting to AST with future publication reservation',
      NEW_SCHEDULE_SETTING: 'New Auto Posting Schedule',
      EDIT_SCHEDULE_SETTING: 'Edit Auto Posting Schedule',
      NEW_SCHEDULE: 'New Schedule Setting',
      RESERVATION: 'Reservation',
      RESERVATION_OFFSET_DAYS: 'Reservation Offset (Days)',
      RESERVATION_TIME: 'Reservation Time',
      ENABLE_DISABLE_AUTO_SCHEDULE: 'Enable or disable automatic posting schedule',
      SCHEDULE_TIME: 'Schedule Time',
      MAX_ARTICLES: 'Max Articles Per Run',
      FUTURE_RESERVATION_SETTING: 'Future Publication Reservation Setting',
      FUTURE_RESERVATION_ENABLED_DESC: 'Future publication reservation is enabled',
      FUTURE_RESERVATION_DISABLED_DESC: 'Articles will be published immediately without reservation',
      FUTURE_RESERVATION_HELP:
        'Articles posted will be reserved for publication after the specified number of days and time.',
      SCHEDULE_SAVED_SUCCESSFULLY: 'Schedule setting saved successfully',
      FAILED_TO_SAVE_SCHEDULE: 'Failed to save schedule',
      SCHEDULE_ACTIVATED: 'Schedule activated',
      SCHEDULE_DEACTIVATED: 'Schedule deactivated',
      FAILED_TO_TOGGLE_SCHEDULE: 'Failed to toggle schedule status',
      DELETE_SCHEDULE_CONFIRMATION: 'Delete Schedule Setting',
      ARE_YOU_SURE_DELETE_SCHEDULE: 'Are you sure you want to delete this schedule setting?',
      AI_CONTENT_DISCLAIMER_TITLE: 'AI Content Disclaimer',
      PROCEED_AND_SAVE: 'Proceed & Save',
      MAIN_KEYWORD_REQUIRED: 'Please select a main keyword',
      NO_SCHEDULE_SETTINGS: 'No schedule settings configured',
      SELECT_MAIN_KEYWORD_OPTIONAL: 'Select Main Keyword (Optional)',
      EMAIL_RECIPIENT_ALL : 'All'
    },
  },
  jp: {
    translation: {
      SERVICE_UNAVAILABLE_NOTICE: 'ご利用いただけるサービスがありません',
      BBS_CMS_CONNECTING: 'BBS-CMS に接続中…',
      BBS_CMS_SESSION_EXPIRED: 'セッションの有効期限が切れました。BBS-CMS から再度ログインしてください。',
      BBS_CMS_RELOAD: '再読み込み',
      FORM_ATTACK_STOPPED_SUCCESSFULLY: 'フォームアタックが正常に停止されました',
      LOGOUT_ERROR: 'ログアウトに失敗しました。もう一度お試しください。',
      SEO: 'SEO',
      LOGO_TITLE: 'SEO ダッシュボード',
      Keywords: 'キーワード',
      HOME: 'ホーム',
      BACKLINK: '被リンク',
      'Date,Time': '日付、時間',
      KEYWORD: 'キーワード',
      'Number of Websites': 'Webサイト数',
      LANGUAGE: '言語',
      SCROLL_HINT: 'スクロールできます',
      Dashboard: 'ダッシュボード',
      'Keyword Management': 'キーワード管理',
      'Build Backlink': '被リンク',
      IS_WEBSITE_BACKLINK: '私のWebサイトは被リンクですか？',
      'Summary Article': 'まとめ記事',
      local: '地域',
      MANUALLY_ENTERED_KEYWORD: '手動入力キーワード',
      business: '業種',
      SEO_ARTICLE: 'SEO記事',
      REVIEW_PROMOTION: '口コミ促進',
      REVIEW_PROMOTION_DESCRIPTION: '口コミ促進・レビュー管理に関する機能を提供する画面です。',
      REVIEW_PROMOTION_SMS_DAILY_REPORT: '口コミ促進（SMS送信予定件数レポート）',
      REVIEW_PROMOTION_SMS_DAILY_REPORT_HELP:
        '毎日09:00（JST）に、ロケーション別のSMS送信予定件数レポートを通知します。',
      REVIEW_PROMOTION_STATUS_SCHEDULED: '送信予定',
      REVIEW_PROMOTION_STATUS_SENDING: '送信中',
      REVIEW_PROMOTION_STATUS_SENT: '送信済',
      REVIEW_PROMOTION_STATUS_FAILED: '失敗',
      REVIEW_PROMOTION_STATUS_CANCELLED: 'キャンセル',
      REVIEW_PROMOTION_FAILED_TO_LOAD_LOCATIONS: 'ロケーション一覧の取得に失敗しました。',
      REVIEW_PROMOTION_NO_LOCATIONS: '口コミ促進を利用できるロケーションがありません。',
      REVIEW_PROMOTION_TAB_SETTINGS: '口コミ促進設定',
      REVIEW_PROMOTION_TAB_SMS_LIST: 'SMS送信予定リスト',
      REVIEW_PROMOTION_SMS_DETAIL_TITLE: 'SMS送信予定 詳細',
      REVIEW_PROMOTION_SMS_LIST_DISABLED_TOAST: '口コミ促進設定を完了するとSMS送信予定リストを利用できます。',
      REVIEW_PROMOTION_UPDATED: '更新しました',
      REVIEW_PROMOTION_UPDATE_FAILED: '更新に失敗しました。しばらくしてから再度お試しください。',
      REVIEW_PROMOTION_NOTES_SAVED: 'メモを保存しました',
      REVIEW_PROMOTION_NOTES_SAVE_FAILED: 'メモ保存に失敗しました。しばらくしてから再度お試しください。',
      REVIEW_PROMOTION_SEND_DATE_UPDATED: '送信日を更新しました',
      REVIEW_PROMOTION_SEND_DATE_UPDATE_FAILED: '送信日の更新に失敗しました。しばらくしてから再度お試しください。',
      REVIEW_PROMOTION_HIDE: '非表示にする',
      REVIEW_PROMOTION_SMS_LIST_DISABLED_HELP:
        '口コミ促進設定を保存して受信用メールアドレスが発行されるまで、SMS送信予定リストは利用できません。',
      REVIEW_PROMOTION_SEARCH: '再検索',
      REVIEW_PROMOTION_FILTERS: '検索条件',
      REVIEW_PROMOTION_FILTERS_SUMMARY_NONE: '条件なし',
      REVIEW_PROMOTION_INVALID_DATE_RANGE: '日付の範囲が正しくありません（From/To）',
      REVIEW_PROMOTION_FILTER_KEYWORD: 'キーワード（氏名/電話/メモ）',
      REVIEW_PROMOTION_FILTER_KEYWORD_PLACEHOLDER: '例）山田 / 090 / メモ',
      REVIEW_PROMOTION_FILTER_VISIT_DATE: '来店日（From/To）',
      REVIEW_PROMOTION_FILTER_SMS_SEND_DATE: '送信日（From/To）',
      REVIEW_PROMOTION_FILTER_TARGET: '送信対象',
      REVIEW_PROMOTION_TARGET_INCLUDED: '対象',
      REVIEW_PROMOTION_TARGET_EXCLUDED: '対象外',
      REVIEW_PROMOTION_FILTER_STATUS: '送信ステータス',
      REVIEW_PROMOTION_SORT: '並び替え',
      REVIEW_PROMOTION_SORT_ORDER: '順序',
      REVIEW_PROMOTION_SORT_BY_SMS_SEND_DATE: '送信日',
      REVIEW_PROMOTION_SORT_BY_VISIT_DATETIME: '来店日時',
      REVIEW_PROMOTION_SORT_ASC: '昇順',
      REVIEW_PROMOTION_SORT_DESC: '降順',
      REVIEW_PROMOTION_LIMIT: '表示件数',
      REVIEW_PROMOTION_TABLE_VISIT_DATETIME: '来店日時',
      REVIEW_PROMOTION_TABLE_SERVICE: '予約サイト',
      REVIEW_PROMOTION_TABLE_NAME: '氏名',
      REVIEW_PROMOTION_TABLE_PHONE: '電話番号',
      REVIEW_PROMOTION_TABLE_TARGET: '送信対象',
      REVIEW_PROMOTION_TABLE_SMS_SEND_DATE: '送信日',
      REVIEW_PROMOTION_TABLE_SMS_SEND_DATETIME: '送信日時',
      REVIEW_PROMOTION_TABLE_STATUS: 'ステータス',
      REVIEW_PROMOTION_TABLE_NOTES: 'メモ',
      REVIEW_PROMOTION_EMPTY: 'データがありません',
      REVIEW_PROMOTION_PAGINATION_RANGE: '表示 {{from}}–{{to}}',
      REVIEW_PROMOTION_PAGINATION_TOTAL: '全{{total}}件',
      REVIEW_PROMOTION_PAGINATION_PAGE: '{{page}}/{{totalPages}}ページ',
      REVIEW_PROMOTION_PAGINATION_EMPTY: '全0件',
      REVIEW_PROMOTION_SEND_DATE_REQUIRED: '送信日を入力してください',
      REVIEW_PROMOTION_SEND_DATE_MIN_TOMORROW: '送信日は明日以降にしてください',
      REVIEW_PROMOTION_SAVE_SEND_DATE: '送信日保存',
      REVIEW_PROMOTION_SAVE_NOTES: 'メモ保存',
      REVIEW_PROMOTION_TOOLTIP_SAVE_SEND_DATE: '送信日を保存します',
      REVIEW_PROMOTION_TOOLTIP_SAVE_NOTES: 'メモを保存します',
      REVIEW_PROMOTION_TOOLTIP_SAVE_TARGET: '送信対象を保存します',
      REVIEW_PROMOTION_SMS_SEND_TIME_OVERRIDE_LABEL: '送信時刻（この予定のみ）',
      REVIEW_PROMOTION_SMS_SEND_TIME_OVERRIDE_HELP:
        '未設定の場合は、口コミ促進設定の送信時刻が使われます（5分単位）。\n※ その日に送るSMSをまとめたレポートが毎日9時に届くため、9時以降に設定することを推奨しております。',
      REVIEW_PROMOTION_SMS_SEND_TIME_DEFAULT_OPTION: 'デフォルト（{{time}}）',
      REVIEW_PROMOTION_SETTINGS_FETCH_FAILED: '設定の取得に失敗しました。しばらくしてから再度お試しください。',
      REVIEW_PROMOTION_COPIED: 'コピーしました',
      REVIEW_PROMOTION_COPY_FAILED: 'コピーに失敗しました',
      REVIEW_PROMOTION_EMAIL_REQUIRED: 'メールアドレスを入力してください',
      REVIEW_PROMOTION_EMAIL_INVALID: 'メールアドレスの形式が正しくありません',
      REVIEW_PROMOTION_SMS_DAYS_INVALID: '送信までの日数は 1〜90 の整数にしてください',
      REVIEW_PROMOTION_SEND_TIME_INVALID: '送信時刻は HH:MM 形式にしてください',
      REVIEW_PROMOTION_SETTINGS_SAVED: '設定を保存しました',
      REVIEW_PROMOTION_SETTINGS_SAVE_FAILED: '設定の保存に失敗しました。しばらくしてから再度お試しください。',
      REVIEW_PROMOTION_FORWARD_TO_EMAIL: '転送先メールアドレス',
      REVIEW_PROMOTION_EMAIL_PLACEHOLDER: 'example@domain.com',
      REVIEW_PROMOTION_FORWARD_TO_EMAIL_HELP:
        '予約メールの内容を、このメールアドレスに転送してお届けします。普段確認しているメールを入力してください。',
      REVIEW_PROMOTION_SMS_DAYS_LABEL: '送信までの日数（1〜90）',
      REVIEW_PROMOTION_SMS_DAYS_HELP: '来店日から何日後にSMSを送るかを指定します（1〜90）。',
      REVIEW_PROMOTION_SMS_TARGET_DEFAULT_ON: 'SMS送信対象をデフォルトONにする',
      REVIEW_PROMOTION_SMS_TARGET_DEFAULT_HELP:
        'ONの場合、受信した予約は自動で送信対象になります（後からリストで個別に変更できます）。',
      REVIEW_PROMOTION_SEND_TIME_LABEL: '送信時刻（5分単位）',
      REVIEW_PROMOTION_SEND_TIME_HELP:
        '毎日この時刻以降に、SMS送信の対象になります（初期状態はデフォルトの10:00です）。\n送信時間を保証するものではありません。\n※ その日に送るSMSをまとめたレポートが毎日9時に届くため、9時以降に設定することを推奨しております。',
      REVIEW_PROMOTION_SMS_MESSAGE_LABEL: 'SMSメッセージ（最大201文字）',
      REVIEW_PROMOTION_SMS_MESSAGE_PLACEHOLDER:
        '例）ご来店ありがとうございました。よろしければ口コミ投稿をお願いします。',
      REVIEW_PROMOTION_SMS_MESSAGE_HELP: 'SMSで送信するメッセージを入力してください。',
      REVIEW_PROMOTION_SMS_MESSAGE_COUNT: '{{count}} / {{max}}',
      REVIEW_PROMOTION_SMS_MESSAGE_TOO_LONG: 'SMSメッセージが長すぎます。201文字以内にしてください。',
      REVIEW_PROMOTION_INBOUND_EMAIL_LABEL: '受信用メールアドレス',
      REVIEW_PROMOTION_INBOUND_EMAIL_HELP: '予約通知メールは、このアドレス宛に送信（または転送）してください。',
      REVIEW_PROMOTION_INBOUND_EMAIL_SECTION_TITLE: '受信メール',
      REVIEW_PROMOTION_INBOUND_EMAIL_EMPTY: 'このレコードに紐づく受信メールがありません',
      REVIEW_PROMOTION_CANCEL_EMAIL_SECTION_TITLE: 'キャンセルメール',
      REVIEW_PROMOTION_CANCEL_EMAIL_EMPTY: 'キャンセルメールがありません',
      REVIEW_PROMOTION_INBOUND_EMAIL_SUBJECT: '件名',
      REVIEW_PROMOTION_INBOUND_EMAIL_FROM: '送信元',
      REVIEW_PROMOTION_INBOUND_EMAIL_RECEIVED_AT: '受信日時',
      REVIEW_PROMOTION_INBOUND_EMAIL_BODY: '本文',
      REVIEW_PROMOTION_INBOUND_EMAIL_BODY_EMPTY: '（本文なし）',
      REVIEW_PROMOTION_RELOAD: '再読込',
      WEBSITES: 'Webサイト',
      Want: '表示件数',
      Filter: 'フィルター',
      FILTER_WEBSITES: 'Webサイトフィルター',
      'Attack List': 'アタックリスト',
      'Add to Attack List': 'アタックリストに追加',
      'Send Mail': 'メール送信',
      'No websites selected for the attack list': 'アタックリストに選択されたWebサイトはありません',
      REFRESH: '更新',
      'Generate Blog': '記事作成',
      'Submit Blog': 'WordPress連携',
      'Save Blog': '保存',
      ID: 'ID',
      EMAIL_HISTORY: 'メール履歴',
      ALL: '全て',
      TITLE: 'タイトル',
      BODY: '本文',
      WEBSITE: 'Webサイト',
      DOMAIN: 'ドメイン',
      SEO_RANK: 'SEOランク',
      DOMAIN_RATE: 'DR',
      INTERSECTION_COUNT: 'インターセクト',
      DOMAIN_TYPE: 'ドメインタイプ',
      LIST_TYPE: 'タイプ',
      ADDRESS: '住所',
      PHONE: '電話番号',
      INQUIRY_FORM: 'お問い合わせフォーム',
      OPENED: 'オープン',
      STATUS: 'ステータス',
      ACTION: 'アクション',
      'Not Sent': '未送信',
      Sent: '送信済',
      UNSENDABLE: '送信不可',
      EXCLUDE: '除外',
      Replied: '返信済',
      'Backlink Provided': '被リンク提供済',
      Rejected: '拒否済',
      'Not Found': '未発見',
      LOGIN: 'ログイン',
      Unknown: '不明',
      LOGOUT: 'ログアウト',
      Previous: '前へ',
      Next: '次へ',
      SUGGEST_OR_RELATED_KEYWORD: 'サジェスト/関連キーワード',
      SOCIAL_LINKS: 'SNSリンク',
      VALID_EMAIL: '有効なメールアドレス',
      COMPETITIVE_BACKLINK: '競合被リンク',
      'No Links Found': 'リンクが見つかりません',
      'N/A': '該当なし',
      WEBSITES_FOR: '対象のWebサイト',
      'Search Query': '検索クエリ',
      Search: '新規リスト作成',
      HIDE_COMMON_DOMAINS: '共通ドメインを非表示',
      HIDE_COMMON_DOMAINS_TOOLTIP:
        'Gmail、Yahoo、Outlookなどの一般的なメールプロバイダーをリストから除外し、固有ドメインのメールのみを表示することができます。',
      HIDE: '非表示',
      HIDE_CONFIRMATION_MESSAGE: 'このメールを非表示にしてもよろしいですか？このリストから削除されます。',
      EMAIL_REPLY_SUCCESSFULLY_HIDE: 'メールの返信が正常に非表示になりました。',
      SOMETHING_WENT_WRONG: 'エラーが発生しました。もう一度お試しください。',
      RESTORE_HIDDEN_EMAILS: '非表示のメールを復元',
      RESTORE_CONFIRMATION_MESSAGE: 'このロケーションのすべての非表示メールを復元してもよろしいですか？',
      RESTORE_HIDDEN_EMAILS_TOOLTIP:
        'このロケーションで以前に非表示にしたすべてのメールを、未追跡の返信リストに戻します。',
      EMAILS_RESTORED_SUCCESSFULLY: '非表示のメールが正常に復元されました。',
      From: '差出人',
      To: '宛先',
      Subject: '件名',
      'Email Body': 'メール本文',
      PLATFORM: 'プラットフォーム',
      'Individual domain': '独自ドメイン',
      MINIMUM_DOMAIN_RANK: '最小ドメインランク',
      SUGGEST: 'サジェスト',
      RELATED_SEARCH: '関連検索',
      SUGGESTION: '提案',
      INITIAL_QUERY: '初期クエリ',
      'Blog content submitted': '記事の内容が送信されました',
      'Enter a topic for the blog': '記事のトピックを入力してください',
      'Please enter some content to save': '保存する内容を入力してください',
      'Blog content saved to local storage': '記事の内容が保存されました',
      'Compose Email': 'メール作成',
      'To:': '宛先:',
      'Subject:': '件名:',
      EMAIL_BODY: 'メール本文',
      'Subject of the email': '件名',
      'Sending...': '送信中...',
      'Send Email': 'メール送信',
      'Failed to send email': 'メールの送信に失敗しました',
      'Email sent successfully!': 'メールが正常に送信されました',
      'All fields are required!': 'すべての項目を入力してください。',
      'Recipient email addresses': '受信者のメールアドレス',
      'Email Outreach': 'メールアウトリーチ',
      LINE_OFFICIAL_ACCOUNT: 'LINE公式アカウント通知',
      ENTER_TALK_ID: 'トークIDを入力 *',
      REGISTER: '登録',
      REGISTERING: '登録中',
      ADD_FRIEND: '友だち追加',
      'Select Keywords and Create Articles': 'ビジネス記事\nキーワードを選択して記事作成',
      'Rewrite Existing Articles': '既存の記事を書き直す',
      CONFIRM_ARTICLES_ALREADY_CREATED: '作成済みの記事を確認する',
      ENTER_KEYWORD_MANUALLY: 'キーワードを入力して記事を作成する',
      ARTICLE_DETAILS: '記事詳細',
      MY_WEBSITES: 'マイWebサイト',
      'Add Website': 'Webサイトを追加',
      LOCATION_NAME: 'ロケーション名',
      'Location Name': 'ロケーション名',
      'Character Count': '文字数',
      RTE_UNDO: '元に戻す',
      RTE_REDO: 'やり直し',
      RTE_BOLD: '太字',
      RTE_ITALIC: '斜体',
      RTE_ALIGN_LEFT: '左揃え',
      RTE_ALIGN_CENTER: '中央揃え',
      RTE_ALIGN_RIGHT: '右揃え',
      RTE_ALIGN_JUSTIFY: '両端揃え',
      RTE_LINK: 'リンク',
      RTE_LINK_PROMPT: 'URLを入力',
      RTE_IMAGE: '画像',
      RTE_IMAGE_PROMPT: '画像URLを入力',
      RTE_SOURCE_CODE: 'ソースコード',
      RTE_INSERT_TABLE: '表を挿入',
      RTE_ADD_ROW: '行を追加',
      RTE_ADD_COL: '列を追加',
      RTE_DELETE_TABLE: '表を削除',
      RTE_CUT: '切り取り',
      RTE_COPY: 'コピー',
      RTE_PASTE: '貼り付け',
      RTE_SELECT_ALL: 'すべて選択',
      RTE_CANCEL: 'キャンセル',
      RTE_APPLY: '適用',
      RTE_BULLET_LIST: '箇条書き',
      RTE_ORDERED_LIST: '番号付きリスト',
      RTE_INDENT: 'インデント',
      RTE_OUTDENT: 'インデント解除',
      RTE_UNDERLINE: '下線',
      RTE_STRIKETHROUGH: '取り消し線',
      RTE_CLEAR_FORMATTING: '書式をクリア',
      RTE_BLOCK_FORMAT: 'ブロック形式',
      RTE_PARAGRAPH: '段落',
      RTE_HEADING_1: '見出し1',
      RTE_HEADING_2: '見出し2',
      RTE_HEADING_3: '見出し3',
      RTE_HEADING_4: '見出し4',
      RTE_TASK_LIST: 'チェックリスト',
      RTE_CODE_BLOCK: 'コードブロック',
      RTE_BLOCKQUOTE: '引用',
      RTE_HORIZONTAL_RULE: '水平線',
      RTE_LIST: 'リスト',
      RTE_INLINE_CODE: 'インラインコード',
      RTE_SUBSCRIPT: '下付き',
      RTE_SUPERSCRIPT: '上付き',
      RTE_HIGHLIGHT: 'ハイライト',
      RTE_REMOVE_HIGHLIGHT: 'ハイライトを解除',
      RTE_DELETE_ROW: '行を削除',
      RTE_DELETE_COLUMN: '列を削除',
      RTE_MERGE_CELLS: 'セルを結合',
      RTE_SPLIT_CELL: 'セルを分割',
      RTE_TOGGLE_HEADER_ROW: '見出し行を切替',
      RTE_TOGGLE_HEADER_COLUMN: '見出し列を切替',
      RTE_ADD_ROW_ABOVE: '上に行を挿入',
      RTE_ADD_ROW_BELOW: '下に行を挿入',
      RTE_ADD_COLUMN_BEFORE: '前に列を挿入',
      RTE_ADD_COLUMN_AFTER: '後に列を挿入',
      'Local Location': '地域名',
      WEBSIDE_URL: 'WebサイトURL',
      'Confirm Submission': '登録確認',
      Yes: 'はい',
      No: 'いいえ',
      'Are you sure you want to add this website?': 'このWebサイトを追加してもよろしいでしょうか？',
      Settings: '設定',
      NOTIFICATIONS: '通知',
      NOTIFICATION_SETTINGS: '通知設定',
      BILLING: '請求',
      CREDIT_MANAGEMENT: 'クレジット管理',
      LOCATION_INFORMATION: 'ロケーション情報',
      LOCATION_INFORMATION_DESC: 'アカウントに紐づくすべてのロケーションの契約ステータスを確認できます。',
      LOCATION_TOTAL: '合計',
      LOCATION_PREPARING_COUNT: '準備中',
      LOCATION_AGREEMENT_COUNT: '契約',
      LOCATION_EMPTY_SUBTITLE: 'アカウントに紐づくロケーションがここに表示されます。',
      LOCATION_LIST: 'ロケーション一覧',
      CONTRACT_STATUS: '契約ステータス',
      AGREEMENT: '契約',
      PREPARING: '準備中',
      SCHEDULED_TO_BE_CANCELED: '解約予定',
      CANCELED: '解約',
      TEMPORARY_STOPPING: '一時停止',
      LOCATION_AGREEMENT_CONFIRM_TITLE: '契約の確認',
      LOCATION_AGREEMENT_CONFIRM_DESC:
        '契約開始日を本日に設定し、「{{name}}」の契約ステータスを準備中から契約に変更します。よろしいですか？',
      LOCATION_AGREEMENT_SUCCESS: '契約ステータスを契約に変更しました。',
      LOCATION_AGREEMENT_FAILED: '契約ステータスの変更に失敗しました。',
      NO_LOCATIONS_FOUND: 'ロケーションが見つかりません。',
      FIXED_PHRASE: '固定フレーズ',
      FIXED_PHRASE_TEMPLATES: '定型フレーズテンプレート',
      FIX: '固定',
      RANDOM: 'ランダム',
      RANDOM_SCHEDULE_TOOLTIP: 'ランダムオプションは指定した範囲内のランダムな時刻で記事を連携する設定です',
      BUSINESS_ARTICLES_SELECT_KEYWORDS_AND_CREATE_ARTICLES: 'ビジネス記事 | キーワードを選択して記事作成',
      LOCAL_ARTICLES_SELECT_KEYWORDS_AND_CREATE_ARTICLES: '地域記事 | キーワードを選択して記事作成',
      REWRITE_EXISTING_ARTICLES: '既存の記事を書き直す',
      MY_WEBSITE: 'マイWebサイト',
      ARTICLE_MANAGEMENT_SETTINGS: '記事管理設定',
      CMS_SETTINGS: 'CMS設定',
      WORDPRESS: 'パターン①',
      IPP: 'パターン②',
      AST: 'パターン③',
      WP_RELAY: 'パターン④',
      WP_MODE_OTHER: 'その他',
      BRIDGEBOOKS: 'MEO連携',
      MAIN_KEYWORDS: 'メインキーワード',
      BILLS: '請求書',
      ENTER_KEYWORD: 'ロケーションを選択し、キーワードを入力して記事作成ボタンを押してください。',
      'Enter Keyword Here': 'ここにキーワードを入力してください。',
      GENERATE_ARTICLE: '記事作成',
      ARTICLE_MODE: '記事モード',
      AI_GENERATED_CONTENT_WARNING:
        '本コンテンツはAIによって生成されたものであり、誤りや不正確な情報が含まれる可能性があります。ご利用にあたっては、内容の確認・検証を行ってください。',
      Location: 'ロケーション',
      AREA: 'エリア',
      'Are you sure you want to generate the article?': '記事を作成してもよろしいでしょうか？',
      'Find My Location': '私のロケーションを見つける',
      EMAIL_NOTIFICATION: 'メール通知',
      EMAIL: 'メール',
      LINE_OFFICIAL_NOTIFICATION: 'LINE公式通知',
      'Bill History': '請求履歴',
      'Profile Settings': 'プロフィール設定',
      New: '新規',
      ARTICLE_WORD_COUNT: '記事の文字数',
      NUMBER_OF_WORDS: '記事の文字数',
      '5000_CHARACTERS': '5,000文字',
      '8000_CHARACTERS': '8,000文字',
      '10000_CHARACTERS': '指定なし',
      SEARCH_LOCATION: 'ロケーションの検索',
      NOT_SPECIFIED: '指定なし',
      LIMITLESS: '指定なし',
      LOCAL: '地域',
      REGIONAL: '地域',
      BUSINESS: '業種',
      NOTIFICATION_OPTIONS: '通知オプション',
      LINE_OFFICIAL_TALK_ID_SAVE_SUCCESS: 'LINE公式トークIDを保存しました',
      LINE_OFFICIAL_TALK_ID_SAVE_FAILED: 'LINE公式トークIDの保存に失敗しました',
      EMAIL_SAVE_SUCCESS: 'メールが正常に保存されました',
      EMAIL_SAVE_FAILED: 'メールを更新できませんでした',
      NOTIFICATION_EMAIL_HEADING: '通知用メールアドレス',
      NOTIFICATION_SETTING_UPDATED: '通知設定を変更しました',
      NOTIFICATION_EMAIL_DESCRIPTION: '重要なアラートを受け取るために、最大3つのメールアドレスを設定できます。',
      DETAILS_FOR: '詳細',
      TYPE: '記事モード',
      NO_STATUS: '-',
      EXCLUDED: '除外',
      UNCREATED: '未作成',
      IN_PROGRESS: '進行中',
      SEND: '送信成功',
      SKIPPED: 'スキップ',
      COMPLETED: '完了',
      Completed: '完了',
      completed: '完了',
      FAILED: '失敗',
      PENDING: '保留中',
      POSTED: '投稿済み',
      NOT_POSTED: '未投稿',
      CONFIRMED: '記事確認済み',
      Confirmed: '記事確認済み',
      confirmed: '記事確認済み',
      IN_QUEUE: '作成待ち',
      PROGRESS: 'ステータス',
      STARTED_AT: '開始日',
      QUEUED_AT: 'キュー登録時刻',
      COMPLETED_AT: '完了日',
      CHANGE_TO_POSTED_STATUS: '投稿済みステータスへ変更',
      CHANGE_STATUS: 'ステータスの変更',
      ALREADY_POSTED: 'すでに投稿済み',
      REWRITE: 'リライト',
      EXCLUSION: '除外',
      WORDPRESS_INTEGRATION: 'CMS連携｜パターン①',
      COPY_TITLE: 'タイトルをコピー',
      COPY_MARKDOWN: 'マークダウン形式でコピー',
      COPY_HTML: 'HTML形式でコピー',
      COPY_TEXT: 'テキスト形式でコピー',
      COPY_AS_NOFOLLOW: 'no-follow形式でコピー',
      MAIN_KEYWORD: 'キーワード管理',
      ADD_MAIN_KEYWORD: 'メインキーワードを追加',
      SELECT_MAIN_KEYWORD: 'メインキーワードを選択',
      NO_MAIN_KEYWORD_FOUND: 'メインキーワードが見つかりません',
      TARGET_KEYWORD: '対象キーワード',
      TITLE_COPIED: '記事のタイトルがテキスト形式でクリップボードにコピーされました。',
      MARKDOWN_COPIED: '記事内容がマークダウン形式でクリップボードにコピーされました',
      HTML_COPIED: '記事内容がHTML形式でクリップボードにコピーされました',
      TEXT_COPIED: '記事内容がテキスト形式でクリップボードにコピーされました',
      TOP: 'トップ',
      NO_WEBSITE: '登録済みのWebサイトはありません',
      SELECTED: '選択済み',
      REGISTERED_MAIN_KEYWORDS: '登録済みメインキーワード',
      NATIONAL_TYPE: '全国型',
      PREFECTURE_TYPE: '都道府県型',
      CITY_TYPE: '都市タイプ',
      MUNICIPALITY_TYPE: '市区町村型',
      STATION_TYPE: '駅の種類',
      CHANGE: '変更',
      VIEW: 'ビュー',
      USE: '使用',
      NOT_USE: '使用しない',
      DO_NOT_USE: '使用しない',
      PREFECTURE_TYPE_POP_UP_TEXT: '都道府県型の利用有無を変更しますか？',
      PREFECTURE_BLANK_SEARCH_TEXT: '都道府県を入力してください',
      CITY_BLANK_SEARCH_TEXT: '市区町村を入力してください',
      REGISTRATION_WARNING_TEXT:
        '登録された内容は後から変更することはできません。\n変更したい場合は登録内容を削除し、新たに登録しなおす必要があります。',
      PREFECTURE_TYPE_INSTRUCTION_TEXT: `作成される地域記事用キーワードは「メインキーワード +（選択した）47都道府県」です。\n例：エアコンクリーニング 北海道｜エアコンクリーニング 青森県・・・`,
      CITY_TYPE_INSTRUCTION_TEXT: `作成される地域記事用キーワードは「メインキーワード +（選択した）都道府県」「メインキーワード +（選択した）市区町村」です。\n例：例：エアコンクリーニング 東京都｜エアコンクリーニング 港区｜エアコンクリーニング 大田区・・・`,
      STATION_TYPE_INSTRUCTION_TEXT: `作成される地域記事用キーワードは「メインキーワード +（選択した）都道府県」「メインキーワード +（選択した）市区町村」「メインキーワード +（選択した）駅名」です。\n例：エアコンクリーニング 東京都｜エアコンクリーニング 新宿区｜エアコンクリーニング 新宿駅`,
      CONFIRM_REGISTRATION_TEXT: '選択した内容で地域記事用キーワードを作成しますか？',
      SELECT_ALL: 'すべて選択',
      DESELECT_ALL: 'すべての選択を解除',
      ALREADY_REGISTERED: '[ すでに登録済み ]',
      REGISTRATION: '登録',
      CLOSE: '閉じる',
      RESET: 'リセット',
      REGISTERED_PREFECTURES: '登録都道府県',
      SELECT_LOCAL_KEYWORDS: '地域記事\nキーワードを選択して記事作成',
      REGISTERED_CITIES: '登録都市',
      REGISTERED_STATIONS: '登録局',
      SELECTED_PREFECTURE: '選択した都道府県',
      SELECTED_CITY: '選択した市区町村',
      ADD_NEW_CITY: '新しい市区町村を追加',
      ADD_NEW_STATION: '新しい駅を追加',
      PO_KEYWORDS: '登録済みのメインキーワードはありません',
      NO_KEYWORDS: 'まだ登録されたキーワードはありません',
      REGISTER_MAIN_KEYWORD: '新しいメインキーワードの登録',
      ENTER_MAIN_KEYWORD: 'メインキーワードを入力してください',
      MAIN_KEYWORD_HINT: 'ロケーションとサービスに関連する、わかりやすいキーワードを入力してください。',
      CONFIRM_KEYWORD: 'キーワードの確認',
      CONFIRM_KEYWORD_EXCLUSION: 'キーワードを除外する',
      ARE_YOU_SURE_YOU_WANT_TO_REGISTER: 'このキーワードをメインキーワードとして登録してもよろしいですか？',
      UPDATE_ARTICLE: '記事を更新',
      // ALL_LOCATION: "すべてのロケーション",
      ALL_LOCATION: 'すべてのロケーション',
      LOCATION_SEARCH: 'ロケーションを選択または入力',
      SEARCH_KEYWORD: 'キーワードを入力して検索',
      POSTED_STATUS_SUCCESS: '投稿ステータスが正常に変更されました。',
      POSTED_STATUS_ERROR: '投稿ステータスの更新に失敗しました。',
      ENTER_LOCAL:
        '地域名（例：東京都 | 東京都千代田区 | 東京都千代田区東京駅 など都道府県、市区町村、駅名）を入力してください',
      SELECT_FROM_PREFECTURES_LIST: '都道府県リストから選択',
      INPUT_MANUALLY: '手動で入力',
      STATION: '駅',
      SELECT_AREA: 'エリアを選択',
      SELECT_LOCATION: 'ロケーションを選択',
      SELECT_PREFECTURE: '都道府県を選択',
      SELECT_CITY: '市区町村を選択',
      SELECT_PREFECTURE_FIRST: '都道府県を先に選択してください',
      SELECT_STATION: '駅を選択',
      SELECT_CITY_FIRST: '市区町村を先に選択してください',
      'DELETING...': '削除中...',
      DELETING: '削除中',
      DELETE: '削除',
      DELETE_DUPLICATE_RECORD: '重複レコードを削除',
      DELETE_DUPLICATE_CONFIRMATION: 'この重複レコードを削除してもよろしいですか？この操作は元に戻せません。',
      DELETE_DUPLICATES_CONFIRMATION: '選択した重複レコードを削除してもよろしいですか？この操作は元に戻せません。',
      DELETE_SELECTED_DUPLICATES: '選択した重複を削除',
      DUPLICATE_LIST_FILTER: '重複リストフィルター',
      DUPLICATE_LIST_ALERT:
        '重複するリストが存在します。「重複リストフィルター」をクリックして、重複する項目の行を表示してください。',
      PREVIOUS: '◀ 前に戻る',
      NEXT: '次',
      NO_TEMPLATES: 'テンプレートが登録されていません',
      SAVED_TEMPLATES: '保存済みテンプレート',
      UPDATE_TEMPLATE: 'テンプレートを更新',
      SAVE_TEMPLATE: 'テンプレートを保存',
      GENERATE_KEYWORDS: 'キーワードを生成',
      GENERATE_WEBSITE_LIST: 'Webサイトリストを生成',
      REGISTRATION_INFO_TITLE: 'さあ始めましょう',
      REGISTRATION_INFO_HEADLINE: '記事キーワードと被リンクサイトリストを生成しましょう',
      REGISTRATION_INFO_STEP_1: '生成するには、同じ画面の「生成」ボタンを押してください。',
      REGISTRATION_INFO_STEP_2: 'なお、生成するとクレジットが消費されます。',
      REGISTRATION_INFO_STEP_3: '各リストの生成はお好きなタイミングで実行できます。',
      REGISTRATION_INFO_MESSAGE:
        '記事作成用キーワードリストと被リンク用Webサイトリストを生成しましょう\n生成するには、同じ画面の「生成」ボタンを押してください。\nなお、生成するとクレジットが消費されます。',
      CREDIT_CONFIRM_TITLE: 'クレジット消費',
      CREDIT_CONFIRM_MESSAGE: 'クレジットを消費してリストを生成しますか？',
      DISPATCH_SUCCESS: '登録が完了しました。',
      DISPATCH_FAILED: '登録に失敗しました。もう一度お試しください。',
      RETRY_DISPATCHED: 'リトライが正常に送信されました。',
      RETRY_FAILED: 'リトライに失敗しました。もう一度お試しください。',
      KEYWORD_COUNT: 'キーワード数',
      KEYWORD_COUNT_LABEL: '{{count}}件のキーワードをリクエスト',
      KEYWORD_COUNT_OPTION: '{{count}}件',
      ESTIMATED_CREDIT_CONSUMPTION: '{{count}}件 : {{total}}クレジットが消費されます',
      CREDIT_CONSUMPTION_SUMMARY: '{{count}}件：合計 {{total}} クレジットが消費されます',
      SELECT_KEYWORD_COUNT_HINT: '生成するキーワード数を選択してください',
      CREDIT_PREVIEW: 'クレジットプレビュー',
      CLICK_TO_SELECT: 'クリックしてこのオプションを選択',
      ADD_MORE_KEYWORD_LIST: 'キーワードリストに追加',
      ADD_MORE_KEYWORD_LIST_DESC: '{{keyword}}に追加するキーワード数を選択してください',
      ADD_MORE_WARNING_MAIN: '同じメインキーワードで新たに異なる記事作成用キーワードを追加で取得することができます。',
      ADD_MORE_WARNING_SUB: '同じサブキーワードで新たに異なる記事作成用キーワードを追加で取得することができます。',
      ADD_MORE_ESTIMATED_CREDIT: '追加の{{count}}キーワードで約{{credits}}クレジット消費されます',
      LOAD_MORE: '追加する',
      ADD_MORE: '追加',
      ADD_MORE_SUCCESS: '{{count}}件の追加キーワードの生成がキューに登録されました',
      ADD_MORE_FAILED: 'キーワードの追加に失敗しました。もう一度お試しください。',
      SERVICE_NOT_AVAILABLE: 'サービスが利用できません',
      LOCAL_AREA_SETTINGS: 'ローカルエリア設定',
      AREA_CONFIGURATION: '地域記事用キーワード登録',
      AREA_CONFIGURATION_DESC: '地域記事を書くための地域記事用キーワードを作成できます。',
      LOADING_AREA_SETTINGS: 'エリア設定を読み込み中...',
      LOCATION_BASED_SETTINGS: '地域設定',
      PREFECTURE_SETTINGS: '都道府県設定',
      CITY_SETTINGS: '市区町村設定',
      STATION_SETTINGS: '駅設定',
      REGISTER_PREFECTURES: '都道府県を登録',
      SELECT_PREFECTURES_TO_REGISTER: '登録する都道府県を選択してください',
      VIEW_CITIES: '市区町村を表示',
      ADD_CITY: '市区町村を追加',
      ADD_CITIES: '市区町村を追加',
      VIEW_STATIONS: '駅を表示',
      ADD_STATION: '駅を追加',
      ADD_STATIONS: '駅を追加',

      //Credit Management
      PURCHASE_CREDITS: '購入',
      CREDIT_USAGE: '使用量',
      PURCHASE_HISTORY: '購入履歴',
      AVAILABLE_CREDITS: '利用可能クレジット',
      DEBITED_ON: '支払日',
      SERVICE: 'サービス',
      REMAINING_CREDIT: '残りのクレジット',
      CONSUMED_CREDIT: '消費クレジット',
      PREVIOUS_CREDIT: '以前のクレジット',
      CATEGORY: 'カテゴリー',
      OPERATION_TYPE: '操作種別',
      ARTICLE_KEYWORD: '記事キーワード',
      TOTAL_CREDITS: '合計クレジット',
      PURCHASED_DATE: '購入日',
      PURCHASED_CREDITS: '追加購入クレジット',
      MONTHLY_CREDITS: '月次クレジット',
      CURRENT_REMAINING_CREDITS: '現在の残りのクレジット',
      SELECT_CREDITS: '購入するクレジットを選択',
      TOTAL_COST: '合計費用',
      CUSTOM_AMOUNT: 'カスタム金額',
      CREDITS_SELECTED: '選択済みクレジット',
      CONFIRM_PURCHASE: '購入確認',
      SECURE_PAYMENT: '安全な支払い',
      INSTANT_DELIVERY: '即時配信',
      CONGRATULATIONS: 'おめでとうございます',
      PURCHASE_SUCCESSFUL: '購入完了',
      SUCCESSFULLY_PURCHASED: '以下のクレジットを購入しました',
      CREDITS: 'クレジット',
      ENJOY_BENEFITS: '引きつづき本サービスをご利用ください',
      CREDITS_READY_FOR_USE: 'クレジットは記事作成や各リスト生成にご利用いただけます',
      NEW_BALANCE: '新しい残高',
      START_USING_CREDITS: 'クレジットを使い始める',
      ENTER_CUSTOM_AMOUNT: 'カスタム金額を入力',
      MINIMUM: '最小',
      INCREMENTS_OF: '増分単位',
      RECURRING: '定期',
      ONE_TIME: '一回払い',
      PURCHASE_CREDITS_DESC: 'サービスを継続してご利用いただくには、アカウントにクレジットを追加してください',
      AVAILABLE_CREDIT: '利用可能なクレジット',
      USED_CREDITS: '使用済みクレジット',
      NO_CONSUMPTION_HISTORY: '消費履歴がありません',
      NO_CONSUMPTION_HISTORY_DESC:
        'まだクレジットを使用していません。サービスを利用すると、消費履歴がここに表示されます。',
      NO_PURCHASE_HISTORY: '購入履歴がありません',
      NO_PURCHASE_HISTORY_DESC: 'まだクレジットを購入していません。クレジットを購入して始めましょう。',
      MAKE_FIRST_PURCHASE: '初めての購入をする',
      HOW_CREDITS_WORK: 'クレジットの使い方',
      REVIEW_YOUR_ORDER: '注文内容をご確認ください',
      PURCHASE_SUMMARY: '購入の概要',
      CREDITS_TO_PURCHASE: '購入するクレジット数',
      CURRENT_BALANCE: '現在の残高',
      IMPORTANT_NOTICE: '重要なお知らせ',
      PURCHASE_CONFIRMATION_NOTE:
        'この操作により、お支払い方法に即座に請求されます。クレジットはすぐにアカウントに追加されます。',
      BACK: '戻る',
      CONFIRM_AND_PAY: '確認して購入',
      SECURE_PAYMENT_GUARANTEED: 'セキュアな決済を保証',
      CONTINUE_TO_PAYMENT: '決済に進む',
      NO_HIDDEN_FEES: '隠れた料金なし',
      EMAIL_RECEIPT: 'メール領収書送信済み',
      CREDITS_PRICE_HINT: '{{credits}}クレジットあたり¥{{price}}',
      OVERALL_BALANCE: '合計残高',
      RENEWED_MONTHLY: '毎月更新',
      ONE_TIME_PURCHASE: '一回購入',

      // Credit Instructions
      CREDIT_SYSTEM_TITLE: 'クレジットシステムガイド',
      CREDIT_SYSTEM_SUBTITLE: 'クレジットの割り当て、消費、管理方法',
      LAST_UPDATED: '最終更新',

      RULE_1_TITLE: '月次割り当て',
      RULE_1_DESC: '毎月初めに各ロケーションに固定数のクレジットが割り当てられます。',

      RULE_2_TITLE: '月次繰越なし',
      RULE_2_DESC: '月次割り当てクレジットは翌月に繰り越されません。',

      RULE_3_TITLE: '追加購入',
      RULE_3_DESC: '追加クレジットはいつでも購入できます。',

      RULE_4_TITLE: '購入クレジット繰越',
      RULE_4_DESC: '購入クレジットは翌月に繰り越されます。',

      RULE_5_TITLE: '消費優先順位',
      RULE_5_SUBTITLE: '月次クレジットを優先使用',
      RULE_5_DESC: 'クレジット消費の優先順位は #1（月次）> #2（購入）です。',

      PRIORITY_AND_EXAMPLE: '優先順位と例',

      PRIORITY_STEP_1_TITLE: '月次クレジット優先',
      PRIORITY_STEP_1_DESC: 'システムは月次割り当てクレジットを最初に使用します',

      PRIORITY_STEP_2_TITLE: '購入クレジット次点',
      PRIORITY_STEP_2_DESC: '月次クレジットを使い切った後にのみ購入クレジットを使用します',

      EXAMPLE_TITLE: '例：月次リセット',
      MAY_31ST: '5月31日（月末）',
      JUNE_1ST: '6月1日（新規月）',
      MONTH_RESET: '月次リセット',

      FAQ_TITLE: 'よくある質問',
      FAQ_1_Q: '月次クレジットはいつリセットされますか？',
      FAQ_1_A: '月次クレジットは毎月1日00:00にリセットされます。',
      FAQ_2_Q: 'アカウント間でクレジットを移送できますか？',
      FAQ_2_A: 'いいえ、クレジットはアカウント単位で管理されており、移送できません。',
      FAQ_3_Q: 'いつ追加クレジットを購入すべきですか？',
      FAQ_3_A: '残高が少ない場合や使用量が増えると予想される場合に追加クレジットを購入してください。',
      FAQ_4_Q: 'クレジットがなくなったらどうなりますか？',
      FAQ_4_A: 'クレジットを必要とするサービスは、追加購入または翌月の割り当てまでご利用いただけません。',

      NEED_HELP: 'クレジットについてお困りですか？',
      STEP: 'ステップ',
      RULE: 'ルール',

      //My Website
      YOUR_WEBSITE: '登録済みWebサイト',
      MY_WEBSITE_MISSING_FOR_THIS_LOCATION:
        'このロケーションのマイWebサイトが登録されていません。設定 > マイWebサイト画面で登録してください。',
      'THIS_LOCATION_ALREADY_HAS_WEBSITE_REGISTERED.PLEASE_SELECT_ANOTHER_LOCATION':
        'このロケーションはすでにWebサイトが登録されています。新しいWebサイトを登録するには、別のロケーションを選択してください。',
      CONFIRM_DELETE: '削除の確認',
      ARE_YOU_SURE_DELETE_WEBSITE:
        'このWebサイトを削除してもよろしいでしょうか？Webサイトを削除すると、登録済みのWordPressの認証情報と統合も削除されます。',
      CANCEL: 'キャンセル',
      DONE: '完了',
      CONFIRM: '登録',
      WEBSITE_OPTIONS: 'Webサイトオプション',
      WEBSITE_STORED_SUCCESSFULLY: 'Webサイトを登録しました',
      MY_WEBSITES_SUBTITLE: '自分自身のWebサイトを登録してください。',
      LOCATION_LABEL: 'ロケーション',
      MANUAL_PLUS_GSC: '手動 + GSC',
      QUICK_ADD: 'クイック追加',
      RECOMMENDED: 'おすすめ',
      WEBSITE_COUNT_LABEL: '{{count}} Webサイト{{plural}}',
      MANUAL_ENTRY: '手動入力',
      ADD_YOUR_WEBSITE_URL: '手動でWebサイトURLを入力してください',
      GOOGLE_SEARCH_CONSOLE: 'Google Search Console',
      CONNECT_GSC_MESSAGE: 'Google Search ConsoleのGoogleアカウントと接続して、Webサイトを登録してください',
      GSC_LINKED: 'アカウントの連携状態',
      ADD_MY_WEBSITE: 'マイWebサイトを追加',
      CONFIRM_SUBMISSION: '登録確認',
      ARE_YOU_SURE_YOU_WANT_TO_ADD_THIS_WEBSITE: 'このWebサイトを登録してもよろしいでしょうか？',
      NO: 'いいえ',
      YES: 'はい',
      GSC_ACCOUNT_STATUS: 'アカウントの連携状態',
      LINKED: '連携済み',
      CONNECTING: '連携中',
      CONNECT_TO_GSC_ACCOUNT: 'アカウントに接続',
      PROCESSING_GSC_AUTH: 'GSC認証を処理中',
      PROCESSING: '処理中...',
      CONTINUE: '続行',
      CONFIRM_WEBSITE_ADDITION: 'Webサイト追加の確認',
      SELECT_YOUR_WEBSITE: 'Webサイトを選択してください',
      FOUND_SITES_MESSAGE:
        '{{count}}件のサイトが見つかりました。追加するWebサイトを選択してください。アクティブにできるのは1つのみです。',

      //Login
      FORGOT_PASSWORD: 'パスワードを忘れましたか？',
      EMAIL_ID: 'ID(メールアドレス)',
      PASSWORD: 'パスワード',
      EMAIL_ID_REQUIRED: 'ID(メールアドレス)を入力してください',
      PASSWORD_REQUIRED: 'パスワードを入力してください',
      INVALID_EMAIL_OR_PASSWORD: 'ID(メールアドレス)またはパスワードが間違っています',

      //Forgot Password
      FORGOT_PASSWORD_TITLE: 'パスワードリセット',
      PASSWORD_RESET: '入力したメールアドレス宛てにパスワードリセットのURLをお送りします',
      LINK_SENT: 'パスワードリセットのURLをお送りしました',
      SEND_RESET_LINK: 'パスワードリセットのリンクを送る',
      ALREADY_HAVE_AN_ACCOUNT: 'すでにアカウントをお持ちですか？  ',

      ARTICLE_CHARACTER_COUNT: '記事の文字数',
      SELECTED_CHARACTER_COUNT: '選択した文字数',

      RESET_PASSWORD: 'パスワードのリセット',
      NEW_PASSWORD: '新しいパスワード',
      CONFIRM_NEW_PASSWORD: '新しいパスワードの確認',
      CONFIRM_PASSWORD_REQUIRED: 'パスワードの確認が必要です',
      CHECK_YOUR_EMAIL_TO_RESET_PASSWORD: 'パスワードをリセットするにはメールを確認してください',

      STATUS_CHANGE_SUCCESS: 'ステータスを変更しました。',
      STATUS_CHANGE_FAILED: 'ステータスの変更に失敗しました。',

      STATUS_ARTICLE_GENERATION: '記事作成ステータス',
      STATUS_BUILD_BACKLINK: '被リンクステータス',
      READY_FOR_ARTICLE_GENERATION: '完了',
      IN_PREPARATION: '準備中',
      READY_FOR_BUILD_BACKLINK: '完了',
      USER_CAN_REGISTER_1_MAIN_KEYWORD_PER_LOCATION:
        'ユーザーは1つのロケーションに対して1つのメインキーワードを登録できます\n一度設定すると変更ができないため、十分にご確認のうえ、登録作業を実施してください。',
      CREATE_ARTICLE: '記事作成',
      TARGET_KW: 'ターゲットキーワード',
      ARTICLE_LIMIT_CHOICE: '作成したい記事の文字数を選択してください。',
      CONFIRM_ARTICLE_GENERATION: '注意事項を理解し、記事を作成する',
      CONFIRM_ARTICLE_GENERATION_RETRY: '記事の再試行を確認する',
      CONFIRM_GENERATION: '記事を作成してもよろしいですか？',
      ARTICLE_GENERATION_DISCLAIMER_1: '記事を作成すると100クレジットが消費されます。',
      ARTICLE_GENERATION_DISCLAIMER_1_WITH_FIRST_HAND: '記事を作成すると180クレジットが消費されます。',
      ARTICLE_GENERATION_DISCLAIMER_2:
        'また、記事はAIによって自動生成されています。\n記事の内容は十分にご確認ください。',
      ARTICLE_GENERATION_DISCLAIMER_3: '記事の再生成を行う場合、クレジットを消費します。',
      FIRST_HAND_INFO_ADDITION: '一次情報を追加する',
      FIRST_HAND_INFO_DISCLAIMER:
        '記事生成に100クレジット、一次情報の追加には80クレジットで、合計100＋80＝180クレジットが消費されます。',
      FIRST_HAND_INFO_DISCLAIMER_DETAILS:
        '一次情報の追加には80クレジットが消費されます。',
      FIRST_HAND_INFO_TOOLTIP:
        '記事への一次情報の追加には、追加で80クレジットが消費されます。記事に独自性を持たせ、他記事との差別化を図ります。',
      FIRST_HAND_INFO_STATUS_PROCESSING: '一次情報追加中',
      FIRST_HAND_INFO_APPLIED: '一次情報追加済み',
      FIRST_HAND_INFO_ADD_BUTTON: '一次情報を追加する',
      FIRST_HAND_INFO_RETRY_BUTTON: '一次情報の追加を再実行',
      FIRST_HAND_INFO_CONFIRM:
        '一次情報の追加には80クレジットが消費されます。実行しますか？',
      FIRST_HAND_INFO_QUEUED: '一次情報の追加を受け付けました',
      FIRST_HAND_INFO_REQUEST_FAILED: '一次情報の追加リクエストに失敗しました',
      FIRST_HAND_INFO_OPERATION: '一次情報追加',
      ARTICLE_RETRY_SUCCESS: '記事の再生成に成功しました',
      ARTICLE_RETRY_FAILED: '記事の再生成に失敗しました',
      NO_KEYWORDS_FOUND: 'キーワードが見つかりません',
      TRY_ADJUSTING_YOUR_SEARCH: '検索条件を調整してください',
      RETRY_ARTICLE_GENERATION: '記事の再生成',
      KEYWORD_DIFFICULTY: 'KD',
      KEYWORD_DIFFICULTY_FILTER: 'キーワード難易度',
      SEARCH_VOLUME: 'SV',
      SEARCH_VOLUME_FILTER: '検索ボリューム',
      TREASURE_KEYWORD_RATING: 'お宝KW',
      TREASURE_KEYWORD_FILTER: 'お宝キーワード',
      EXCLUDED_KEYWORDS: '除外キーワード',
      SEARCH_RANKING: '検索順位',
      APPLY: '適用',
      CLEAR: 'クリア',
      TREASURE_KEYWORD_NOT_STARTED: '判定中',
      TREASURE_KEYWORD_IN_PROGRESS: '進行中',
      TREASURE_KEYWORD_FAILED: '失敗',
      TREASURE_KEYWORD_NOT_TREASURE: '-',
      KEYWORD_PROCESSING_MAIN_KEYWORD: 'メインキーワード',
      KEYWORD_PROCESSING_SUB_KEYWORD: 'サブキーワード',
      KEYWORD_PROCESSING_TREASURE_KEYWORD: 'お宝キーワード',
      KEYWORD_PROCESSING_CV_DETERMINATION: 'CV判定',
      KEYWORD_PROCESSING_KW_RELEVANCE: '関連度',
      KEYWORD_PROCESSING_GOOGLE_SERP: 'Google SERP',
      KEYWORD_RELEVANCE: '関連度',
      KEYWORD_RELEVANCE_HIGH: '高い',
      KEYWORD_RELEVANCE_LOW: '低い',
      KEYWORD_RELEVANCE_FILTER_HIGH: '高い',
      KEYWORD_RELEVANCE_FILTER_LOW: '低い',
      KEYWORD_TYPE: 'KWタイプ',
      POSITION: '検索順位',
      CONVERSION_NEAR_SCORE: 'CV',
      CV_SCORE_FILTER: 'CV',
      ANY_CV_SCORE: '指定なし',
      CV_RANGE_7_10: '7-10',
      CV_RANGE_GTE_5: '5 以上',
      CV_RANGE_LT_5: '5 未満',
      CV_CUSTOM: '自由設定',
      AI_OVERVIEW: 'AI概要',
      RELATED_QUESTIONS: '関連する質問',
      MEO_RESULTS: 'MEO',
      SERP_FEATURE_PRESENT: 'あり',
      SERP_FEATURE_NOT_FOUND: 'なし',
      SERP_FEATURE_LOAD_FAILED: 'SERP詳細の読み込みに失敗しました。',
      SERP_FEATURE_UNKNOWN: '未確認',
      QUESTIONS_SHORT: '件',
      PLACES_SHORT: '件',
      AI_OVERVIEW_SUMMARY_UNAVAILABLE: '概要は利用できません',
      MEO_DATA_UNAVAILABLE: 'ロケーションが見つかりません',
      LIST_OF_CREATED_ARTICLES: '作成された記事のリスト',
      FILTERS: 'フィルター',
      CLEAR_KEYWORD_DIFFICULTY_FILTER: 'キーワード難易度フィルターをクリア',
      ENTER_KEYWORDS_TO_EXCLUDE_COMMA_OR_LINE_SEPARATED: '除外するキーワードを入力（カンマまたは改行で区切る）',
      USE_BRACKETS_FOR_EXTACT_MATCHES: '正確な一致には[角括弧]を使用',
      SEARCH: '検索',
      ANY_KEYWORD_DIFFICULTY: '指定なし',
      KD_VERY_EASY: '0–14:上位表示しやすいKW ',
      KD_EASY: '15–29:やや上位表示しやすいKW',
      KD_POSSIBLE: '30–49:中程度のKW',
      KD_DIFFICULT: '50–69:やや上位表示しにくいKW',
      KD_HARD: '70–84:上位表示しにくいKW',
      KD_VERY_HARD: '85–100:上位表示が困難なKW',
      KD_CUSTOM: '数値を自由に指定する',
      ANY_SEARCH_VOLUME: '指定なし',
      SV_CUSTOM: '数値を自由に指定する',
      ANY_TREASURE_KEYWORD_RATING: '指定なし',
      ADD_EXCLUSION: '除外キーワードを追加',
      KEYWORD_LIST: 'キーワードリスト',
      LOCAL_KEYWORD_LIST: '地域キーワードリスト',
      SHOWING: '表示中｜',
      TO: 'から',
      OF: 'まで（合計',
      RESULTS: '件）',
      MANUAL_FORM_SUBMISSION: '手動フォーム送信',
      MANUAL_FORM_IFRAME: '手動フォーム送信画面',
      IFRAME: '手動フォーム送信画面',
      GO_BACK: '一覧に戻る',
      WOULD_YOU_LIKE_TO_PROCEED: '記事を作成してもよろしいですか？',

      // CMS
      USE_THIS_SETTING: '連携設定を有効化する',
      USE_THIS_SETTING_TOOLTIP: 'CMS連携を有効化したいタブを選び、トグルをONにしてください。',
      CMS_INTEGRATION_MODAL: 'CMS連携の有効化',
      ENABLE_CMS_CONFIRM_WP: 'このタブで設定を有効化すると、他タブの有効化設定が無効になります。続行しますか？',
      ENABLE_CMS_CONFIRM_IPP: 'このタブで設定を有効化すると、他タブの有効化設定が無効になります。続行しますか？',
      ENABLE_CMS_CONFIRM_AST: 'このタブで設定を有効化すると、他タブの有効化設定が無効になります。続行しますか？',
      ENABLE_CMS_CONFIRM_WP_RELAY: 'このタブで設定を有効化すると、他タブの有効化設定が無効になります。続行しますか？',
      CONFIRM_CMS: '続行する',
      CMS_ENABLED_SUCCESS: 'CMS連携を有効にしました',
      CMS_DISABLED_SUCCESS: 'CMS連携を無効にしました',
      CMS_TOGGLE_FAILED: 'CMS連携の更新に失敗しました',
      CMS_INTEGRATION: 'CMS連携',
      CMS_INTEGRATION_DISABLED_TOOLTIP: 'CMS連携設定画面でCMS連携を有効にしてください。',
      BRIDGEBOOKS_INTEGRATION: 'MEO連携',
      BRIDGEBOOKS_INTEGRATION_TOOLTIP:
        'CMSへの記事投稿と同時に、GBP最新情報への投稿をご希望の場合はチェックしてください。',
      APPLY_TO_BRIDGEBOOKS: '同じ連携設定をMEO連携にも適用する',
      BBS_OVERWRITE_WARNING_TITLE: 'MEO連携設定の上書き',
      BBS_OVERWRITE_WARNING_MESSAGE:
        'MEO連携画面で既にスケジュール設定が登録されています。この設定を適用すると、既存のMEO連携設定が上書きされます。続行しますか？',
      BBS_LINKAGE_OFF_WARNING_TITLE: 'MEO連携の停止',
      BBS_LINKAGE_OFF_WARNING_MESSAGE:
        '自動投稿設定がOFFのため、MEO連携側の自動連携設定もOFFになります。よろしければ、このまま保存してください。',
      CMS_INTEGRATION: 'CMS連携',
      ARTICLE_MANAGEMENT_SETTINGS: '記事管理設定',
      BBS_INTEGRATION: 'MEO連携',
      NO_WEBSITES_FOUND_FOR_LOCATION: 'このロケーションで登録されたWebサイトが見つかりません',
      WORDPRESS_ACCOUNT: 'WordPressアカウント',
      WP_CREDS_REGISTERED: 'WordPress認証情報が登録されました',
      ENTER_WORDPRESS_USERNAME: 'WordPressユーザー名を入力',
      ADMIN: 'admin',
      ENTER_APPLICATION_PASSWORD: 'アプリケーションパスワードを入力',
      XXX_YYY_ZZZ_AAA_BBB: 'XXX-YYY-ZZZ-AAA-BBB',
      REGISTER_CREDENTIALS: '認証情報を登録',
      INTEGRATIONS: '自動投稿設定',
      NEW_INTEGRATION: '新規登録',
      Status: 'ステータス',
      ACTIVE: '有効',
      INACTIVE: '無効',
      SELECT_RECIPIENT: '宛先を選択',
      LOADING_RECIPIENTS: '受信者を読み込み中...',
      NEW: '新規',
      EMAIL_CONVERSATION: 'メールの会話',
      SEND_REPLY: '返信を送信',
      SEND_REPLY_TOOLTIP: 'このメールの送信者に返信メールを送信します。',
      REPLY_FROM: '差出人',
      REPLY_TO: '返信先',
      Schedule: 'スケジュール',
      ACTIVATE: '有効化',
      EDIT: '編集',
      No_integrations_found: '連携設定が見つかりません',
      CREATE_YOUR_FIRST_INTEGRATION: '最初の連携を作成',
      AUTO_INTEGRATION: '自動連携',
      REGISTER_WP_CREDS_FIRST: 'まずWordPress認証情報を登録してください',

      // Automatic Article Creation (Exclusive keys)
      AUTO_ARTICLE_INTEGRATIONS: '自動記事作成設定',
      NEW_AUTO_ARTICLE_INTEGRATION: '+ 新規登録',
      NO_AUTO_ARTICLE_INTEGRATIONS_FOUND: '連携設定が見つかりません',
      CREATE_YOUR_FIRST_AUTO_ARTICLE_INTEGRATION: '最初の連携を作成',
      AUTO_ARTICLE_SEO_ARTICLE: 'SEO記事',
      AUTO_ARTICLE_AUTO_INTEGRATION: '自動記事作成',
      AUTO_ARTICLE_MAIN_KEYWORD: 'メインキーワード',
      AUTO_ARTICLE_SCHEDULE: 'スケジュール',
      AUTO_ARTICLE_EVERY_DAY: '毎日',
      AUTO_ARTICLE_EVERY_WEEK: '毎週',
      AUTO_ARTICLE_EVERY_MONTH: '毎月',
      AUTO_ARTICLE_DAILY: '毎日',
      AUTO_ARTICLE_WEEKLY: '毎週',
      AUTO_ARTICLE_MONTHLY: '毎月',
      AUTO_ARTICLE_AT: '',
      AUTO_ARTICLE_TIME: '時間',
      AUTO_ARTICLE_MAX_ARTICLES_PER_SCHEDULE: 'スケジュールごとの最大作成記事数',
      AUTO_ARTICLE_24H_WARNING:
        '記事生成は、設定した作成時刻から24時間以内に完了します。同日の自動CMS連携を設定している場合、連携時刻までに生成が完了しない可能性があります。',
      SCHEDULE_ONCE_PER_DAY_TITLE: '本スケジュールは1日に1回だけ処理されます。',
      SCHEDULE_AFTER_RUN_NOTE:
        '処理起動後、つまり設定したスケジュール時刻に従い処理が動いた後の設定変更内容は翌日から反映されます。',
      SCHEDULE_BEFORE_RUN_NOTE:
        '処理起動前、つまり設定したスケジュール時刻に未達で処理が動く前の設定変更内容は同日から反映されます。（変更内容は未来日時に限ります。）',
      AUTO_ARTICLE_SORT_ORDER: '記事の並び順',
      AUTO_ARTICLE_RELEVANCE_ORDER: '関連度順',
      AUTO_ARTICLE_RELEVANCE_NOT_SPECIFIED: '指定なし',
      AUTO_ARTICLE_RELEVANCE_HIGH_PRIORITY_EXCEPT_TREASURE: '高優先(お宝KWは例外)',
      AUTO_ARTICLE_RELEVANCE_HIGH_PRIORITY_ALL: '高優先',
      AUTO_ARTICLE_RELEVANCE_HIGH_ONLY_EXCEPT_TREASURE: '高のみ(お宝KWは例外)',
      AUTO_ARTICLE_RELEVANCE_HIGH_ONLY_ALL: '高のみ',
      AUTO_ARTICLE_RELEVANCE_ORDER_TOOLTIP:
        '指定なし：一覧画面のデフォルトソートで上からで書く\n高優先(お宝KWは例外)：お宝KW → お宝KW以外は関連度 "高→低→未判定" の順で書く\n高優先：全KWを関連度 "高→低→未判定" の順で書く\n高のみ(お宝KWは例外)： お宝KW → お宝KW以外は関連度 "高" だけ書く\n高のみ：関連度 "高" のKWだけを書く',
      AUTO_ARTICLE_RELEVANCE_HIGH_ONLY_NOTICE:
        '※関連度の判定が付与されているキーワードが対象となります。\n  関連度の判定がない（未判定・対象外の）キーワードのみの場合、「高のみ」を選択すると記事が生成されませんのでご注意ください。',
      AUTO_ARTICLE_AUTHOR_INFORMATION: '著者情報',
      AUTO_ARTICLE_DO_NOT_USE: '使用しない',
      AUTO_ARTICLE_USE: '使用する',
      AUTO_ARTICLE_LIMIT_CHOICE: '作成する記事の指定文字数を選択してください。',
      AUTO_ARTICLE_8000_CHARACTERS: '8,000文字',
      AUTO_ARTICLE_LIMITLESS: '指定なし',
      ARTICLE_SORT_RECOMMENDED: 'トラフィック狙い順',
      ARTICLE_SORT_CV_SCORE: 'CV狙い順',
      TREASURE_KW_PRIORITY: 'トラフィック狙い順',
      CV_PRIORITY: 'CV狙い順',
      PRIORITY_SETTING_UPDATED: '優先度設定を更新しました',
      ARTICLE_SORT_ORDER_SELECTION: '記事生成順の選択',
      AUTO_ARTICLE_LANGUAGE: '言語',
      AUTO_ARTICLE_JAPANESE: '日本語',
      AUTO_ARTICLE_ENGLISH: '英語',
      AUTO_ARTICLE_OTHER_COMPANY_BRAND_INFO: '他社ブランド情報',
      AUTO_ARTICLE_INCLUDE: '含める',
      AUTO_ARTICLE_EXCLUDE: '除外する',
      AUTO_ARTICLE_MANUAL_PROMPT_ADDITION: 'プロンプト手動追加',
      AUTO_ARTICLE_ENTER_CUSTOM_PROMPT: '必要に応じてカスタムプロンプトを入力してください...',
      AUTO_ARTICLE_CANCEL: 'キャンセル',
      AUTO_ARTICLE_UPDATE: '更新',
      AUTO_ARTICLE_SAVE: '保存',
      AUTO_ARTICLE_ACTIVE: '有効',
      AUTO_ARTICLE_INACTIVE: '無効',
      AUTO_ARTICLE_INSUFFICIENT_CREDIT: 'クレジット不足',
      AUTO_ARTICLE_SAVE_CREDIT_WARNING: 'クレジットが不足している場合、記事は生成されませんのでご注意ください。',
      AUTO_ARTICLE_MAX_ARTICLES: '最大記事数',
      AUTO_ARTICLE_EDIT: '編集',
      AUTO_ARTICLE_DELETE: '削除',
      AUTO_ARTICLE_SELECT_DAYS: '曜日を選択',
      AUTO_ARTICLE_SELECT_MONTH_DAY: '日付を選択',
      AUTO_ARTICLE_DAY_OF_MONTH: '{{day}}日',
      AUTO_ARTICLE_MONDAY: '月曜日',
      AUTO_ARTICLE_TUESDAY: '火曜日',
      AUTO_ARTICLE_WEDNESDAY: '水曜日',
      AUTO_ARTICLE_THURSDAY: '木曜日',
      AUTO_ARTICLE_FRIDAY: '金曜日',
      AUTO_ARTICLE_SATURDAY: '土曜日',
      AUTO_ARTICLE_SUNDAY: '日曜日',
      AUTO_ARTICLE_DONE: '完了',
      AUTO_ARTICLE_CLEAR: 'クリア',
      AUTO_ARTICLE_HOUR_TEXT: '時',
      AUTO_ARTICLE_MINUTE_TEXT: '分',
      AUTO_ARTICLE_BATCH_CAUTION: 
      '自動記事作成は、指定した記事作成時刻から最大24時間以内に完了します。同日にCMS自動連携設定をしている場合、その時刻までに記事生成が完了しない場合があること、予めご了承ください。',
      WP_DELETE_CONFIRMATION: '連携設定を削除',
      ARE_YOU_SURE_DELETE_WP: 'このWordPress連携設定を削除してもよろしいですか？この操作は取り消せません。',
      AUTO_ARTICLE_FAILED_TO_LOAD_SETTINGS: '設定の読み込みに失敗しました',
      AUTO_ARTICLE_SETTINGS_DELETED: '自動記事作成設定が削除されました',
      AUTO_ARTICLE_FAILED_TO_DELETE_SETTINGS: '設定の削除に失敗しました',
      AUTO_ARTICLE_MAX_ARTICLES_INVALID: 'スケジュールごとの最大作成記事数は1以上にしてください',
      AUTO_ARTICLE_AUTHOR_INFO_REQUIRED: '著者情報を使用するかどうかを選択してください',
      AUTO_ARTICLE_SETTINGS_SAVED: '自動記事作成設定が保存されました',
      AUTO_ARTICLE_FAILED_TO_SAVE_SETTINGS: '設定の保存に失敗しました',
      INTEGRATION_METHOD: '連携方法',
      DRAFT: '下書き',
      PUBLISH: '公開',
      SCHEDULE: 'スケジュール',
      EVERY_DAY: '毎日',
      EVERY_WEEK: '毎週',
      SELECT_DAYS: '曜日を選択',
      Monday: '月曜日',
      Tuesday: '火曜日',
      Wednesday: '水曜日',
      Thursday: '木曜日',
      Friday: '金曜日',
      Saturday: '土曜日',
      Sunday: '日曜日',
      TIME: '時間',
      MAX_ARTICLES_PER_SCHEDULE: 'スケジュールごとの最大連携記事数',
      SELECT_ARTICLE_STATUS: '記事ステータスを選択',
      SELECT_STATUS: 'ステータスを選択',
      Completed: '完了',
      Confirmed: '確認済み',
      Done: '完了',
      UPDATE: '更新',
      SAVE: '保存',
      POST_TO_WORDPRESS: 'WordPressに投稿',
      SELECT_POST_TYPE: '投稿タイプを選択',
      SELECT_WHICH_POST_TYPE: '公開する投稿タイプを選択してください',
      SELECT_INTEGRATION_METHOD: '公開方法を選択してください',
      POST_TIMING: '投稿タイミング',
      SELECT_TIME: '記事の投稿時期を選択してください',
      POST_NOW: '今すぐ投稿',
      SET_DATE_AND_TIME: '日時を指定',
      FAILED_TO_ACTIVATE_INTEGRATION: 'WordPress統合の有効化に失敗しました',
      SAVED_WP_INTEGRATION_SETTINGS: 'Wordpress統合設定が正常に保存されました',
      INTEGRATION_ACTIVATED_SUCCESSFULLY: '連携が正常に有効化されました',
      INTEGRATION_DELETED_SUCCESSFULLY: '連携が正常に削除されました',
      FAILED_TO_DELETE_INTEGRATION: '連携の削除に失敗しました',
      UPDATED_INTEGRATION: '連携が正常に更新されました',
      FAILED_TO_UPDATE_INTEGRATION: '連携の更新に失敗しました',
      PLEASE_REGISTER_WP_CREDS_FIRST: 'まずWordPress認証情報を登録してください',
      FAILED_TO_REGISTER_WP_CREDS: 'WordPressのユーザー名またはアプリケーションパスワードが正しくありません',
      FAILED_TO_LOAD_WORDPRESS_SETTINGS: 'WordPress設定の読み込みに失敗しました',
      FAILED_TO_LOAD_LOCATIONS: 'ロケーションの読み込みに失敗しました',
      DAILY: '毎日',
      WEEKLY: '毎週',
      MONTHLY: '毎月',
      SCHEDULE_AT: '',
      ENTER_IPP_DOMAIN: 'ドメインを入力',
      EXAMPLE_COM: 'example.com',
      HTTPS_EXAMPLE_COM: 'https://example.com',
      ENTER_AST_DOMAIN: 'ドメインを入力',
      POST_TYPE: '投稿タイプ',
      NEW_POST_TYPE: '新しい投稿タイプ',
      PARENT_TYPE: 'タイプ',
      CATEGORIES_IDS: 'カテゴリーID',
      NOTE: 'メモ',
      NEW_PARENT_TYPE: 'タイプ追加',
      NEW_CATEGORIES_IDS: 'カテゴリーID追加',
      UPDATE_PARENT_TYPE: 'タイプの更新',
      UPDATE_CATEGORIES_IDS: 'カテゴリーIDの更新',
      ADD_PARENT_TYPE: 'タイプ追加',
      ADD_CATEGORIES_IDS: 'カテゴリーID追加',
      ENTER_NOTE: 'メモを入力',
      SUBMIT: '送信',
      UPDATE_CONFIRMATION: '更新確認',
      ARE_YOU_SURE_UPDATE: 'この変更を保存してもよろしいですか？',
      DELETE_CONFIRMATION: '削除確認',
      ARE_YOU_SURE_DELETE: 'この項目を削除してもよろしいですか？この操作は取り消せません。',
      ENTER_ID: 'IDを入力',
      ENTER_PASSWORD: 'パスワードを入力',
      CATEGORIES: 'カテゴリー',
      TAG: 'タグ',
      NEW_CATEGORY: 'カテゴリー追加',
      NEW_TAG: 'タグ追加',
      CATEGORY_NAME: 'カテゴリー名',
      NO_NAME: '名前なし',
      ALREADY_LINKED: '連携済み',
      PUBLISHED: '投稿済み',
      SCHEDULED: '反映待ち',
      INTEGRATED: '連携済み',
      NOT_LINKED: '未連携',
      CODE_ARTICLE_ID: 'コード/記事ID',
      DIRECTORY_ID: 'ディレクトリID',
      DIRECTORY: 'ディレクトリ',
      SELECT_AST_TYPE: 'タイプを選択',
      USE_CODE_HINT: '新はコードを使用／旧はアーティクルIDを使用',
      NEW_AST: '新',
      OLD_AST: '旧',
      TAG_NAME: 'タグ名',
      ADD_TAG: 'タグを追加',
      UPDATE_TAG: 'タグ更新',
      CATEGORY_SET: 'カテゴリー設定',
      CATEGORY: 'カテゴリー',
      ARTICLE_ID: '記事ID',
      CODE: 'コード',
      UPDATE_CATEGORY: 'カテゴリー更新',
      POST_TO_AST: 'CMSに投稿',
      POST_TO_NEW_AST: 'CMSに投稿',
      POST_TO_OLD_AST: 'CMSに投稿',
      POST_TO_IPP: 'CMSに投稿',
      IPP_INTEGRATION: 'CMS連携｜パターン②',
      AST_INTEGRATION: 'CMS連携｜パターン③',
      WP_RELAY_INTEGRATION: 'WP Relay連携',
      WP_RELAY_SETTINGS: 'WP Relay設定',
      WP_RELAY_ACCOUNT_IDENTIFIER: 'アカウント識別子',
      WP_RELAY_ACCOUNT_IDENTIFIER_PLACEHOLDER: 'admin',
      WP_RELAY_AUTH_URL: '認証エンドポイントURL',
      WP_RELAY_AUTH_URL_PLACEHOLDER: 'https://example.com/cms-integration/auth/api/?key=...',
      WP_RELAY_AUTH_SAVED: 'WP Relay設定を保存しました',
      WP_RELAY_SETTINGS_DELETED: 'WP Relay設定を削除しました',
      POST_TO_WP_RELAY: 'WP Relayに投稿',
      REPLACE_URL: 'URLを変更',
      WP_RELAY_VERIFY_DISABLED_TOOLTIP: 'WP Relayでは投稿状態やURLの再取得はできません。',
      SELECT_CMS: 'CMS連携',
      NO_INTEGRATIONS_CONFIGURED: '連携が設定されていません',
      IPP_AUTH_SAVED: '認証が保存されました',
      FAILED_TO_SAVE_AUTH: '認証の保存に失敗しました',
      AST_AUTH_SAVED: '認証が保存されました',
      SETTING_SAVED: '設定が保存されました',
      FAILED_TO_SAVE_SETTING: '設定の保存に失敗しました',
      SETTING_DELETED: '設定が削除されました',
      FAILED_TO_DELETE_SETTING: '設定の削除に失敗しました',
      FAILED_TO_LOAD_CMS_SETTINGS: 'CMS設定の読み込みに失敗しました',
      ARTICLE_POSTED_SUCCESSFULLY: 'CMSへの記事投稿連携が成功しました',
      FAILED_TO_POST_ARTICLE: 'CMSへの記事投稿連携が失敗しました',
      AUTO_ARTICLE_GENERATE: '自動記事作成',
      AUTO_GENERATE: '自動記事作成',
      CSS_SETTINGS: 'CSS設定',
      CSS_SETTINGS_INTEGRATION: 'CSS設定',
      CSS_ENABLED: '有効',
      CSS_DISABLED: '無効',
      CSS_CONTENT_PLACEHOLDER:
        '/* 記述例 */\nh2 { color: #333; }\np { line-height: 1.8; }\n.article-body img { max-width: 100%; }',
      CSS_SAVED: 'CSS設定が保存されました',
      FAILED_TO_SAVE_CSS: 'CSS設定の保存に失敗しました',
      FAILED_TO_LOAD_CSS: 'CSS設定の読み込みに失敗しました',
      EDIT_CSS: 'CSS編集',
      SAVE_CSS: 'CSS保存',
      CSS_TOOLTIP:
        '有効なCSSを記述してください。適用時はセレクタが記事ラッパー（.article-content-wrapper）内に限定されるため、ページ全体には影響しません。@import と @font-face はそのまま維持されます。',
      CSS_COPY_HTML_LABEL: 'HTML形式でコピー時',
      CSS_COPY_HTML_TOOLTIP: 'ONにすると、記事詳細画面でHTML形式コピーを行う際にアクティブなCSSが付与されます。',
      CSS_CMS_LABEL: '記事連携時',
      CSS_CMS_TOOLTIP: 'ONにすると、記事連携時にアクティブなCSSが付与されます。',
      CSS_ACTIVE_BADGE: 'アクティブ',
      SET_AS_ACTIVE: 'アクティブに設定',
      NEW_CSS: '新規CSS',
      DELETE_CSS: '削除',
      NO_CSS_YET: 'CSSがまだ作成されていません',
      CSS_NAME_PLACEHOLDER: 'CSS名',
      CSS_ACTIVE_UPDATED: 'アクティブなCSSを更新しました',
      CSS_DELETED: 'CSSを削除しました',
      CSS_DELETE_CONFIRM: 'このCSSを削除しますか？この操作は取り消せません。',
      CSS_ON: 'ON',
      CSS_OFF: 'OFF',
      CSS_DELIVERY_TITLE: '適用先の設定',
      CSS_DELIVERY_DESCRIPTION: 'アクティブなCSSをどの場面で適用するか選択してください。',
      CSS_EMPTY_TITLE: 'CSSプロファイルがありません',
      CSS_EMPTY_DESCRIPTION: 'CSSプロファイルを作成すると、コピーや記事連携時の記事デザインを設定できます。',
      CSS_CREATE_FIRST: '最初のCSSを作成',
      CSS_CREATE_FIRST_HINT: 'この設定を有効にするには、先にCSSプロファイルを作成してください。',
      CSS_LEGACY_COPY_ONLY: '旧形式ではHTMLコピーのみ利用できます。',
      CSS_LEGACY_CMS_DISABLED: '旧形式では記事連携へのCSS適用は利用できません。',
      CSS_LEGACY_NOTICE: 'APIが旧形式の単一CSS設定を使用しています。既存CSSとHTMLコピー設定は編集できますが、複数プロファイルと記事連携には更新版APIが必要です。',
      CSS_CREATED: 'CSSプロファイルを作成しました',
      CSS_NEW_PROFILE_NAME: '新しいCSSプロファイル',
      CSS_PROFILES_TITLE: 'CSSプロファイル',
      CSS_PROFILES_DESCRIPTION: '複数のデザインを保存し、適用するプロファイルを1つ選択できます。',
      CSS_SAVED_PROFILES: '保存済みプロファイル',
      CSS_LINES: '行',
      CSS_UNNAMED: '名前なしCSS',
      CSS_PROFILE_ID: 'プロファイル',
      CSS_NAME_LABEL: 'プロファイル名',
      CSS_CONTENT_LABEL: 'CSS内容',
      CSS_CHARACTERS: '文字',
      CSS_UNSAVED_CHANGES: '未保存の変更があります',
      CSS_NO_UNSAVED_CHANGES: '変更は保存済みです',
      CSS_EDITOR_TITLE: 'CSSエディター',
      CSS_EDITOR_SCOPE_HINT: 'CSSを適用する際、セレクタは .article-content-wrapper 内に限定されます。上の設定に応じて、アクティブなプロファイルがHTMLコピーや記事連携に使用されます。',
      CSS_DELETE_TITLE: 'CSSプロファイルを削除しますか？',
      CSS_DELETE_DESCRIPTION: 'このプロファイルを削除します。アクティブなプロファイルを削除した場合は、別の保存済みプロファイルが自動的にアクティブになります。',
      COPY_CSS: 'CSSをコピー',
      CSS_COPIED: 'CSSをクリップボードにコピーしました',
      FAILED_TO_COPY_CSS: 'CSSのコピーに失敗しました',
      CSS_COPY_DISABLED_HINT: 'コピーするにはCSSプロファイルを作成し、適用先をONにしてください。',
      CSS_TOGGLE_CONFIRM_TITLE: '設定変更の確認',
      CSS_TOGGLE_CONFIRM_DESCRIPTION: '「{{channel}}」を{{state}}にしますか？',

      // Structured Data Settings
      STRUCTURED_DATA: '構造化データ',
      STRUCTURED_DATA_SETTINGS: '構造化データ設定',
      STRUCTURED_DATA_SETTINGS_TITLE: '構造化データ設定',
      STRUCTURED_DATA_DELIVERY_TITLE: '構造化データの適用設定',
      STRUCTURED_DATA_DELIVERY_DESC: 'HTMLコピー時や各CMSへの記事連携時に構造化データを自動付与するか設定します。',
      STRUCTURED_DATA_MANAGEMENT_TITLE: '構造化データ管理',
      STRUCTURED_DATA_MANAGEMENT_DESC:
        'このウェブサイト向けの構造化データ（JSON-LD・スクリプト）を管理します。有効なプロファイルが各CMS設定やHTMLコピー時に自動付与されます。',
      STRUCTURED_DATA_PROFILES: '構造化データプロファイル',
      STRUCTURED_DATA_PROFILES_HINT: '適用するプロファイルを1つ選択して有効にしてください。',
      STRUCTURED_DATA_SAVED_PROFILES: '保存済みプロファイル',
      STRUCTURED_DATA_ACTIVE_BADGE: 'アクティブ',
      STRUCTURED_DATA_ACTIVE: 'アクティブ',
      STRUCTURED_DATA_ON: 'ON',
      STRUCTURED_DATA_OFF: 'OFF',
      STRUCTURED_DATA_COPY_HTML_LABEL: '構造化データ（HTML形式でコピー時）',
      STRUCTURED_DATA_COPY_HTML_TOOLTIP:
        'ONにすると、記事詳細画面でHTML形式コピーを行う際にアクティブな構造化データが付与されます。',
      STRUCTURED_DATA_CMS_LABEL: '構造化データ（記事連携時）',
      STRUCTURED_DATA_CMS_TOOLTIP: 'ONにすると、記事連携時にアクティブな構造化データが付与されます。',
      STRUCTURED_DATA_NO_ACTIVE_HINT:
        'アクティブな構造化データがありません。「構造化データ」タブでプロファイルを作成・有効化すると、この設定が利用可能になります。',
      STRUCTURED_DATA_EMPTY_TITLE: '構造化データが登録されていません',
      STRUCTURED_DATA_EMPTY_DESC: 'CMSに応じたテンプレートから自動生成するか、新規レコードを手動で作成してください。',
      GENERATE_STRUCTURED_DATA: '構造化データを生成',
      GENERATE_FROM_TEMPLATE: 'テンプレートから生成',
      GENERATE_MODAL_SUBTITLE: 'CMSのテンプレート形式を選択し、サイトに合わせたパラメータを設定してください。',
      SELECT_TEMPLATE_FORMAT: '1. テンプレート形式の選択',
      CONFIGURE_PARAMETERS: '2. パラメータ設定',
      NEW_STRUCTURED_DATA: '新規レコード作成',
      NEW_STRUCTURED_DATA_NAME: '新しい構造化データ',
      NEW_RECORD: '新規作成',
      COPY_SCRIPT: 'スクリプトをコピー',
      STRUCTURED_DATA_COPIED: '構造化データスクリプトをクリップボードにコピーしました',
      FAILED_TO_COPY_STRUCTURED_DATA: '構造化データのコピーに失敗しました',
      STRUCTURED_DATA_CREATED: '構造化データを作成しました',
      STRUCTURED_DATA_GENERATED: '構造化データを生成しました',
      STRUCTURED_DATA_SAVED: '構造化データを保存しました',
      STRUCTURED_DATA_ACTIVE_UPDATED: 'アクティブな構造化データを更新しました',
      STRUCTURED_DATA_DELETED: '構造化データを削除しました',
      FAILED_TO_SAVE_STRUCTURED_DATA: '構造化データの保存に失敗しました',
      FAILED_TO_LOAD_STRUCTURED_DATA: '構造化データの読み込みに失敗しました',
      FAILED_TO_CREATE_STRUCTURED_DATA: '構造化データの作成に失敗しました',
      FAILED_TO_GENERATE_STRUCTURED_DATA: '構造化データの生成に失敗しました',
      FAILED_TO_DELETE_STRUCTURED_DATA: '構造化データの削除に失敗しました',
      FAILED_TO_SET_ACTIVE_STRUCTURED_DATA: 'アクティブ化に失敗しました',
      STRUCTURED_DATA_NAME_PLACEHOLDER: '設定名を入力してください（本項目は構造化データには影響はありません）',
      STRUCTURED_DATA_USAGE_HINT:
        'アクティブなプロファイルは、WP・IPP・ASTタブの配信トグル設定に応じて記事に付与されます。',
      DELETE_STRUCTURED_DATA_TITLE: '構造化データプロファイルを削除しますか？',
      DELETE_STRUCTURED_DATA_DESC:
        'このプロファイルを削除します。アクティブなプロファイルを削除した場合は、別の保存済みプロファイルが自動的にアクティブになります。',
      STRUCTURED_DATA_TOGGLE_CONFIRM_TITLE: '設定変更の確認',
      STRUCTURED_DATA_TOGGLE_CONFIRM_DESCRIPTION: '「{{channel}}」を{{state}}にしますか？',
      TEMPLATE_WP_STANDARD: 'パターン① 標準',
      TEMPLATE_WP_STANDARD_DESC:
        'ロゴ画像と投稿日を、指定した1つの場所（CSSセレクタ）からそれぞれ自動取得して構造化データを生成するテンプレート',
      TEMPLATE_WP_RESPONSIVE: 'パターン① PC/スマホ',
      TEMPLATE_WP_RESPONSIVE_DESC:
        'PC版とスマホ版でロゴ画像・投稿日の表示箇所が異なるサイト向け。両方の場所（CSSセレクタ）からそれぞれ自動取得して構造化データを生成するテンプレート',
      TEMPLATE_IPP: 'パターン②',
      TEMPLATE_IPP_DESC:
        'URLの階層から記事ページかどうかを自動判定し、パンくずリスト（#pan要素）の表示内容を読み取って構造化データに反映するテンプレート',
      TEMPLATE_AST_NEW: 'パターン③ 新',
      TEMPLATE_AST_NEW_DESC:
        'カテゴリの階層をルート（TOPページ）までさかのぼって自動でパンくず情報を組み立て、記事やページの情報をASTのデータベースから直接取得して構造化データを組み立てるテンプレート（他CMSと違い、サーバー側で処理）',
      TEMPLATE_AST_OLD: 'パターン③ 旧',
      TEMPLATE_AST_OLD_DESC:
        'パンくずリスト（#breadcrumb要素）の表示内容と、URLの階層の深さを読み取り、階層構造に応じて構造化データの入れ子を自動的に組み立てるテンプレート',
      TEMPLATE_LABEL_WP_STANDARD: 'パターン① 標準',
      TEMPLATE_LABEL_WP_RESPONSIVE: 'パターン① レスポンシブ（PC/スマホ）',
      TEMPLATE_LABEL_IPP: 'パターン②',
      TEMPLATE_LABEL_AST_NEW: 'パターン③ 新',
      TEMPLATE_LABEL_AST_OLD: 'パターン③ 旧',
      WP: 'パターン① 標準',
      WP_PC_SP: 'パターン① PC/スマホ',
      AST_NEW: 'パターン③ 新',
      AST_OLD: 'パターン③ 旧',
      CUSTOM: 'カスタム',
      PROFILE_NAME: 'プロファイル名',
      TEMPLATE_TYPE: 'テンプレート種別',
      SCHEMA_SCRIPT_CONTENT: '構造化データスクリプト内容',
      UNNAMED_PROFILE: '名前なしプロファイル',
      GENERATE_AND_SAVE: '生成して保存',
      TOP_PAGE_NAME: 'トップページ名',
      SITE_URL_LABEL: 'サイトURL',
      CUSTOMER_NAME: '顧客名 / サイト名',
      AUTHOR_PAGE_URL: '著者 / 会社概要ページURL',
      ARTICLE_PAGE_NAME: '対象記事一覧名',
      SUBMISSION_DIRECTORY: '投稿ディレクトリ',
      URL_PATH_LENGTH: 'URL分割長',
      LOGO_ELEMENT_SELECTOR: 'ロゴ要素セレクタ',
      DATE_ELEMENT_SELECTOR: '日付要素セレクタ',
      PC_LOGO_SELECTOR: 'PCロゴセレクタ',
      SP_LOGO_SELECTOR: 'SPロゴセレクタ',
      PC_DATE_SELECTOR: 'PC日付セレクタ',
      SP_DATE_SELECTOR: 'SP日付セレクタ',
      LOGO_IMAGE_URL: 'ロゴ画像URL',
      ARTICLE_CODE: 'アーティクルコード',
      AUTHOR_PAGE_PATH: '著者ページ相対パス',

      // Keyword Management
      KEYWORD_MANAGEMENT: 'キーワード管理',
      MANUAL_ARTICLE_KEYWORD_MANAGEMENT_TOOLTIP: '記事一覧や自動記事投稿はメインキーワードごとに設定できます。\n手動で記事作成するときにどのメインキーワードに紐づけるか選択できます。\n作成される記事内容について、メインキーワードの紐づけによる影響は一切ありません。',
      DOWNLOAD_CSV: 'CSVダウンロード',
      UPLOAD_KEYWORDS: 'キーワードアップロード',
      SL_NO: 'No.',
      CSV_CLOSE: '閉じる',
      CSV_CONFIRM: '作成',
      BUILD_BACKLINK_CSV_LIST: 'WebサイトリストCSVの作成',
      BUSINESS_KEYWORD_CSV_LIST: 'ビジネスキーワードCSVの作成',
      UPLOAD_BUILD_BACKLINK_CSV: 'CSVアップロード',
      NO_CSV_FOUND: 'CSV ファイルが見つかりません。最初のファイルを作成してください。',
      CONFIRM_CREATE_CSV: 'CSV作成の確認',
      CONFIRM_CREATE_CSV_MESSAGE:
        'CSVを作成してもよろしいですか？作成が完了するとダウンロードボタンが有効になり、ダウンロードすることができます。',
      EXCLUDE_EXCLUDED_KEYWORDS_IN_CSV: '除外済みのキーワードをCSVダウンロードから除外する',
      CONFIRM_UPLOAD_CSV: 'CSVアップロードの確認',
      CONFIRM_UPLOAD_CSV_MESSAGE: 'CSVをアップロードしてもよろしいですか？',
      CREATE_CSV: 'CSVを作成',
      CREATED_AT: '作成日',
      ACTIONS: 'アクション',
      NOT_STARTED: '未着手',
      REMAINING: '件中',
      DOWNLOADED: 'ダウンロード済み',
      DOWNLOAD: 'ダウンロード',
      DOWNLOADING: 'ダウンロード中',
      WARNING_TEXT_DELETE_CITY_STATION_TYPE: `削除してもよろしいですか？\n※[地域記事>キーワードを選択して記事作成]からキーワードが削除されます。\nしかし、記事作成済みのキーワードは削除されずに残りますのでご安心ください。`,

      //KEYWORD EXCLUSION
      KEYWORD_EXCLUSION_DISCLAIMER_TITLE: 'キーワードの除外に関する確認',
      KEYWORD_EXCLUSION_DISCLAIMER_MESSAGE:
        'キーワードを除外すると画面から非表示になり、あとからこのキーワードで記事作成をすることができなくなります。',
      EXCLUDE_KEYWORD_SUCCESS: 'キーワードは正常に除外されました',
      EXCLUDE_KEYWORD_FAILED: 'キーワードを除外できませんでした',

      // THUMBNAIL UPLOAD
      ARTICLE_THUMBNAIL: '記事のアイキャッチ画像',
      SELECT_THUMBNAIL: 'アイキャッチ画像を選択',
      UPLOAD_THUMBNAIL: '画像生成/アップロード',
      REMOVE_THUMBNAIL: 'アイキャッチ画像を削除',
      THUMBNAIL_UPLOAD_SUCCESS: 'アイキャッチ画像をアップロードしました',
      THUMBNAIL_UPLOAD_FAILED: 'アイキャッチ画像のアップロードに失敗しました',
      THUMBNAIL_REMOVED: 'アイキャッチ画像を削除しました',
      THUMBNAIL_REMOVE_FAILED: 'アイキャッチ画像の削除に失敗しました',
      UPLOADING: 'アップロード中...',
      LOADING: '読み込み中...',
      THUMBNAIL_HELP: '投稿用のアイキャッチ画像として使用する画像をアップロードしてください。',
      PLEASE_SELECT_IMAGE_FILE: '画像ファイルを選択してください',
      PLEASE_SELECT_IMAGE_FIRST: '先に画像を選択してください',
      IMAGE_SIZE_EXCEEDE: '画像サイズは5MB未満にしてください',
      CURRENT_THUMBNAIL: '現在のアイキャッチ画像',
      SELECTED_IMAGE: '選択した画像',
      SELECT_IMAGE_HELP: 'クリックして画像ファイルを選択',
      CANCEL_SELECTION: '選択をキャンセル',
      IMAGE_SIZE_EXCEEDED_1MB: '画像サイズは5MB未満にしてください',
      IMAGE_SIZE_EXCEEDED_5MB: '画像サイズは5MB未満にしてください',
      WP_IMAGE_SIZE_LIMIT_TEXT: 'JPG / PNG / GIF / WebP形式、5MB以下の画像をアップロードしてください。',
      UPLOADING_COMPRESSING: 'アップロードおよび圧縮中...',
      THUMBNAIL_READY: 'アイキャッチ画像がアップロードされ、投稿に含まれます',
      CHANGE_THUMBNAIL: '画像生成/アップロード',

      ARTICLE_IMAGE_TAB_GENERATE: 'AIで画像を生成',
      ARTICLE_IMAGE_TAB_UPLOAD: '画像をアップロード',
      ARTICLE_IMAGE_OPTIONAL: '任意',
      ARTICLE_IMAGE_TARGET_AUDIENCE: 'ターゲット層',
      ARTICLE_IMAGE_OPTIONS_HINT: '未選択でも問題ありません。デフォルトで記事内容に沿った画像を生成します。',
      ARTICLE_IMAGE_OPTIONS_HINT_STRONG: '未選択でも問題ありません。',
      ARTICLE_IMAGE_OPTIONS_HINT_DESC: 'デフォルトで記事内容に沿った画像を生成します。',
      ARTICLE_IMAGE_GENERATE_NOTICE_WAIT: '画像生成には数分かかります。時間をおいて再度ご確認ください。',
      ARTICLE_IMAGE_GENERATE_NOTICE_TASTE: 'また、ターゲット層やデザインテイストを選択した場合でも、必ずしもご希望のテイストにならない場合があります。',
      ARTICLE_IMAGE_GENDER: '性別',
      ARTICLE_IMAGE_GENDER_MALE: '男性',
      ARTICLE_IMAGE_GENDER_FEMALE: '女性',
      ARTICLE_IMAGE_AGE_GROUP: '年齢層',
      ARTICLE_IMAGE_AGE_NOT_SELECTED: '未選択',
      ARTICLE_IMAGE_AGE_10S: '10代',
      ARTICLE_IMAGE_AGE_20S: '20代',
      ARTICLE_IMAGE_AGE_30S: '30代',
      ARTICLE_IMAGE_AGE_40S: '40代',
      ARTICLE_IMAGE_AGE_50S: '50代',
      ARTICLE_IMAGE_AGE_60S: '60代',
      ARTICLE_IMAGE_AGE_70S: '70代',
      ARTICLE_IMAGE_AGE_80S: '80代',
      ARTICLE_IMAGE_AGE_90S: '90代',
      ARTICLE_IMAGE_AGE_OR_ABOVE: '以上',
      ARTICLE_IMAGE_AGE_OR_BELOW: '以下',
      ARTICLE_IMAGE_DESIGN_STYLE: 'デザインテイスト',
      ARTICLE_IMAGE_CLEAR_ALL: '選択をすべて解除',
      ARTICLE_IMAGE_CANCEL: 'キャンセル',
      ARTICLE_IMAGE_GENERATE: 'この設定で画像を生成',
      ARTICLE_IMAGE_REGENERATE: 'この設定で再生成',
      ARTICLE_IMAGE_GENERATING: '生成中...',
      ARTICLE_IMAGE_USE_IMAGE: 'この画像を使用',
      ARTICLE_IMAGE_UPLOAD_TITLE: '画像をアップロード',
      ARTICLE_IMAGE_UPLOAD_ZONE: 'クリックして画像を選択、またはドラッグ＆ドロップ',
      ARTICLE_IMAGE_UPLOAD_HINT: '対応形式: JPG / PNG / GIF / WebP　最大5MB　推奨サイズ: 1200×630px以上',
      ARTICLE_IMAGE_REMOVE_IMAGE: '削除',
      ARTICLE_IMAGE_UNSUPPORTED_TYPE: 'JPG / PNG / GIF / WebP形式の画像を選択してください。',
      ARTICLE_IMAGE_STATUS_PENDING: '待機中',
      ARTICLE_IMAGE_STATUS_QUEUED: 'キュー待ち',
      ARTICLE_IMAGE_STATUS_IN_PROGRESS: '生成中',
      ARTICLE_IMAGE_STATUS_COMPLETED: '完了',
      ARTICLE_IMAGE_STATUS_FAILED: '失敗',
      ARTICLE_IMAGE_STATUS_NONE: 'なし',
      ARTICLE_IMAGE_ACCEPTED: '画像生成を受け付けました。',
      ARTICLE_IMAGE_GENERATE_SUCCESS: '記事画像の生成が完了しました。',
      ARTICLE_IMAGE_GENERATE_FAILED: '記事画像の生成に失敗しました。',
      ARTICLE_IMAGE_GENERATE_START_FAILED: '画像生成の開始に失敗しました。',
      ARTICLE_IMAGE_TASTES_LOAD_FAILED: 'デザインテイストの取得に失敗しました。',
      ARTICLE_IMAGE_FREE_INPUT: '自由入力',
      ARTICLE_IMAGE_FREE_INPUT_PLACEHOLDER:
        '短めの文章（2〜3行程度）を推奨します。入力内容がそのまま反映されない場合がありますのでご了承ください。',
      ARTICLE_IMAGE_FREE_REMAINING: '無料生成の残り回数：{{remaining}}回',
      ARTICLE_IMAGE_CREDIT_NOTICE: 'この実行で{{credits}}クレジットを消費します。',
      ARTICLE_IMAGE_CREDIT_CONFIRM_TITLE: '確認',
      ARTICLE_IMAGE_CREDIT_CONFIRM_MESSAGE:
        '無料枠の実行数を超過しました。\n<strong>{{credits}}クレジットを消費し、操作を継続しますか？</strong>',
      ARTICLE_IMAGE_CONFIRM_CONTINUE: '続行',
      ARTICLE_IMAGE_INSUFFICIENT_CREDITS: 'クレジットが不足しています。',
      ARTICLE_IMAGE_FREE_REMAINING_NONE: '無料生成回数が残っていません',
      ARTICLE_IMAGE_MISSING_IMAGE: '編集できる画像がありません。',
      ARTICLE_IMAGE_MANUAL_NOT_EDITABLE: 'アップロードした画像は編集できません。',
      ARTICLE_IMAGE_ARTICLE_NOT_FOUND: '記事が見つかりません。',
      ARTICLE_IMAGE_MISSING_LOCATION: 'ロケーション情報がありません。',
      ARTICLE_IMAGE_MISSING_TITLE: '記事タイトルがありません。',
      ARTICLE_IMAGE_MISSING_COMPOSITION: '記事構成がありません。',
      ARTICLE_IMAGE_MISSING_AUTHOR_TEXT: '投稿者情報が設定されていないため、画像生成を利用できません。',
      ARTICLE_IMAGE_MISSING_TEMPLATE: '画像生成用のプロンプトが未設定です。',
      ARTICLE_IMAGE_EDIT_LABEL: '生成画像への編集指示',
      ARTICLE_IMAGE_EDIT_PLACEHOLDER: '短めの文章（2〜3行程度）を推奨します。入力内容がそのまま反映されない場合がありますのでご了承ください。',
      ARTICLE_IMAGE_EDIT_APPLY: '画像を編集する',
      ARTICLE_IMAGE_EDIT_ACCEPTED: '画像の編集を受け付けました。',
      ARTICLE_IMAGE_EDIT_START_FAILED: '画像編集の開始に失敗しました。',
      ARTICLE_IMAGE_EDIT_COMPLETE: '記事画像の編集が完了しました。',
      ARTICLE_IMAGE_EDIT_FAILED: '記事画像の編集に失敗しました。',
      ARTICLE_IMAGE_EDITING: '画像生成には数分かかります。時間をおいて再度ご確認ください。',
      ARTICLE_IMAGE_EDIT_REMAINING: '無料生成の残り回数：{{remaining}}回',
      ARTICLE_IMAGE_EDIT_CREDIT_NOTICE: 'この編集で{{credits}}クレジットを消費します。',
      ARTICLE_IMAGE_SAVE_PNG: 'PNGで保存',
      ARTICLE_IMAGE_SAVE_FAILED: '画像の保存に失敗しました。',
      ARTICLE_IMAGE_IN_FLIGHT: '画像生成はすでに実行中です。',
      ARTICLE_IMAGE_GENERATION_STATUS: '画像生成ステータス',
      ARTICLE_IMAGE_ARTICLE_TITLE: '記事タイトル',
      ARTICLE_IMAGE_PAGE_PREVIEW: 'ページプレビュー',
      ARTICLE_IMAGE_PAGE_PREVIEW_SUBTITLE: 'メインビジュアルと記事冒頭の見え方を確認できます',
      ARTICLE_IMAGE_PREVIEW_KEYWORD_LABEL: '記事作成に使用したキーワード: ',
      ARTICLE_IMAGE_PREVIEW_BODY: '記事本文',
      ARTICLE_IMAGE_PREVIEW_TIP: '記事の冒頭（最大500文字）を表示しています。',
      ARTICLE_IMAGE_HAS_THUMBNAIL: 'アイキャッチ画像あり',
      ARTICLE_IMAGE_CURRENT_IMAGE: '現在の画像',
      ARTICLE_IMAGE_REMOVE_FAILED: '画像の削除に失敗しました。',
      ARTICLE_IMAGE_TASTE_PHOTOREALISTIC: '実写',
      ARTICLE_IMAGE_TASTE_PHOTOREALISTIC_SUB: '店舗紹介・サービス紹介向け',
      ARTICLE_IMAGE_TASTE_BUSINESS: 'ビジネスイラスト',
      ARTICLE_IMAGE_TASTE_BUSINESS_SUB: 'BtoB・解説記事向け',
      ARTICLE_IMAGE_TASTE_ANIME: 'アニメ',
      ARTICLE_IMAGE_TASTE_ANIME_SUB: '親しみやすい記事向け',
      ARTICLE_IMAGE_TASTE_FLAT: 'フラットデザイン',
      ARTICLE_IMAGE_TASTE_FLAT_SUB: 'SEO記事全般向け',
      ARTICLE_IMAGE_TASTE_DCG: 'DCG',
      ARTICLE_IMAGE_TASTE_DCG_SUB: 'IT・AI・未来系向け',
      ARTICLE_IMAGE_TASTE_INFOGRAPHIC: 'インフォグラフィック',
      ARTICLE_IMAGE_TASTE_INFOGRAPHIC_SUB: 'データ解説向け',
      ARTICLE_IMAGE_TASTE_WATERCOLOR: '水彩画',
      ARTICLE_IMAGE_TASTE_WATERCOLOR_SUB: '旅行・ライフスタイル向け',
      ARTICLE_IMAGE_TASTE_CINEMATIC: 'シネマティック',
      ARTICLE_IMAGE_TASTE_CINEMATIC_SUB: '高級サービス向け',

      //CSV
      MANUAL_KEYWORD_UPLOAD: '手動アップロードKW',
      BUSINESS_KEYWORD_CSV_LIST: 'キーワードリストCSVダウンロード',
      DOWNLOAD_SAMPLE_CSV: 'サンプルCSVをダウンロード',
      CSV_UPLOADED_SUCCESSFULLY: 'CSVが正常にアップロードされました',
      CSV_UPLOAD_FAILED: 'CSVのアップロードに失敗しました',
      CSV_UPLOAD_STATUS_CHECK_FAILED: 'CSVのアップロードステータスチェックに失敗しました',
      UPLOAD_CSV: 'CSVアップロード',
      CONFIRM_UPLOAD: 'アップロード',
      Creating: '作成中...',
      Loading_CSV_list: 'CSVリストを読み込み中...',
      FILE_NOT_READY_YET: 'ファイルはまだ準備できていません',
      UPLOAD_FILE: 'ファイルをアップロード',
      UPLOADED_FILES: 'アップロードされたファイル',

      // BULK ARTICLE GENERATION
      BULK_ARTICLE_CREATION: 'まとめて記事作成',
      NO_KEYWORDS_SELECTED: 'キーワードが選択されていません',
      NOT_MORE_THAN_20_KEYWORDS_SELECTED: '20件を超える記事の作成は許可されていません',
      ARTICLE_GENERATION_FAILED: '記事の作成に失敗しました',
      DUPLICATE_KEYWORD_DETECTED: '重複したキーワードが検出されました。別のキーワードを入力してください。',
      BULK_ARTICLE_GENERATION_FAILED: '記事作成に失敗しました',
      BULK_ARTICLE_GENERATION_STARTED: '記事作成を開始しました',
      BULK_ARTICLE_GENERATION_COMPLETED: '記事作成が完了しました',
      PHRASE_MATCH: 'フレーズ一致KW',
      COMPETITOR_ORGANIC: '競合のオーガニックKW',
      MY_WEBSITE_ORGANIC: '自サイトのオーガニックKW',
      MANUAL_KEYWORD_INPUT: '手動記事作成KW',
      SELECTED_KEYWORDS: '選択キーワード',
      CREATE_ARTICLE_BULK: '一括記事作成',
      SUCCEEDED: '成功',

      //Language
      ENGLISH: '英語',
      JAPANESE: '日本語',
      ARTICLE_LANGUAGE: '言語',
      LIST_SEND: 'リスト/送信',
      CHECK_MAIL: 'メール確認',
      MANAGE_BACKLINK_STATUS: '掲載状況の確認/管理',
      CHECK_SEND_RESULT: '送信結果の確認/再送信',
      OTHER_ACTIONS: 'その他のアクション',

      //Manual Prompt
      ARTICLE_REVISION_TOOLTIP:
        '記事作成後に記事を加筆修正するプロンプトを設定できます。\n例：求人に関する内容がない場合、求人に関する情報を追加してください\n 粗大ごみ回収・粗大ごみ・廃品回収などのキーワードを追加してください\nなど',
      MANUAL_PROMPT_ADDITION: '手動プロンプト追加',
      MANUAL_PROMPT: '手動プロンプト',

      // User Profile / Template Management
      LOCATION_NOT_FOUND_MESSAGE: 'ロケーションが見つかりません',
      TEMPLATE_NOT_FOUND_MESSAGE: 'テンプレートが見つかりません',
      USER_PROFILE_DESCRIPTION_1:
        '被リンク獲得に向け、各Webサイトの問い合わせフォームより自動でフォーム送信を実施します。',
      USER_PROFILE_DESCRIPTION_2: '問い合わせフォームでは会社名、氏名、メールアドレスなど様々な入力項目があります。',
      USER_PROFILE_DESCRIPTION_3: '本画面で、問い合わせフォームで送信したい項目の値を事前に設定してください。',
      USER_PROFILE_DESCRIPTION_4:
        '例：会社名を[株式会社ABC]で登録した場合、問い合わせフォームで会社名を入力する項目があれば、[株式会社ABC]という値を入力して自動でフォームを送信します。',
      USER_PROFILE: 'マイプロフィール',
      COPY_BTN: 'コピー',
      EDIT_BTN: '編集｜保存',
      UPDATE_BTN: '更新',
      DELETE_BTN: '削除',
      SELECT_OPTION: 'オプションを選択',
      EMAIL_ADDRESS: 'メールアドレス*',
      LAST_NAME: '姓 *',
      FIRST_NAME: '名 *',
      LAST_NAME_KATAKANA: '姓（カタカナ）',
      FIRST_NAME_KATAKANA: '名（カタカナ）',
      LAST_NAME_HIRAGANA: '姓（ひらがな）',
      FIRST_NAME_HIRAGANA: '名（ひらがな）',
      PHONE_NUMBER_ONE: '電話番号1 *',
      REPLY_TEXT: '返信メール本文',
      TEMPLATE_NAME: 'テンプレート名 *',
      COMPANY_NAME: '会社名 *',
      DEPARTMENT_NAME: '部署名',
      POSITION_PROFILE: '役職',
      INDUSTRY: '業界',
      NUMBER_OF_EMPLOYEES: '従業員数',
      HOMEPAGE_URL: 'ホームページURL *',
      EDITING_BTN: '⏳ 更新中...',
      DELETING_BTN: '⏳ 削除中...',
      UPDATE_INQUIRE_BTN: '問い合わせ本文を更新',
      UPDATE_REPLY_BTN: '返信メール本文を更新',
      PATTERN_NAME_REQUIRED: 'パターン名は必須です',
      DATA_CREATED: 'データが作成されました',
      ERROR_LOADING_TEMPLATE: 'テンプレートの読み込みエラー:',
      NO_CONTENT_TO_COPY: 'コピーする内容がありません',
      COPIED: 'コピーしました',
      NO_TEMPLATE_SELECTED: 'テンプレートが選択されていません',
      CONFIRM_DELETE_TEMPLATE: 'このテンプレートを削除してもよろしいですか？',
      TEMPLATE_DELETED: 'テンプレートが削除されました',
      DELETE_FAILED: '削除に失敗しました',
      CONFIRM_EDIT_TEMPLATE: 'このテンプレートを編集してもよろしいですか？',
      TEMPLATE_UPDATED: 'テンプレートが更新されました',
      UPDATE_FAILED: '更新に失敗しました',
      INQUIRY_TEXT: '問い合わせ本文',
      TEXT: 'テキスト',
      ADD_INQUIRY_PATTERN: '問い合わせパターンを追加',
      ADD_REPLY_PATTERN: '返信パターンを追加',
      PATTERN_NAME: 'パターン名',
      SELECT_TEMPLATE: 'テンプレートを選択',
      NO_TEMPLATES_FOUND: 'テンプレートが見つかりません',
      SELECT_LOCATION_FIRST: '最初にロケーションを選択してください',
      ADD_NEW_TEMPLATE: '新しいテンプレートを追加',
      TEMPLATE_CREATED_SUCCESSFULLY: 'テンプレートが正常に作成されました',
      DATA_UPDATED: 'データが正常に更新されました',
      DATA_DELETED: 'データが正常に削除されました',
      SOMETHING_WENT_WRONG: '問題が発生しました。後でもう一度お試しください。',
      FILL_ALL_FIELD: 'すべての項目を入力してください',
      COPY_SUCCESS: '正常にコピーされました',
      DELETE_CONFIRM: '本当に削除しますか？',
      CREATE_USER_TEMPLATE_PROFILE: 'プロフィールを作成',
      COMPANY_NAME_KATAKANA: '会社名（カタカナ） *',
      HOMEPAGE_NAME: 'ホームページ名 *',
      PHONE_NUMBER: '電話番号',
      PHONE_NUMBER_TWO: '電話番号2 *',
      PHONE_NUMBER_THREE: '電話番号3 *',
      POSTAL_CODE_ONE: '郵便番号1',
      POSTAL_CODE_TWO: '郵便番号2',
      PREFECTURE: '都道府県',
      ADDRESS_LINE_ONE: '番地',
      CITY: '市区町村',
      ADDRESS_LINE_TWO: '建物',
      HOMEPAGE_OVERVIEW: 'ホームページの概要',
      SUBJECT: '件名',
      PROFILE_SUBJECT: '件名 *',
      POSTAL_CODE: '郵便番号',
      FULL_NAME_KATAKANA: 'フルネーム（カタカナ）',
      FULL_NAME: 'フルネーム',
      CHOOSE_INQUIRY_STYLE: '問い合わせ本文を選択',
      CHOOSE_TEMPLATE: 'テンプレートを選択',
      INQUIRY_MESSAGE_PREVIEW: '問い合わせ本文',
      SELECT_AN_INQUIRY_STYLE_TO_PREVIEW: 'プレビューする問い合わせ本文を選択してください',
      COMPANY_DETAILS: '会社詳細',
      PERSONAL_DETAILS: '個人情報',
      USE_TEMPLATE: 'この内容で自動送信開始',
      NO_TEMPLATES_AVAILABLE: 'テンプレートが利用できません',
      CONTENT_LIMIT_EXCEEDED: '内容制限を超えました。{{limit}}文字以内で入力してください。',
      ANCHOR: 'アンカー',
      PUBLISHED_URL: '掲載URL',
      UPLOAD_TEMPLATE_CSV: 'CSVファイルをアップロード',
      UPLOAD_VALID_CSV: '正しいCSVファイルをアップロードしてください。',

      // LIST/SEND
      MAIN_KEYWORD_PLACEHOLDER: 'メインキーワード',
      CLEAR_FILTER: 'フィルターをクリア',
      RE_FILTER: '再フィルター',
      SHOW: '表示 ｜ 1ページ',
      PER_PAGE: '件',
      SEARCH_PLACEHOLDER: '検索...',
      MAIL: 'メール',
      FORM: 'フォーム',
      AUTO_FORM_SUBMISSION: '自動フォーム送信',
      PLEASE_SELECT_WEBSITES_FIRST: 'まずWebサイトを選択してください',
      SUBMIT_SELECTED_WEBSITES: '{{count}}件のWebサイトに送信',
      QUERY_TYPE: 'クエリタイプ',
      CONTACT_FORM: '問い合わせフォーム',
      COPY_TITLE_TO_CLIPBOARD: 'タイトルをクリップボードにコピー',
      COPY_URL_TO_CLIPBOARD: 'URLをクリップボードにコピー',
      COPY_LOCATION_NAME_TO_CLIPBOARD: 'ロケーション名をクリップボードにコピー',
      OPEN_CONTACT_FORM: '問い合わせフォームを開く',
      NO_WEBSITES_FOUND: 'Webサイトが見つかりません',
      TRY_ADJUSTING_YOUR_FILTERS_OR_REFRESH_THE_LIST: 'フィルターを調整するかリストを更新してください',
      N_A: '該当なし',
      FOUND: '見つかりました',
      NOT_FOUND: '見つかりません',
      CREATING: '作成中',
      LOADING_CSV_LIST: 'CSVリスト読み込み中...',
      ERROR_FETCHING_CSV_LIST: 'CSVリストを取得できません',
      PLEASE_SELECT_A_LOCATION_FIRST: 'まずロケーションを選択してください',
      CSV_CREATION_STARTED: 'CSV作成を開始しました',
      CSV_CREATION_FAILED: 'CSV作成に失敗しました',
      CSV_DOWNLOAD_SUCCESS: 'CSVダウンロードに成功しました',
      FILE_DOWNLOAD_FAILED: 'ファイルダウンロードに失敗しました',
      CSV_DELETED: 'CSVを削除しました',
      COPIED_TO_CLIPBOARD: 'クリップボードにコピーしました',
      COPY_FAILED: 'コピーに失敗しました',
      PLEASE_SELECT_AT_LEAST_ONE_WEBSITE: '少なくとも1つのWebサイトを選択してください',
      FORM_SUBMISSION_FAILED: 'フォーム送信に失敗しました。再度送信してください。',
      CSV_DELETE_FAILED: 'CSV削除に失敗しました',
      UNSELECT_ALL: '選択を解除',
      SELECT_ALL_PAGES: '全選択',
      SELECT_ALL_PAGES_TOOLTIP:
        '全選択されますが、手動フォーム送信ボタンを押して画面遷移する際に"失敗"と"スキップ"ステータスのWebサイトリストのみが表示されます。\n*送信不可、除外、キャンセルはユーザー操作によって割り当てられたステータスであるため、二重送信せぬよう手動フォームアタック画面には表示されないように制御しています。',
      SELECTING_ALL: 'すべて選択中...',
      SELECTION_UPDATED: '選択が更新されました: {{count}}件のレコード',
      SELECTION_UPDATE_FAILED: '選択の更新に失敗しました',
      EXCLUDED_ITEMS_SUCCESS: '除外アイテムが正常に保存されました',
      EXCLUDED_ITEMS_FAILED: '除外アイテムの保存に失敗しました',
      NO_FILE_CHOSEN: 'ファイルが選択されていません',
      FILE_NAME: 'ファイル名',
      PROGRESSED_AT: '進行中',

      // Screen/Module Constants
      CHECK_MANAGE_BACKLINK_STATUS: '掲載状況の確認/管理',
      OTHER_ACTION: 'その他のアクション',
      NOTIFICATION_FOR_LIST_SEND: 'まだ送信できるリストがあります！送信ボタンを押しましょう！',
      NOTIFICATION_FOR_MANUAL_SUBMISSION:
        '自動フォーム送信に失敗したサイトがあります！フォームを手動で送信してください！',
      NOTIFICATION_FOR_CHECK_MAIL: 'メールが届いています！OK回答と質問回答を確認し、OKのものは公開作業に進みましょう！',
      NOTIFICATION_FOR_MANAGE_BACKLINK:
        '公開がまだ完了していないサイトがあります！相手方が完了していない場合は、リマインダーを送信してみてください！',
      NOTIFICATION_FOR_CHECK_SEND_RESULT:
        '自動メールまたはフォーム送信の結果を確認してください！メールアドレスやURLを変更して再送信することもできます！',
      NOTIFICATION_FOR_OTHER_ACTIONS:
        'ステータスを正しく分類できなかったリストがあります！必要に応じてステータスを更新してください！',

      // Check Send Result
      RESEND_MAIL: 'メール再送',
      RESEND_FORM: 'フォーム再送',
      RESEND_FORM_CONFIRMATION:
        '選択されたWebサイトに対して強制的に再度フォームアタックをします。\nすでに送信済みのサイトや"営業お断り"といった文字を検知してスキップしたWebサイトに対してもフォームアタックされること、再度フォームアタックしても結果が変わらない場合がございます。\n留意事項をご承諾いただけましたら、フォーム再送を実行してください。',
      FAILED_TO_LOAD_TEMPLATES: 'テンプレートの読み込みに失敗しました',
      PLEASE_SELECT_AT_LEAST_ONE_ROW: '移動するには少なくとも1行選択してください',
      MOVE_TO_CHECK_MAIL: 'メール確認へ移す',
      MAIL_ADDRESS: 'メールアドレス',
      FORM_URL: '問い合わせフォームURL',
      FORM_STATUS: 'ステータス',
      NG_WORD_STATUS: 'NGワード',
      ENTER_NEW_EMAIL: 'メールアドレスを入力',
      ENTER_NEW_FORM_URL: '問い合わせフォームURLを入力',
      FORM_SEND_RESULTS: 'フォーム送信結果',
      MAIL_SEND_RESULTS: 'メール送信結果',

      // Check Mail
      FAILED_TO_UPDATE_DATA: '更新に失敗しました',
      MOVE_TO_READY_FOR_PUBLICATION: '掲載状況の確認/管理へ移す',
      BULK_EDIT: '一括編集',
      EMAIL_TYPE: '人手｜自動返信',
      REPLY_FROM: '返信元（From）',
      INITIAL_SENTIMENT: '初期判別',
      GENERAL_SENTIMENT: '今の判別',
      REPLY_BODY: '返信本文',
      SELECT_INITIAL_SENTIMENT: '初期判別を選択',
      SELECT_GENERAL_SENTIMENT: '今の判別を選択',
      MEMO: 'メモ',
      EDIT_SENTIMENT: '編集',
      SENTIMENT_REPLY_TEXT: '返信',
      BULK_EDIT_SENTIMENTS: '一括編集',
      SELECTED_ROWS_COUNT: '{{count}}行選択済み',
      PLEASE_SELECT_AT_LEAST_ONE_SENTIMENT: '少なくとも1つ選択してください',
      REPLY_APPROVED: '承諾',
      REPLY_REJECTED: '拒否',
      REPLY_QUESTION: '質問',
      REPLY_OTHER: '判定対象外',
      MAIL_RESPONSE: 'メール返信',
      HUMAN: '人手',
      AUTOMATED: '自動',
      SELECT_EMAIL_TYPE: '人手｜自動による返信か選択',
      ALREADY_MOVED_FOR_PUBLICATION: '掲載管理に移動済み',
      SAVE_NOTE: '備考を保存',
      NO_REPLY_CONTENT: '返信内容なし',
      MAIL_RESPONSE_COPY: 'メール返信コピー',
      MAIL_RESPONSE_COPY_FAILED: 'メール返信コピーに失敗しました',

      // Check Manage Backlink
      OWN: '自社',
      OTHER: '相手',
      NOTES: '備考',
      NOTES_PLACEHOLDER: '備考',
      COPY_URL: 'URLコピー',
      NEITHER_PUBLISHED: '両者未掲載',
      NOT_PUBLISHED_ON_OTHER_SITE: '相手未掲載',
      PUBLISHED_ON_OTHER_SITE: '相手掲載済み',
      NOT_PUBLISHED_ON_OWN_SITE: '自社未掲載',
      PUBLISHED_ON_OWN_SITE: '自社掲載済み',
      BOTH_PUBLISHED: '両者掲載済み',

      // Manual Form Submission
      USER_INFORMATION: 'ユーザー情報',
      MANUAL_FORM_SUBMISSION_PROGRESS: '手動フォーム送信の進捗状況',
      NEW_MAIL_ADDRESS: 'メールアドレス',
      NEW_FORM_URL: '問い合わせフォームURL',
      EDIT_FORM_SUBMISSION_DETAILS: '問い合わせフォームURLを編集',
      NEW_EMAIL_ADDRESS: 'メールアドレス',
      ENTER_NEW_EMAIL_ADDRESS: 'メールアドレスを入力',
      SENT: '送信済',
      SKIP: 'スキップ',
      COPY: 'コピー',
      RETRY: '再試行',
      SKIP_TO_NEXT: '次へ進む',
      SKIP_THE_WEBSITE: 'このWebサイトへの送信をスキップしますか？',
      CONFIRMATIO_SKIP_THE_WEBSITE:
        'このWebサイトへの送信をスキップしてもよろしいでしょうか？後ほどお戻りいただけます。',
      SUBMISSION_SUMMERY: '提出内容の概要',
      CONFIRM_ALERT: '本当に実行しますか？',
      MAKE_DEFAULT: 'デフォルトにする',
      DEFAULT: 'デフォルト',
      FORM_ATTACK_AUTO_STARTED_AT: '自動送信開始日',
      FORM_ATTACK_AUTO_END_AT: '自動送信完了日',
      FORM_ATTACK_MANUAL_STARTED_AT: '手動送信開始日',
      FORM_ATTACK_MANUAL_END_AT: '手動送信日',
      FORM_ATTACK_REASON: '失敗理由',
      TOTAL: '合計',
      URL_IS_INVALID: 'URL が無効です',
      INQUIRY_FORM_NOT_FOUND: '問い合わせフォームが見つかりません',
      NO_SALES_NOTICE_DETECTED: '「営業停止」通知を検知しました',
      EXCLUDED_DOMAIN: '除外ドメインのため送信しません',
      DUPLICATE_SUBMISSION: '重複送信のため送信しません',
      FORM_IN_IFRAME: 'フォームが iframe 内にあるため自動入力できません',
      UNSUPPORTED_INQUIRY_FORM: '非対応の問い合わせフォームです',
      WEBSITE_ANALYSIS_NOT_POSSIBLE: 'サイト分析ができません',
      TIMEOUT: 'リクエストがタイムアウトしました',
      BLOG_COMMENT_FORM: 'ブログなどのコメント欄を検知しました',
      RESERVATION_FORM: '予約などのフォームを検知しました',
      DOCUMENT_MEMBER_FORM: '資料請求や会員登録などのフォームを検知しました',
      NO_APPLICABLE_INQUIRY_TYPE: '適切な選択肢が見つかりませんでした',
      TEXT_HALF_WIDTH_ONLY: '全角文字のみ入力可能',

      // user profile
      CONFIRMATION_ALERT_DEFAULT_TEXT: 'この操作を実行してもよろしいですか？',
      CONFIRMATION_ALERT_DEFAULT_TITLE: '操作の確認',
      CSV_LIST: 'CSVリスト',
      FULL_NAME_HIRAGANA: 'フルネーム（ひらがな）',

      // article rewrite
      CREATE_REWRITE_ARTICLE: 'リライト記事作成',
      FIRST_HAND_INFO_IN_QUEUE: '一次情報追加中',
      REWRITE_IN_QUEUE: 'リライト待ち',
      REWRITE_CLIENT_PROMPT_CONSTRUCTED: 'プロンプト作成',
      REWRITE_ARTICLE_STARTED: '記事開始',
      REWRITE_ARTICLE_COMPLETED: 'リライト完了',
      REWRITE_ARTICLE_FAILED: '失敗',
      RETRY_REWRITE_ARTICLE: 'リライト記事再試行',
      REWRITE_ARTICLE: 'リライト記事',
      CONFIRM_REWRITE_ARTICLE: 'このキーワードの既に作成された記事をリライトしてもよろしいですか？',
      REWRITE_ARTICLE_CONFIRMATION_TITLE: '既存の記事をリライトしようとしています',
      REWRITE_ARTICLE_CONFIRMATION_MESSAGE: 'このキーワードの既に作成された記事をリライトしてもよろしいですか？',
      REWRITE_ARTICLE_BULK: '記事を一括リライト',
      REWRITE_ARTICLE_BULK_CONFIRMATION_TITLE: '既存の記事を一括でリライトしようとしています',
      REWRITE_ARTICLE_BULK_CONFIRMATION_MESSAGE:
        '選択したキーワードの既に作成された記事をリライトしてもよろしいですか？',
      ARTICLE_FAILED: '失敗',
      REWRITE_KEYWORD_CSV_LIST: 'リライト記事キーワード CSVリスト',
      NO_ARTICLES_FOUND: '記事が見つかりません',

      // user profile
      UPDATE_CONFIRM_USER_TEMPLATE:
        '会社名、担当者名、メールアドレス、WebサイトURL、サイト名、アンカーテキスト、公開URL、またはサイト概要を変更した場合は、変更内容を保存した後、［問い合わせ文を更新］または［返信メールテンプレートを更新］ボタンをクリックし、変更が反映されているかを確認し、必要に応じて修正してください。',
      GENERATING_TEXT: '生成中...',
      LOADING_TEXT: '読み込み中...',
      LOADING_AVAILABLE_SITES: '利用可能なサイトを読み込み中...',
      INQUIRY_DESCRIPTION_TEXT: '入力可能文字数は{{limit}}文字までです。現在の合計文字数は{{count}}文字です。',
      TEXT_LIMIT_EXCEEDED: '入力可能文字数を超えました。最大{{limit}}文字まで入力可能です。再度入力してください。',
      REPLY_DESCRIPTION_TEXT: '入力可能文字数は{{limit}}文字までです。現在の合計文字数は{{count}}文字です。',

      TEMPLATE_NAME_PLACEHOLDER: 'テンプレート名',
      COMPANY_NAME_PLACEHOLDER: '株式会社テンプレート',
      COMPANY_NAME_KATAKANA_PLACEHOLDER: 'カブシキガイシャテンプレート',
      DEPARTMENT_NAME_PLACEHOLDER: '広報',
      POSITION_PROFILE_PLACEHOLDER: '一般職',
      INDUSTRY_PLACEHOLDER: 'ホームページ制作、アプリ開発など',
      NUMBER_OF_EMPLOYEES_PLACEHOLDER: '100',
      URL_PLACEHOLDER: 'https://www.●●●',
      HOMEPAGE_NAME_PLACEHOLDER: 'ホームページ名',
      HOMEPAGE_OVERVIEW_PLACEHOLDER:
        'ホームページ制作、MEO対策、アプリ開発など、デジタルマーケティング全般を支援するサービスを提供',
      EMAIL_ADDRESS_PLACEHOLDER: 'test@example.com',
      LAST_NAME_PLACEHOLDER: '山田',
      FIRST_NAME_PLACEHOLDER: '太郎',
      LAST_NAME_KATAKANA_PLACEHOLDER: 'ヤマダ',
      FIRST_NAME_KATAKANA_PLACEHOLDER: 'タロウ',
      LAST_NAME_HIRAGANA_PLACEHOLDER: 'やまだ',
      FIRST_NAME_HIRAGANA_PLACEHOLDER: 'たろう',
      PHONE_NUMBER_ONE_PLACEHOLDER: '03',
      PHONE_NUMBER_TWO_PLACEHOLDER: '1234',
      PHONE_NUMBER_THREE_PLACEHOLDER: '5678',
      POSTAL_CODE_ONE_PLACEHOLDER: '123',
      POSTAL_CODE_TWO_PLACEHOLDER: '4567',
      PREFECTURE_PLACEHOLDER: '東京都',
      CITY_PLACEHOLDER: '新宿区',
      ADDRESS_LINE_ONE_PLACEHOLDER: 'テンプレート1-1-1',
      ADDRESS_LINE_TWO_PLACEHOLDER: 'テンプレートビル1F',
      PROFILE_SUBJECT_PLACEHOLDER: 'フォーム送信時の問い合わせ件名です。50文字以内におさめてください',
      ANCHOR_PLACEHOLDER: 'アンカーテキスト',
      TRANSACTIONS: '取引',
      TEAM_MEMBERS: 'チームメンバー',
      EMAIL_OUTREACH: 'メール営業',
      LEADS: 'リード',
      WELCOME: 'ようこそ',
      CHECK_MANAGE_BACKLINK: '掲載状況の確認/管理',
      ANALYTICS: 'Google Analytics',
      SEARCH_CONSOLE: 'Google Search Console',
      CALENDAR: 'カレンダー',
      BLANK_PAGE: '空白ページ',
      GETTING_STARTED: 'はじめに',
      FEATURES: '機能',
      DOCUMENTATION: 'ドキュメント',
      ACCOUNT_MANAGEMENT: 'アカウント管理',
      STATUS_UPDATE_SUCCESS: 'ステータスが「{{actionName}}」に正常に更新されました',
      STATUS_UPDATE_FAILED: 'ステータスを「{{actionName}}」に更新できませんでした',
      ALL_WEBSITES_PROCESSED: 'すべてのWebサイトの処理が完了しました',
      SKIPPED_TO_NEXT_WEBSITE: '次のWebサイトへスキップしました',
      SKIPPED_TO_FIRST_WEBSITE: '最初のWebサイトへスキップしました',
      MOVED_TO_PREVIOUS_WEBSITE: '前のWebサイトへ移動しました',
      CONFIRM_MARK_AS: '{{actionName}}としてマークする',
      CONFIRM_MARK_WEBSITE: 'このWebサイトを{{actionName}}としてマークしてもよろしいですか？',
      CONFIRM_DESC_SENT: ' フォームが正常に送信されたとしてマークされます。',
      CONFIRM_DESC_UNSENDABLE: ' フォームが送信不可としてマークされます。',
      CONFIRM_DESC_EXCLUDED: ' このWebサイトは今後の送信対象から除外されます。',
      CONFIRM_DESC_REMOVED: ' このWebサイトはキャンセルされ、一覧から削除されます。',
      CONFIRM_GO_BACK: '戻る',
      GO_PREVIOUS_TITLE: '前のWebサイトへ移動しますか？',
      GO_PREVIOUS_CONFIRM: '前のWebサイトに戻ってもよろしいですか？',
      SENTIMENT_UPDATE_SUCCESS: '感情分析の更新が完了しました',
      SENTIMENT_UPDATE_FAILED: '感情分析の更新に失敗しました',
      SELECT_ROWS_TO_EDIT: '編集する行を選択してください',
      NO_ROWS_SELECTED: '行が選択されていません',
      ROWS_UPDATED_SUCCESS: '{{count}} 行が正常に更新されました',
      DATA_UPDATE_FAILED: 'データの更新に失敗しました',
      SUCCESS: '成功',
      ERROR: 'エラー',
      FORMS_SUBMITTED_SUCCESS: '{{count}} 件のフォームが正常に送信され、処理の対象になりました',
      DOMAIN_RATING: 'DR',
      URL_TYPE: 'URLタイプ',
      RANK_GTE: 'ランク ≥',
      EXCLUDE_DOMAINS: 'ドメインを除外',
      REPLIED_AT: '返信日時',
      TOTAL_ITEMS_FOUND: `{{total}} 件`,

      // MainKeyword
      AREA_CONFIGURATION_FOR: 'エリア設定',

      MOVE_TEMPLATE_EDIT: 'テンプレート編集へ移動',
      SELECTED_ALL_RECORDS: '全{{count}}件を選択',
      NO_ITEMS_FOUND: 'アイテムが見つかりません',

      CHECKBOX_ALERT_MESSAGE:
        '次または前のフォームに移動するときの画面遷移確認のポップアップを非表示にするには、このボックスにチェックをいれてください。',
      CHECKBOX_ALERT_BUTTON_MESSAGE:
        '以下いずれかのボタンを押下したときのポップアップを非表示にするには、このボックスにチェックをいれてください。',

      // --- Article Details: Post Modal ---
      POST_TO_GBP: 'Googleビジネスプロフィールへ投稿',
      CONFIGURE_PUBLICATION_SETTINGS: '公開設定を構成します',
      SELECT_BBS_LOCATION: 'MEOツール側のロケーションを選択',
      THIS_LOCATION_HAS_ACTIVE_INTEGRATION: 'このロケーションは自動連携が有効です',
      POST_LINK: '投稿リンク',
      ENTER_BUTTON_LINK_PLACEHOLDER: 'https://example.com/promotion',
      SCHEDULE_DATE: '予約日時',
      THUMBNAIL_READY_FOR_POSTING: '投稿用サムネイルの準備完了',
      ARTICLE_POSTED_TO_BBS_SUCCESSFULLY: 'MEOへの記事投稿連携が成功しました',
      FAILED_TO_POST_TO_BBS: 'MEOへの記事投稿連携が失敗しました',
      ARTICLE_POSTED_TO_WP_SUCCESSFULLY: 'CMSへの記事投稿連携が成功しました',
      ARTICLE_POSTED_TO_WP_FAILED: 'CMSへの記事投稿連携が失敗しました',

      // --- Article Details: Preview Modal ---
      GENERATE_PREVIEW: 'プレビューを作成',
      PREVIEW_AND_EDIT: 'プレビューと編集',
      VERIFY_CONTENT_BEFORE_PUBLISHING: '公開前に内容を確認してください',
      POST_CONTENT: '投稿コンテンツ',
      EDITABLE_CONTENT_TIP: 'ここで内容を直接編集できます',
      ENTER_GBP_POST_CONTENT: 'GBP投稿内容を入力...',
      GBP_CONTENT_TIP_MESSAGE: 'ヒント: GBP投稿の文字数制限は1500文字です。',
      POST_DETAILS: '投稿詳細',
      ATTACHED_IMAGE: '添付画像',
      PUBLICATION_TIMING: '公開タイミング',
      POST_IMMEDIATELY: '即時公開',
      TARGET_LOCATION: '対象ロケーション',
      ACTION_BUTTON_LINK: 'アクションボタンのリンク',
      SAVE_AND_USE: '保存して使用',
      GBP_CONTENT_SAVED_SUCCESSFULLY: 'GBPコンテンツを保存しました',
      FAILED_TO_SAVE_GBP_CONTENT: 'GBPコンテンツの保存に失敗しました',
      PREVIEW_GENERATED_SUCCESSFULLY: 'プレビューを作成しました',
      FAILED_TO_GENERATE_PREVIEW: 'プレビューの作成に失敗しました',
      EDIT_PREVIEW_CONTENT: 'プレビュー内容を編集',

      // --- BBS Integration Settings: Account & Mapping ---
      BBS_INTEGRATION: 'MEO連携',
      BBS_ACCOUNT:
        'MEOサービスとの連携設定をすることで、本サービスで作成された記事をGoogleビジネスプロフィールの最新情報へ投稿することができます。\n※MEOサービス側でGoogleビジネスプロフィールの連携設定が完了している必要があります。',
      BBS_ACCOUNT_DESCRIPTION: 'MEOサービスへの連携設定を管理します。',
      ENTER_BBS_EMAIL: 'MEOサービスのログインメールアドレスを入力',
      ENTER_BBS_PASSWORD: 'MEOサービスのログインパスワードを入力',
      LOGIN_TO_BBS: 'MEOサービスにログイン',
      BBS_LOGIN_SUCCESSFUL: 'MEOサービスへのログインに成功しました',
      FAILED_TO_LOGIN_BBS: 'MEOサービスへのログインに失敗しました',
      BBS_CONNECTED: 'MEOサービス連携済み',
      DISCONNECT_BBS_ACCOUNT_CONFIRMATION: '本当にMEOサービスとの連携を解除しますか？',
      DISCONNECT_CONFIRM: '解除します',
      DISCONNECT: '連携解除',
      BBS_DISCONNECTED_SUCCESSFULLY: 'MEOサービスとの連携を解除しました',
      FAILED_TO_DISCONNECT_BBS: 'MEOサービスとの連携解除に失敗しました',
      LOCATION_NOT_MAPPED_MSG: 'このロケーションはMEOサービスのロケーションに連携されていません。',
      CONNECT_LOCATION_TO_BBS: 'ロケーションをMEOサービスに連携',
      MAP_LOCATIONS_DESCRIPTION: 'このロケーションに対応するMEOサービスのロケーションを選択してください。',
      SELECTED_SEO_LOCATION: '選択された本サービスのロケーション',
      SELECT_BBS_LOCATION_TO_MAP: '連携するMEOサービスのロケーションを選択',
      SELECT_ONE_BBS_LOCATION_DESCRIPTION:
        '1つのロケーションにつき1つのMEOサービスのロケーションと連携することができます。',
      CONFIRM_MAPPING: '連携設定を登録',
      MAPPED_BBS_LOCATION: '連携済みMEOサービスのロケーション',
      LOCATION_MAPPED_SUCCESSFULLY: 'ロケーションの連携に成功しました',
      FAILED_TO_MAP_LOCATION: 'ロケーションの連携に失敗しました',

      // --- BBS Integration Settings: Scheduler ---
      LOCATION_INTEGRATION_SETTINGS: 'ロケーション連携設定',
      LOCATION_INTEGRATION_DESCRIPTION: 'このロケーションの自動投稿とスケジュールを設定します。',
      CURRENT_INTEGRATION: '現在の連携設定',
      BBS_LOCATIONS: 'BBSロケーション',
      CREATE_INTEGRATION: '連携設定を作成',
      UPDATE_INTEGRATION: '連携設定を更新',
      NO_INTEGRATION_SETTINGS: '連携設定が見つかりません。',
      DELETE_INTEGRATION_CONFIRMATION: '本当にこの連携設定を削除しますか？',
      DELETE_INTEGRATION_CONFIRM_BUTTON: '削除',
      INTEGRATION_ACTIVATED: '連携を有効化しました',
      INTEGRATION_DEACTIVATED: '連携を無効化しました',
      INTEGRATION_SETTINGS_SAVED: '連携設定を保存しました',
      FAILED_TO_SAVE_INTEGRATION: '連携設定の保存に失敗しました',
      ARTICLE_STATUSES: '対象の投稿ステータス',
      DAYS_SELECTED: '日選択済み',
      DEACTIVATE: '無効化',
      EVERY_MONTH: '毎月',
      CONNECT_NOW: '接続',
      REPLY_TEMPLATE: '返信テンプレート',
      NO_TEMPLATE_EXISTS: '利用可能なテンプレートがありません。',
      BUILD_BACKLINK_CSV: 'CSVをアップロード',
      TEMPLATE_CSV: 'テンプレートCSV',
      ARTICLE_CHAR_COUNT: '{length} / 1500 文字',
      OPTIONAL: '(オプション)',
      PLEASE_FILL_REQUIRED_FIELDS: '必須項目をすべて入力してください。',
      ACTION_REQUIRED: '対応が必要です',
      EMAIL_PLACEHOLDER: '',
      PASSWORD_PLACEHOLDER: '',

      // Platform Configuration
      MANAGE_PLATFORM_SETTINGS: 'プラットフォーム設定の管理',

      // Badge Configuration
      PLATFORM_CONFIGURATION: '運用設定',
      LOADING_MAIN_KEYWORDS: 'メインキーワードを読み込み中',
      NO_LOCATION_FOUND: 'ロケーションが見つかりません',
      LOADING_LOCATIONS: 'ロケーションを読み込み中',
      BADGE_CONFIGURATION: 'バッチ表示',
      BADGE_CONFIGURATIONS_DISABLED:
        'バッチ表示設定が有効化されていません（すべてのバッチが非表示になります）。設定したい場合は右上のトグルをONにしてください。',
      LOCATION_WISE_BADGE_CONFIGURATION: 'バッチの表示／非表示',
      BADGE_CONFIGURATION_UPDATED: 'バッチ表示設定を更新しました',
      BADGE_CONFIGURATION_DESCRIPTION:
        'ロケーションごとにバッチの表示／非表示を設定できます。設定変更後は右下の「設定を保存」ボタンを押してください。',
      SHOW_BADGE_COUNT: 'バッジ数を表示',
      BADGE_CONFIGURATION_HELP_TEXT:
        '各セクションのバッジを有効/無効にします。バッジは保留中のアクションや通知をユーザーに通知します。',
      ENABLE_BADGE_COUNT_TO_CONFIGURE: '個別のバッジを設定するには「バッジ数を表示」を有効にしてください',
      PLEASE_SELECT_LOCATION_TO_CONFIGURE_BADGES: 'バッジを設定するロケーションを選択してください',
      LOCATION_REQUIRED: 'ロケーションは必須です',

      ANY: '指定なし',
      MANUAL: '手動',
      AUTO: '自動',
      MONTHLY_QUERY_KWP: '月次クエリ（KWP）',
      MONTHLY_QUERY: '月次クエリ',
      CSV_UPLOAD: 'CSVアップロード',

      QUERY_TYPE_TOOLTIP: 'サンプル',
      EMAIL_TOOLTIP: 'Webサイトに掲載されているメールアドレス',
      LIST_TYPE_TOOLTIP: 'サービスで自動収集されたWebサイトかCSVアップロードによるWebサイトか',
      INQUIRY_FORM_TOOLTIP: 'WebページURLの問い合わせフォーム（フォームアタック先URL）',
      DOMAIN_TOOLTIP: '被リンクを獲得したい（フォームアタックする）Webページのドメイン',
      WEBSITE_TOOLTIP: '被リンクを獲得したい（フォームアタックする）WebページURL',
      DOMAIN_RATE_TOOLTIP: '被リンクの量や質をもとに算出した、Webサイト（ページ）のドメインの信頼性を示す指標',
      SEO_RANK_TOOLTIP:
        '検索順位・被リンク数、質など複数の要素をもとに算出した、Webサイト（ページ）のSEOパフォーマンスを示す総合指標',
      TITLE_TOOLTIP: 'メインキーワードをもとに自動収集されたWebサイトリストのサイト名',
      NG_WORD_STATUS_TOOLTIP: 'フォームアタックしたWebサイトに"営業禁止"などのNGワードが存在するかの判別',
      EMAIL_TYPE_TOOLTIP: 'Webサイトからの返信メールが自動返信か人手による返信であるかの判別',
      INITIAL_SENTIMENT_TOOLTIP: '返信メールの一通目のメール内容が"承諾"、"質問"、"拒否"なのか判別',
      GENERAL_SENTIMENT_TOOLTIP: '現時点が"承諾"、"質問"、"拒否"なのかのステータス',

      // Download CSV
      LOCAL_KEYWORD_CSV_LIST: 'ローカルキーワードCSVエクスポート',
      DOWNLOAD_CREDIT_HISTORY: 'クレジット履歴ダウンロード',
      CREDIT_HISTORY_CSV_LIST: 'クレジット履歴CSVエクスポート',
      MANAGE_YOUR_CREDIT_HISTORY_EXPORTS: 'クレジット履歴エクスポートファイルを管理',
      CREATE_NEW_CSV: '新しいCSVを作成',
      NO_CSV_FOUND_DESC: 'まだクレジット履歴をエクスポートしていません。最初のエクスポートを作成して開始しましょう。',
      CREATE_YOUR_FIRST_CSV: '最初のCSVを作成',
      PERIOD: '期間',
      FILE_SIZE: 'ファイルサイズ',
      TOTAL_FILES: '総ファイル数',
      READY_TO_DOWNLOAD: 'ダウンロード可能',
      IN_PROGRESS_FILES: '処理中',
      CREATE_NEW_EXPORT: '新規エクスポート作成',
      CSV_EXPORT_HELP: 'CSVファイルは30日間保持されます',
      SELECTED_PERIOD: '選択された期間',
      CHANGE_START_MONTH: '開始月を変更',
      CSV_FILE_INFO: 'CSVファイル情報',
      CSV_FILE_DETAILS: 'タイムスタンプと詳細を含むすべてのクレジット取引が含まれます。',
      EXPORT_YOUR_CREDIT_DATA: 'クレジットデータをエクスポート',
      DATA_WILL_START_FROM: 'データは以下から開始',
      COMPLETE_DATA: '完全なデータ',
      SECURE_EXPORT: '安全なエクスポート',
      INSTANT_PROCESSING: '即時処理',
      SECURE_DOWNLOAD: '安全なダウンロード',

      MONTH: '月',
      YEAR: '年',

      // Email Replies
      EMAIL_CONVERSATION: 'メールのやりとり',
      FROM: '送信元',
      NO_MESSAGES: 'メッセージが見つかりません',
      REPLY_TO: '返信先',
      UNTRACK_EMAILS: 'フォームアタックしたWebサイトと受信メールの紐づけ',
      CONFIRM_UNTRACK_EMAILS: 'このメールのやりとりを追跡解除してもよろしいですか？この操作は元に戻せません。',
      EMAIL_UNTRACKED: 'メールのやりとりの追跡を解除しました',
      FAILED_TO_UNTRACK_EMAIL: 'メールのやりとりの追跡解除に失敗しました',
      SEARCH_BY_SENDER_RECEIVER_OR_SUBJECT: '送信者、受信者、または件名で検索',
      NO_EMAIL_REPLIES_FOUND: 'メール返信が見つかりません',
      SELECT: '選択',
      CONFIRM_ATTACH_EMAIL_REPLY_TO_ATTACK_LIST:
        '選択されたメールをWebサイトに紐づけてもよろしいですか？この操作により、メールの送受信とWebサイトとの紐づけが行われます。',
      EMAIL_REPLY_ATTACHED: '受信メールをWebサイトに紐づけました',
      FAILED_TO_ATTACH_EMAIL_REPLY: '受信メールをWebサイトに紐づけられませんでした',
      ARE_YOU_SURE: '本当に実行しますか？',
      SEND_REPLY: '返信先を選び、返信メールを送信',
      SEND_REPLY_TOOLTIP:
        '返信先をプルダウンからお選びください。\n"全て"を選択した場合は本Webサイトリストに紐づくメールのやり取りをすべて表示します。\nこの場合、返信先を指定していないため\n"メールを送信"ボタンは押せません。\n個別の宛先を選んだ場合は、その宛先とのやり取りだけが表示され、本文を入力することで\n"メールを送信"ボタンを押すことができます。',
      ME: '私',
      REPLY: '返信',
      SEND_EMAIL: 'メールを送信',
      TYPE_YOUR_REPLY: '返信内容を入力...',
      DELETED: '削除済み',
      FAILED_TO_SEND_REPLY: '返信の送信に失敗しました',
      UNDO_FAILED: '元に戻すことができませんでした',
      UNDO_SUCCESSFUL: '元に戻しました',
      ARE_YOU_SURE_TO_UNDO_ATTACHING_EMAIL_REPLY:
        '選択されたメールとWebサイトとの紐づけを解除してもよろしいですか？この操作により、メールの送受信とWebサイトとの紐づけが解除されます。',
      // Password Update
      UPDATE_PASSWORD: 'パスワードを更新',
      CURRENT_PASSWORD: '現在のパスワード',
      PASSWORD_UPDATED_SUCCESSFULLY: 'パスワードが正常に更新されました',
      FAILED_TO_UPDATE_PASSWORD: 'パスワードの更新に失敗しました',
      ENTER_CURRENT_PASSWORD: '現在のパスワードを入力してください',
      ENTER_NEW_PASSWORD: '新しいパスワードを入力してください',
      PASSWORD_UPDATE_FAILED: 'パスワードの更新に失敗しました。もう一度お試しください。',

      LOCATION_WISE_SCHEDULER_CONFIG_TITLE: 'フォームアタックスケジュール設定',
      LOCATION_WISE_SCHEDULER_CONFIG_DESCRIPTION:
        'ロケーションごとに自動フォームアタックを実施する曜日、時間帯、タイムゾーンを設定できます。設定した曜日・時間帯を超えた場合は自動フォームアタックが停止し、設定した次の曜日・時間帯に再開します。',
      ALLOWED_DAYS: '許可された曜日',
      START_TIME: '開始時間',
      END_TIME: '終了時間',
      TIMEZONE: 'タイムゾーン',
      SCHEDULER_CONFIGURATION_UPDATED: 'スケジューラー設定が更新されました。',
      ERROR_LOADING_CONFIGURATIONS: '設定の読み込み中にエラーが発生しました。',
      SUNDAY: '日',
      MONDAY: '月',
      TUESDAY: '火',
      WEDNESDAY: '水',
      THURSDAY: '木',
      FRIDAY: '金',
      SATURDAY: '土',
      LOCATION_SCHEDUALR_CONFIGURATION: 'スケジュール',
      SELECT_TIMEZONE: 'タイムゾーンを選択',
      CACHE_CLEAR: 'キャッシュクリア',
      CLEAR_ALL_CACHE: 'すべてのキャッシュをクリアします。',

      // Form attact settings
      SCHEDULE_SETTINGS: 'スケジュール設定',
      VALIDATING: '検証中...',
      SCHEDULE_VALID: '有効なスケジュール',
      SCHEDULE_INVALID: '無効なスケジュール',
      VALIDATE_SCHEDULE: 'スケジュールを検証',
      PLEASE_CONFIGURE_SCHEDULE_FIRST: '最初にスケジュールを設定してください',
      SCHEDULE_VALIDATION_SUCCESS: 'スケジュールの検証が正常に完了しました',
      SCHEDULE_VALIDATION_FAILED: 'スケジュールの検証に失敗しました。設定を確認してください',
      SCHEDULER_CONFIGURATION_HELP_TEXT:
        'これらの設定は、このロケーションからのフォーム送信を処理できる時間を決定します',
      PLEASE_SELECT_LOCATION_TO_CONFIGURE_SCHEDULE: 'スケジュール設定を行うにはロケーションを選択してください',
      END_TIME_MUST_BE_AFTER_START_TIME: '終了時間は開始時間より後である必要があります',
      // SMTP Configuration
      SMTP_CONFIGURATION: 'SMTP設定',
      CONFIGURE_SMTP_SETTINGS_FOR_EMAIL_DELIVERY:
        '"メール確認"画面からメール返信機能を利用できるようにするため、SMTP設定を登録してください。\nまた、"マイプロフィール > 被リンク設定"で本設定で登録するメールアドレスが含まれたテンプレートが作成済みである必要があります。',
      LOADING_CONFIGURATION: '設定を読み込んでいます...',
      SMTP_SETTINGS: 'SMTP設定',
      MAILER: 'メーラー',
      SMTP_HOST: 'SMTPホスト',
      PORT: 'ポート',
      ENCRYPTION: '暗号化',
      USERNAME: 'ユーザー名',
      FROM_ADDRESS: '送信元アドレス',
      FROM_NAME: '送信元名',
      TEST_CONNECTION: '接続テスト',
      SAVE_CONFIGURATION: '設定を保存',
      TESTING: 'テスト中...',
      CONNECTION_SUCCESSFUL: '接続成功',
      CONNECTION_FAILED: '接続失敗',
      CONNECTION_TEST_SUCCESS: '接続テストが正常に完了しました',
      CONNECTION_TEST_FAILED: '接続テストに失敗しました。設定を確認してください',
      SMTP_CONFIGURATION_UPDATED_SUCCESS: 'SMTP設定が正常に更新されました',
      HOST_REQUIRED: 'ホストは必須です',
      PORT_REQUIRED: 'ポートは必須です',
      USERNAME_REQUIRED: 'ユーザー名は必須です',
      FROM_ADDRESS_REQUIRED: '送信元アドレスは必須です',
      FROM_NAME_REQUIRED: '送信元名は必須です',
      SMTP_CONFIGURATION_HELP_TEXT: 'これらの設定は、このロケーションからのすべてのメール通信に使用されます',
      NO_LOCATION_SELECTED: 'ロケーションが選択されていません',
      PLEASE_SELECT_LOCATION_TO_CONFIGURE_SMTP: 'SMTP設定を行うにはロケーションを選択してください',
      SMTP: 'SMTP',
      SENDMAIL: 'Sendmail',
      PHP_MAIL: 'PHPメール',
      SIMPLE_MAIL_TRANSFER_PROTOCOL: '簡易メール転送プロトコル',
      SENDMAIL_PROGRAM: 'Sendmailプログラム',
      PHP_MAIL_FUNCTION: 'PHP mail()関数',
      TLS: 'TLS',
      SSL: 'SSL',
      NONE: 'なし',
      PORT_587: 'ポート587',
      PORT_465: 'ポート465',
      PORT_25: 'ポート25',

      SUGGESTION_KEYWORD: 'サジェストKW',

      // Email verification configration
      EMAIL_VERIFICATION: 'メール認証',
      EMAIL_VERIFICATION_DESCRIPTION:
        '"メール確認"画面からメール返信機能を利用できるようにするため、「認証」ボタンをクリックして完了してください。\n（SMTP設定と本設定のどちらも有効である場合、SMTP設定が優先されます。）',
      VERIFICATION_STATUS: '認証ステータス',
      LOCATION: 'ロケーション',
      VERIFIED: '認証済み',
      INITIATED: '処理中',
      NO_VERIFICATION_DATA: '認証データがありません',
      NO_VERIFICATION_DATA_DESCRIPTION: 'メールアドレスが設定されたテンプレートがここに表示されます',
      VIEW_DETAILS: '詳細表示',
      VERIFY_EMAIL: 'メール認証',
      RETRY_VERIFICATION: '再試行',
      VERIFICATION_IN_PROGRESS: '認証処理中です。メールをご確認ください。',
      VERIFICATION_EMAIL_SENT_TO: '認証メールを {{email}} に送信しました',
      ERROR_FETCHING_VERIFICATION_LIST: '認証リストの取得中にエラーが発生しました',
      VIEW_DETAILS_FEATURE_COMING_SOON: '詳細表示機能は近日公開予定です',
      EMAIL_VERIFICATION_DETAILS: 'メール認証詳細',
      TEMPLATE_ID: 'テンプレートID',
      SENDING: '送信中...',
      EMAIL_VERIFIED_SUCCESS: 'このメールアドレスは正常に認証されました。',
      EMAIL_VERIFICATION_PENDING_HELP:
        'このメールアドレスは認証待ちです。「認証」ボタンをクリックして認証メールを送信してください。',
      EMAIL_VERIFICATION_FAILED_HELP: '認証に失敗しました。「再試行」をクリックして別の認証メールを送信してください。',
      PLEASE_CHECK_YOUR_EMAIL: 'メールを確認してください',
      VERIFICATION_CONFIRMATION_MESSAGE:
        '認証ボタンをクリックすると、確認メールが送信されます。メール本文のリンクをクリックして認証を完了してください。',
      VERIFY: '認証',
      VERIFY_EMAIL_CONFIRM: '認証メールを送信しますか？',
      RETRY_VERIFICATION_CONFIRM: '再試行しますか？',
      VIEW_DETAILS_TOOLTIP: 'テンプレートの詳細を表示',
      VERIFY_EMAIL_TOOLTIP: 'このアドレスに認証メールを送信',
      RETRY_VERIFICATION_TOOLTIP: '認証メールを再送信',
      TEMPLATE_DETAILS: 'テンプレート詳細',
      BASIC_INFORMATION: '基本情報',
      CONTACT_INFORMATION: '連絡先情報',
      ADDRESS_INFORMATION: '住所情報',
      DEPARTMENT: '部署',
      INQUIRE_TEMPLATES: '問い合わせテンプレート',
      REPLY_TEMPLATES: '返信テンプレート',
      ERROR_FETCHING_TEMPLATE_DETAILS: 'テンプレート詳細の取得中にエラーが発生しました',
      UNTRACK_EMAILS_DESCRIPTION:
        'この操作で、Webサイトと受信メールを紐づけることができます。\n一覧に表示されている受信メールはどのWebサイトとも紐づけができなかったメールです。必要に応じて各メールを適切なWebサイトに紐づけてください。\n紐づけることで、今後そのWebサイトに対するメールの送受信が自動的に反映されます。',

      // Propose Articles
      PROPOSE_ARTICLES: '記事提案',
      PROPOSE_ARTICLES_DESCRIPTION: 'SEOオーナーサイトから記事を抽出し、ロケーションごとの提案履歴を管理します。',
      EXTRACTED_ARTICLES: '抽出記事',
      PROPOSAL_HISTORY: '提案履歴',
      EXTRACTED_ARTICLES_PLACEHOLDER: 'このロケーションで抽出された記事URL、タイトル、見出しがここに表示されます。',
      PROPOSAL_HISTORY_PLACEHOLDER: 'このロケーションで生成された提案結果とメール返信がここに表示されます。',
      PROPOSE_ARTICLES_SELECT_LOCATION_HINT: '続行するにはロケーションを選択してください。',
      EXTRACTION_HISTORIES: '抽出履歴',
      SL: 'No.',
      SITE_URL: 'URL',
      ARTICLE_URL: '記事URL',
      HEADING: '見出し',
      OUTBOUND_HEADING: 'アウトバウンド見出し',
      NO_EXTRACTION_HISTORIES: '抽出履歴が見つかりません。',
      EXTRACTION_ERROR: 'エラー',
      ARTICLE_ENABLED: '記事を有効にしました。',
      ARTICLE_DISABLED: '記事を無効にしました。',
      BULK_ENABLE_ARTICLES: '選択を有効化',
      BULK_DISABLE_ARTICLES: '選択を無効化',
      BULK_DELETE_ARTICLES: '選択を削除',
      BULK_ARTICLES_ENABLED: '{{count}}件の記事を有効にしました。',
      BULK_ARTICLES_DISABLED: '{{count}}件の記事を無効にしました。',
      BULK_ARTICLES_DELETED: '{{count}}件の記事を削除しました。',
      SELECTED_COUNT: '{{count}}件選択中',
      ENABLED_STATUS: '有効',
      FILTER_BY_ENABLED_STATUS: 'ステータス絞り込み',
      FILTER_BY_EXTRACTION_HISTORY: '抽出サイト',
      EXTRACTED_ARTICLE_DETAILS: '記事詳細',
      EXTRACTED_ARTICLE_EDIT: '記事を編集',
      ARTICLE_UPDATED: '記事を更新しました。',
      ARTICLE_DELETED: '記事を削除しました。',
      DELETE_EXTRACTED_ARTICLE_CONFIRM: 'この抽出記事を削除してもよろしいですか？',
      BULK_DELETE_EXTRACTED_ARTICLES_CONFIRM:
        '選択した{{count}}件の抽出記事を削除してもよろしいですか？この操作は取り消せません。',
      DELETE_PROPOSAL_CONFIRM: 'この提案履歴を削除してもよろしいですか？',
      PROPOSAL_DELETED: '提案を削除しました。',
      PROPOSAL_CANNOT_EDIT_WHILE_RUNNING: '提案の生成中は編集できません。',
      PROPOSAL_CANNOT_DELETE_WHILE_RUNNING: '提案の生成中は削除できません。',
      CLEAR_PROPOSAL_HISTORY: '提案履歴をクリア',
      CLEAR_PROPOSAL_HISTORY_CONFIRM: 'このロケーションの提案履歴をすべて削除してもよろしいですか？',
      PROPOSAL_HISTORIES_CLEARED: '提案履歴をすべて削除しました。',
      LAST_CRAWLED_AT: '最終クロール日時',
      NO_EXTRACTED_ARTICLES: '抽出された記事がありません。抽出を実行してください。',
      RUNNING: '実行中',
      EXTRACT_ARTICLES: '記事を抽出',
      EXTRACT_ARTICLES_MODAL_TITLE: '見出し抽出ツール',
      EXTRACT_ARTICLES_MODAL_DESCRIPTION: 'サイト情報を入力して記事URLを抽出します。',
      EXTRACT_ARTICLES_STARTED: '記事の抽出を開始しました。',
      RECRAWL_STATUS: '再クロール状態',
      RECRAWL_START_TIME: '再クロール開始',
      RECRAWL_COMPLETED_AT: '再クロール完了',
      RECRAWL_SITE: 'サイトを再クロール',
      RECRAWL_SITE_CONFIRM: 'このサイトの全記事を再クロールしますか？数分かかる場合があります。',
      RECRAWL_STARTED: 'サイトの再クロールを開始しました。',
      RECRAWL_ARTICLE: 'URLを再クロール',
      ARTICLE_RECRAWLED: '記事を再クロールしました。',
      NOT_RECRAWLABLE: '初回抽出が完了した後にのみ再クロールできます。',
      EXTRACT_DATA: 'データを抽出',
      EXTRACTING: '抽出中...',
      EXTRACT_REGISTER_TEMPLATE_FIRST:
        'このロケーションのホームページURLが見つかりません。先にユーザープロフィールテンプレートを登録してください。',
      SITE_TYPE: 'サイトタイプ',
      SITE_TYPE_OTHERS: 'その他',
      SITEMAP_URL: 'サイトマップURL',
      PROPOSAL_DATE: '提案日',
      TARGET_SITE: 'ターゲットサイト',
      PROPOSED_TITLE: '提案タイトル',
      NO_PROPOSAL_HISTORY: '提案履歴が見つかりません。',
      PROPOSAL_HISTORY_DETAILS: '提案履歴の詳細',
      PROPOSAL_HISTORY_LOCATION_ID: 'ロケーションID',
      PROPOSAL_HISTORY_ATTACK_LIST_ID: 'アタックリストID',
      PROPOSAL_HISTORY_MAIN_KEYWORD_ID: 'メインキーワードID',
      PROPOSAL_HISTORY_EXTRACT_ARTICLE_ID: '抽出記事ID',
      PROPOSAL_HISTORY_PROJECT_KEY: 'プロジェクトキー',
      PROPOSAL_HISTORY_TARGET_URL: 'ターゲットURL',
      PROPOSAL_HISTORY_TARGET_NAME: 'ターゲット名',
      PROPOSAL_HISTORY_TARGET_TITLE: 'ターゲットタイトル',
      PROPOSAL_HISTORY_TARGET_DESCRIPTION: 'ターゲット説明',
      PROPOSAL_HISTORY_PROPOSAL_TEXT: '導入文',
      PROPOSAL_HISTORY_REVERSE_TEXT: '逆提案文',
      PROPOSAL_HISTORY_USED_HEADING: '使用見出し',
      PROPOSAL_HISTORY_USED_HEADINGS: '使用見出し一覧',
      PROPOSAL_HISTORY_IS_PARTNER_SPECIFIED: 'パートナー指定',

      // Proposal email reply
      PROPOSAL_ALL_PROPOSALS: '提案作成',
      PROPOSAL_GROUP_SELECT: '提案対象サイト',
      PROPOSAL_EXTRA_SITE_URL: '別のサイトURLを追加',
      PROPOSAL_EXTRA_SITE_ADD: 'URLで提案作成',
      PROPOSAL_EXTRA_SITE_INVALID_URL: '有効なウェブサイトURLを入力してください。',
      FAILED_TO_LOAD_PROPOSAL_GROUP: '提案対象サイトの読み込みに失敗しました。',
      PROPOSAL_ALREADY_GENERATED: '提案履歴を表示',
      PROPOSAL_GENERATION_STARTED: '提案の生成を開始しました。',
      PROPOSAL_GENERATION_IN_PROGRESS: '提案を生成中です。少し時間がかかるため後ほどご確認ください。',
      PROPOSAL_GENERATION_FAILED: '提案の生成に失敗しました。',
      PROPOSAL_STATUS_PENDING: '生成中',
      PROPOSAL_STATUS_FAILED: '失敗',
      PROPOSAL_RETRY: '再生成',
      PROPOSAL_GENERATION_COMPLETED: '提案の生成が完了しました。',
      PROPOSAL_FIELD_UPDATED: '提案フィールドを更新しました。',
      PROPOSAL_DISPLAY: '表示',
      PROPOSAL_REGENERATE_EMAIL: 'メールを再生成',
      PROPOSAL_REGENERATE_INTRODUCTION: '導入文再生成',
      PROPOSAL_INSERT_INITIAL_REPLY: '初回返信を挿入',
      PROPOSAL_INSERT_NOT_YET_PUBLISHED: 'お礼メール：相手未掲載を挿入',
      PROPOSAL_INSERT_ALREADY_PUBLISHED: 'お礼メール：相手掲載済みを挿入',
      PROPOSAL_INSERT_FOLLOW_UP: 'フォローアップを挿入',
      PROPOSAL_PUBLISHED_ARTICLE_URL: '掲載記事URL',
      PROPOSAL_PLACEMENT_LOCATION_TAG: '掲載場所/タグ',
      PROPOSAL_DESIRED_PLACEMENT_URL: '希望掲載URL',
      PROPOSAL_PARTNER_INTERNAL_URLS: '相手サイト内部URL',
      PROPOSAL_PARTNER_INTERNAL_URLS_SELECT: '相手サイトの記事URLを選択',
      PROPOSAL_UNABLE_TO_FETCH_TITLE: 'タイトルを取得できません',
      OPEN_IN_NEW_TAB: '新しいタブで開く',
      PROPOSAL_PUBLISHED_ARTICLE_TITLE: '掲載記事タイトル',
      PROPOSAL_INITIAL_REPLY: '初回返信',
      PROPOSAL_NOT_YET_PUBLISHED: 'お礼メール：相手未掲載の場合',
      PROPOSAL_ALREADY_PUBLISHED: 'お礼メール：相手掲載時済みの場合',
      PROPOSAL_FOLLOW_UP: 'フォローアップ',
      PROPOSAL_CLICK_TO_INSERT: 'クリックして返信本文に挿入',
      PROPOSAL_CONTENT_EMPTY: '挿入するコンテンツがありません。',
      FAILED_TO_LOAD_PROPOSAL_DATA: '提案データの読み込みに失敗しました。',
      PROPOSAL_REGENERATE_EMAIL_STARTED: 'メールの再生成を開始しました。',
      PROPOSAL_REGENERATE_INTRO_STARTED: '紹介文の再生成を開始しました。',
      PROPOSAL_REGENERATE_EMAIL_COMPLETED: 'メール本文を再生成しました。',
      PROPOSAL_REGENERATE_INTRO_COMPLETED: '導入文とメール本文を再生成しました。',
      FIELD: '項目',
      CONTENT: '内容',

      // Dashbaord
      DASHBOARD: 'ダッシュボード',
      SEO_SCORE: 'ドメインランク',
      DOMAIN_RATING: 'ドメインレーティング',
      ARTICLES_CREATED: '作成された記事',
      FORMS_SENT: '送信されたフォーム',
      BACKLINKS_ACQUIRED: '獲得した被リンク',
      REVIEW_ALL: '作成済み記事を表示',
      AUTO_SEND: '自動送信',
      MANUAL_SEND: '送信結果を表示',
      MANAGEMENT: '掲載状況を管理',
      CHECK_EMAIL: 'メールを確認',
      THIS_MONTH: '今月',
      NOT_FETCHED_YET: '未取得',
      SEO_PERFORMANCE: 'Google Search Consoleデータ',
      GSC_DISCONNECTED: 'GSC未接続',
      LINK_ACCOUNT: 'アカウント連携',
      DATA_FEED_ACTIVE: 'データフィードアクティブ',
      CLICKS: 'クリック数',
      IMPRESSIONS: 'インプレッション数',
      AVG_CTR: '平均CTR',
      NO_DATA_AVAILABLE: 'データがありません',
      START_DATE: '開始日',
      END_DATE: '終了日',
      LAST_7_DAYS: '過去7日間',
      LAST_30_DAYS: '過去30日間',
      LAST_3_MONTHS: '過去3ヶ月',
      LAST_MONTH: '先月',
      SELECT_DATE_RANGE: '日付範囲を選択',
      SELECT_DATES: '日付を選択',
      CLICKS_IMPRESSIONS: 'クリック数 / インプレッション数',
      CTR_PERCENT: 'CTR (%)',
      RESET_TO_CURRENT_MONTH: '今月にリセット',
      TRY_DIFFERENT_DATE_RANGE: '別の日付範囲を選択してください',
      COUNT: '件数',
      ADDITIONAL_INFO: '詳細情報',
      TOP_QUERIES: '上位クエリ',
      TOP_PAGES: '上位ページ',
      COUNTRY: '国',
      DEVICES: 'デバイス',
      QUERY: 'クエリ',
      PAGE: 'ページ',
      KEY: 'キー',
      CTR: 'CTR',
      FETCH_DATE: '取得日',
      LOADING_MORE: '読み込み中...',
      ARTICLE_CREATION_SETTINGS: '記事作成設定',
      BACKLINK_SETTINGS: '被リンク設定',
      AUTHOR_INFO_DESCRIPTION:
        '記事作成用キーワードの取得や記事作成に使用する著者情報を設定してください。\n設定した内容に基づいて記事作成用キーワード、記事が生成されます。',
      AUTHOR_NAME: '著者名',
      AUTHOR_TEXT: '著者テキスト',
      BUSINESS_NAME: 'ビジネス名',
      TEL: '電話番号',
      SERVICE_AREA: 'サービスエリア',
      NEARBY_STATION: '最寄駅',
      BUSINESS_TYPE: '業種・カテゴリ',
      SAVE_AUTHOR_PROFILE: '著者プロフィールを保存',
      ARTICLE_AUTHOR_PROFILE_SAVED: '著者プロフィールが正常に保存されました。',
      AUTHOR_INFORMATION: '著者情報',
      ARTICLE_THUMBNAIL: 'アイキャッチ画像',
      AUTHOR_INFO_RESTRICTION_NOTE: '使用するにはマイプロフィール->記事作成設定にて著者情報を登録する必要があります。',
      UPDATED_AT: '更新日時',
      ADD_MORE_SITE_TITLE: 'Webサイトリストを追加',
      ADD_MORE_SITE_BTN: 'Webサイトリストを追加',
      ADD_MORE_SITE_DESC:
        '{{limit}}件のWebサイトリストを追加することができます。この操作は{{credit}}クレジットを消費します。Webサイトリストを追加しますか？',
      ADD_MORE_SITE_DESC_KEYWORD:
        'このメインキーワードのWebサイトリストはすべてご利用いただきました。新たにメインキーワードを登録し、新しいWebサイトリストを作成しましょう。',
      ADD_MORE_WEBSITES_FAILED: 'Webサイトリストの追加に失敗しました。もう一度お試しください。',
      WEBSITE_LIMIT_ALERT: '「Webサイトリストを追加」ボタンをクリックして、Webサイトリストを追加してください。',
      PARTIAL: '部分一致',
      EXACT: '完全一致',
      FILTERS_ACTIVE: 'フィルター有効',
      CLEAR_ALL: 'すべてクリア',
      APPLY_FILTERS: 'フィルターを適用',
      EXCLUDE_DOMAINS_PLACEHOLDER: `部分一致：テキストを含むドメインをすべて除外します（例：「test」→ test.com、support.test.com）。
完全一致：ルートドメインとすべてのサブドメインを除外します（例：「test.com」→ test.com、www.test.com、support.test.com）。`,
      EXCLUDE_DOMAINS_HELP: 'ドメイン名をカンマ区切りで入力してください',
      BUSINESS_AUTHOR_INFORMATION_USED: '業種｜著者情報利用',
      CONFIRMATION_ALERT_CREDIT_BADGE: 'クレジットを消費します',
      WEBSITE_CANCEL_ALERT: 'キャンセル',
      WEBSITE_CONFIRM_ALERT: '確認',
      WEBSITE_ADD_MAIN_KEYWORD: 'メインキーワードを追加',
      ADD_ALL_SITE_TITLE: 'すべてのWebサイトリストを追加',
      ADD_ALL_SITE_DESC:
        '{{count}}件（すべて）のWebサイトリストを追加しようとしています。Webサイトリストを追加しますか？',
      ADD_MORE_WEBSITES_SUCCESS: 'Webサイトリストが正常に追加されました',

      // Sub keyword
      ADD_SUB_KEYWORD: 'サブキーワード追加',
      ADD_SUB_KEYWORD_DESC: 'サブキーワードを入力してください。',
      SUB_KEYWORD: 'サブキーワード',
      SUB_KEYWORD_PLACEHOLDER: '例：SEOサービス',
      CREATE: '作成',
      SUB_KEYWORD_CREATED_SUCCESS: 'サブキーワードが正常に作成されました',
      SUB_KEYWORD_CREATE_FAILED: 'サブキーワードの作成に失敗しました',
      ARTICLE_GENERATION: '記事作成用キーワード',
      BACKLINK_BUILDING: '被リンク用Webサイトリスト',
      GENERATE: '生成',
      RETRY_GENERATION: '生成を再実行',
      GENERATE_NOW: '今すぐ生成',
      ADD_YOUR_FIRST_KEYWORD: '最初のキーワードを追加してください',
      ADD_SUB_KEYWORD_TOOLTIP: '{{keyword}}にサブキーワードを追加',
      CONFIRM_SUB_KEYWORD: 'サブキーワード確認',
      ARE_YOU_SURE_YOU_WANT_TO_REGISTER_SUB_KEYWORD: 'このサブキーワードを登録してもよろしいですか？',
      PLEASE_REVIEW_BEFORE_REGISTERING: '登録前に内容をご確認ください',
      THIS_ACTION_WILL_CONSUME_CREDITS: 'この操作はクレジットを消費します',
      CONFIRM_REGISTRATION: '登録を確認',
      SUB_KEYWORD_HINT: 'メインキーワードに関連する具体的なキーワードを入力してください',
      SEARCH_PREFECTURE: '都道府県検索',
      SEARCH_CITY: '市町村検索',
      SUB_KEYWORDS: 'サブキーワード',
      SUGGESTED: '提案',
      VIEW_SUB_KEYWORD_DETAILS: 'サブキーワードの詳細を表示',
      DELETE_SUB_KEYWORD: 'サブキーワードを削除',
      LOADING_SUB_KEYWORDS: 'サブキーワードを読み込み中...',
      NO_SUB_KEYWORDS: 'サブキーワードがまだ追加されていません',
      ADD_FIRST_SUB_KEYWORD: 'サブキーワードを追加',
      ARE_YOU_SURE_DELETE_SUB_KEYWORD: 'このサブキーワードを削除してもよろしいですか？',
      STARTED: '開始',
      FAIL_REASON: '失敗理由',
      ARTICLE_GENERATION_IN_PROGRESS: '記事の生成中',
      ARTICLE_GENERATION_NOT_STARTED: '記事の生成はまだ開始されていません',
      SUB_KEYWORD_REGISTRATION_INFO_TITLE: 'サブキーワードが正常に登録されました',
      SUB_KEYWORD_REGISTRATION_INFO_HEADLINE: 'サブキーワードが正常に登録されました',
      SUB_KEYWORD_REGISTRATION_INFO_STEP_1: 'このサブキーワードのコンテンツを生成できるようになりました。',
      SUB_KEYWORD_REGISTRATION_INFO_STEP_2: 'このサブキーワードのコンテンツ生成にはクレジットが消費されます。',
      SUB_KEYWORD_REGISTRATION_INFO_STEP_3: 'いつでも生成ボタンをクリックしてコンテンツを生成できます。',
      GOT_IT: '了解しました',

      // Sub Keyword Select
      SELECT_SUB_KEYWORD: 'サブキーワードを選択',
      NO_SUB_KEYWORD_FOUND: 'サブキーワードが見つかりません',
      SELECT_MAIN_KEYWORD_FIRST: 'まずメインキーワードを選択してください',
      ARTICLE_MAIN_KEYWORD: 'メインキーワード',
      ARTICLE_SUB_KEYWORD: 'サブキーワード',
      KEYWORD_INPUT_TYPE: 'KW登録タイプ',

      // Sidebar routes
      BACKLINKS: '被リンク',
      SETTINGS: '設定',

      BIZ_ARTICLES: 'ビジネス記事作成',
      LOCAL_ARTICLES: '地域記事作成',
      REWRITE_ARTICLES: '記事を書き直す',
      CONFIRM_ARTICLES: '作成済み記事一覧',
      CREATE_ARTICLES: 'キーワードを入力して記事作成',

      CHECK_SEND_RESULTS: '送信結果確認',
      CHECK_MAILS: 'メール確認',
      MANAGE_BACKLINKS: '掲載状況の確認/管理',
      MANUAL_SUBMISSION: '手動フォーム送信',

      COMMON: '共通設定',
      MY_SITES: 'マイWebサイト',
      KEYWORDS: 'キーワード管理',
      PROFILE: 'マイプロフィール',
      NOTIFS: '通知',

      ARTICLE_MANAGEMENT: '記事管理',
      BRIDGE: 'MEO連携',
      PLATFORM_CONFIG: '運用設定',

      ATTACH_EMAIL: 'メール添付',
      ATTACH_TO_ATTACK_LIST: 'アタックリストに紐づける',
      LOADING_ATTACK_LIST: 'アタックリストを読み込み中...',
      SEARCH_BY_SITE_NAME_OR_URL: 'サイト名またはURLで検索',
      ATTACH_SUCCESS: '正常に紐づけられました',
      ATTACH_ERROR: '紐づけに失敗しました',

      CLICK_TO_VIEW: 'クリックして見る',
      WEBSITE_URL: 'WebサイトURL',
      ADDING: '追加中...',
      YES_ADD_WEBSITE: 'はい、追加します',
      ONLY_ONE_WEBSITE_ALLOWED: 'ロケーションごとに1つのWebサイトのみ追加できます',
      ACTIVATING: '有効化中...',
      ADDED_ON: '追加日',
      ADD_YOUR_FIRST_WEBSITE: '最初のWebサイトを追加してください',
      PLEASE_WAIT: 'お待ちください',
      LOADING_GSC_STATUS: 'ステータスを読み込み中...',
      ACCOUNT_CONNECTED: 'アカウントが連携されています',
      REFRESH_STATUS: 'ステータスを更新',
      CONNECT_TO_GSC_MESSAGE: 'Google Search Consoleアカウントを連携して、Webサイトを登録',

      STOP_FORM_ATTACK: 'フォームアタックを停止',
      STOP_FORM_ATTACK_DESCRIPTION:
        'フォームアタックを停止してもよろしいですか？この操作ではまだ開始されていない（未着手の）Webサイトへのフォームアタックが停止されます。',
      STOP_FORM_ATTACK_SUCCESS: 'フォームアタックを停止しました',
      STOP_FORM_ATTACK_FAILED: 'フォームアタックを停止できませんでした',

      // Password Update
      CONFIRM_PASSWORD: 'パスワードを確認',
      PASSWORD_SECURITY_MESSAGE: '強力なパスワードでアカウントを保護してください',
      PASSWORD_STRENGTH: 'パスワードの強度',
      WEAK: '弱い',
      MEDIUM: '中程度',
      STRONG: '強い',
      UPDATING: '更新中...',
      PASSWORD_REQUIREMENTS: '8文字以上で、英字と数字を含む強力なパスワードを使用してください',

      // Profile Settings
      ACCOUNT_SETTINGS: 'アカウント設定',
      MANAGE_SECURITY_SETTINGS: 'セキュリティ設定を管理',
      EDITOR_BOLD: '太字',
      EDITOR_ITALIC: '斜体',
      EDITOR_LINK: 'リンク',
      EDITOR_UNLINK: 'リンク解除',
      EDITOR_BULLET_LIST: '箇条書き',
      EDITOR_NUMBERED_LIST: '番号付きリスト',
      EDITOR_ENTER_URL: 'URLを入力してください (例: https://example.com):',
      EMAIL_FORWARDING_TITLE: 'メール転送設定が必要です',
      EMAIL_FORWARDING_DESCRIPTION:
        'フォームアタックしたWebサイトからメール返信があった場合、そのメールを"メール確認"画面に表示することができます。本機能を利用するためにはご自身のメールソフトで必ず以下アドレスに対して転送設定を行ってください。',
      FORWARDING_ADDRESS: '転送先アドレス',
      I_HAVE_SET_IT_UP: '設定しました',
      CONFIGURE_LATER: '後で設定する',
      INQUIRY_BODY_GENERATION_TITLE: '問い合わせ本文生成',
      INQUIRY_BODY_GENERATION_DESCRIPTION: '登録済みのテンプレート内容をもとに、問い合わせ本文を自動生成します',
      INQUIRY_BODY_GENERATION_WARNING:
        '問い合わせ本文はAIによって生成されたものであり、誤りや不正確な情報が含まれる可能性があります。ご利用にあたっては、内容の確認を行ってください。',
      CHANGE_RECEIPINT: '受信先変更',
      CLICK_TO_FILTER_BY_LOCATION: '地域別に絞り込む',

      NOT_FOUND_NEW: '見つかりませんでした',
      NOT_FOUND_NG: '検知なし',
      FOUND_NG: '検知あり',
      CANCEL_FOR_ADD_MORE_SITE: 'キャンセル',
      CONFIRM_FOR_ADD_MORE_SITE: '確認する',
      UNTRACKED_REPLIES: 'Webサイトリストに紐づいていない受信メール',
      COMMON_DOMAIN_FILTER: 'ドメイン除外設定',
      COMMON_DOMAIN_FILTER_TOOLTIP:
        '有効にすると、一般的なドメイン（Gmail、Yahooなど）が予測から除外されます。無効にすると、それらは含まれます。',
      SEARCH_EMAILS_OR_SUBJECT: 'メールまたは件名で検索...',
      MESSAGE_BODY: 'メッセージ本文',
      TOTAL_ITEMS_FOUND: '合計 {{total}} 件見つかりました',
      SENDER: '送信者',
      RECEIVER: '受信者',
      BODY: '本文',
      ENTRIES_FOUND: '件見つかりました',
      LOADING_DATA: '読み込み中...',
      PARTICIPANTS: '関係者',
      'SUBJECT_&_CONTENT': '件名と本文',
      SUBJECT_PREVIEW: '件名のプレビュー',
      MESSAGE_CONTENT: 'メッセージ内容',
      COPY_BODY: '本文をコピー',
      NO_REPLIES_FOUND: '返信が見つかりません',
      SELECT: '選択',
      ATTACH_TO_ATTACK_LIST: '受信メールをフォームアタックしたWebサイトに紐づけ',
      ATTACHING: '紐づけ中...',
      FORECAST: '予測',
      SELECT_ENTRY: '手動選択',
      ATTACH_EMAIL_CONFIRMATION: '紐づけの確認',
      ARE_YOU_SURE_TO_ATTACH: 'このメールを選択したWebサイトに紐づけてもよろしいですか？',
      YES_ATTACH: '登録',
      SELECT_AN_ENTRY_TO_ASSOCIATE_WITH_THIS_EMAIL: '本メールを紐づけるWebサイトを選択してください',
      ATTACHED_SUCCESSFULLY: 'メールが正常に紐づけられました',
      FAILED_TO_ATTACH: 'メールの紐付けに失敗しました',
      ERROR_ATTACHING_EMAIL: 'メールの紐づけ中にエラーが発生しました',
      UNTRACK_ATTACH_SECURITY_REJECTED:
        'このメールはこのロケーションまたは受信アドレスに属していないため、紐づけできません。',
      AI_FORECAST: '予測',
      EMAIL_BODY: 'メール本文',
      MANUAL_SELECTION: '手動選択',
      ANALYZING_CONVERSATION: '会話を分析中...',
      FINDING_PROBABLE_MATCHES: 'アタックリストから一致する可能性のあるものを探しています',
      NO_SUGGESTIONS_FOUND: 'Webサイトのサジェスト候補が見つかりません',
      TRY_MANUAL_SELECTION_TAB: '手動選択タブでWebサイトを検索してみてください',
      LOADING_ENTRIES: 'エントリを読み込み中...',
      NO_RESULTS_FOUND: '検索結果が見つかりません',
      MESSAGE_DETAILS: 'メッセージ詳細',
      COPY_MESSAGE: 'メッセージをコピー',
      COPIED: 'コピーしました',
      SEE_MORE: 'もっと見る',
      DETACH_EMAIL: 'メールの紐づけを解除する',
      CONFIRM_DETACH_EMAIL:
        'このメールの紐づけを解除してもよろしいですか？解除後はWebサイトリストに紐づいていない受信メール一覧に表示されます。',
      DETACHED_SUCCESSFULLY: '正常に紐づけを解除しました',
      DETACH_FAILED: '紐づけの解除に失敗しました',
      DETACH_CONVERSATION_TITLE: 'Webサイトとの紐づけを解除',
      DETACH_CONVERSATION_DESCRIPTION: 'このメールアドレスとWebサイトリストとの紐づけを解除しましすか？',
      CONFIRM_DETACH: '紐づけを解除',
      DETACH_SUCCESS: '正常に紐づけを解除しました',
      DETACH_INFO_MISSING: '紐づけの解除に必要な情報が不足しています',
      OTHER_COMPANY_BRAND_INFO: '他社情報',
      INCLUDE: '含める',
      EXCLUDE_BRAND_PROMPT_TEXT:
        '実在する社名、病院名、店名、製品・サービス名を内容に含めないでください。ただし著者情報が出力されている場合は、必ず残してください。',
      WAITING_FOR_RETRY: 'リトライ待機',
      ARTICLES_HEADER_KEYWORD_TOOLTIP: '記事作成用キーワードです。',
      ARTICLES_HEADER_STATUS_TOOLTIP: 'キーワードの記事作成ステータスです。',
      ARTICLES_HEADER_TYPE_TOOLTIP: 'キーワードの種別を示します。',
      ARTICLES_HEADER_ARTICLE_MODE_TOOLTIP: '記事作成モードを示します。',
      ARTICLES_HEADER_POSITION_TOOLTIP: '自社サイトの現在の検索順位です。',
      ARTICLES_HEADER_MY_WEBSITE_POSITION_TOOLTIP: '検索結果における自社サイトの現在の順位です。',
      ARTICLES_HEADER_SEARCH_VOLUME_TOOLTIP: '月間でどのぐらい検索されているかを示す指標です。',
      ADDITIONAL_INFO_KEY_QUERY_TOOLTIP: 'ユーザーがGoogleで検索したキーワードです。',
      ADDITIONAL_INFO_KEY_PAGE_TOOLTIP: '検索結果に表示されたページのURLです。',
      ADDITIONAL_INFO_KEY_COUNTRY_TOOLTIP: '検索が行われた国です。',
      ADDITIONAL_INFO_KEY_DEVICE_TOOLTIP: '検索に使用されたデバイスの種類です（デスクトップ・モバイル・タブレット）。',
      ADDITIONAL_INFO_CLICKS_TOOLTIP: '検索結果からあなたのサイトへ実際にアクセスされた回数です。',
      ADDITIONAL_INFO_IMPRESSIONS_TOOLTIP: '検索結果にあなたのサイトが表示された回数です。',
      ADDITIONAL_INFO_CTR_TOOLTIP: 'インプレッションのうち、クリックされた割合です。',
      ADDITIONAL_INFO_POSITION_TOOLTIP:
        '検索結果で何番目に表示されたかの平均値です。数字が低いほど上位表示されています。',
      ADDITIONAL_INFO_FETCH_DATE_TOOLTIP: 'Googleサーチコンソールからデータを取得した日付です。',
      ADDITIONAL_INFO_UPDATED_AT_TOOLTIP: 'このレコードの最終更新日時です。',
      ARTICLES_HEADER_TREASURE_KEYWORD_RATING_TOOLTIP: 'どのぐらいの価値があるか（お宝度）を示す評価です。',
      ARTICLES_HEADER_KEYWORD_DIFFICULTY_TOOLTIP: '検索結果で上位表示することがどの程度難しいかを示す指標です。',
      ARTICLES_HEADER_CONVERSION_NEAR_SCORE_TOOLTIP:
        '予約・購入などの成果（コンバージョン）につながる可能性を示す評価です。',
      ARTICLES_HEADER_KW_RELEVANCE_TOOLTIP:
        'キーワードと自サイトの関連度です。CVスコア5.0以上のKWが判定されます。',
      ARTICLES_HEADER_AI_OVERVIEW_TOOLTIP: 'Googleの検索結果でAIオーバービューの表示有無を示します。',
      ARTICLES_HEADER_RELATED_QUESTIONS_TOOLTIP: 'Googleの検索結果で「関連する質問」の表示有無を示します。',
      ARTICLES_HEADER_MEO_TOOLTIP: 'Googleの検索結果でGoogleMap（ローカル検索結果）の表示有無を示します。',
      ARTICLES_HEADER_TITLE_TOOLTIP: '作成された記事のタイトルです。',
      ARTICLES_HEADER_URL_TOOLTIP: '記事が公開されている、または公開される予定のURLです。',
      INDEX_REQUEST_POPUP_DISPLAY: 'インデックス申請ポップアップの表示',
      INDEX_REQUEST_POPUP_TOOLTIP:
        'ロケーションごとの設定です。記事詳細画面でのインデックス申請案内ポップアップの表示を切り替えます。',
      POSTED_ARTICLE_URL: '投稿記事URL',
      INDEX_REQUEST: 'インデックス申請',
      INDEX_GUIDE_MESSAGE:
        '記事を公開した場合、記事URLをGoogleに登録申請することでSEO効果が期待できますので、インデックス申請を行ってください。',
      INDEX_GUIDE_PENDING_MESSAGE:
        'インデックス申請が未完了です。CMSへの記事公開後、投稿記事URLを登録し、Googleサーチコンソールでインデックス申請を行ってください。',
      PROCEED_TO_GSC_INDEX_PAGE: 'Googleの登録申請ページへ進む',
      INDEX_GUIDE_IMAGE_ALT: 'Googleサーチコンソール URL検査の案内',
      GSC_INDEX_LINK_ERROR: 'Googleサーチコンソールのインデックス申請画面を開けませんでした。',
      POSTED_ARTICLE_URL_SAVED: '投稿記事URLを保存しました。',
      INDEX_GUIDE_PANEL_TITLE: 'Googleインデックス案内',
      INDEX_SUBMISSION: 'インデックス申請',
      INDEX_SUBMISSION_COMPLETED: 'インデックス申請済み',
      INDEX_SUBMISSION_PENDING: '未申請',
      INDEX_SUBMISSION_REQUIRES_URL: '先に投稿記事URLを登録してください',
      ARTICLES_HEADER_INDEX_SUBMISSION_TOOLTIP: 'Googleサーチコンソールでインデックス申請したらチェックしてください',
      VERIFY_WORDPRESS_POST: 'WordPress投稿を確認',
      WP_POST_STATUS_LABEL: 'WordPressステータス',
      WP_POST_STATUS_DRAFT: '下書き',
      WP_POST_STATUS_PUBLISHED: '公開済み',
      WP_POST_STATUS_SCHEDULED: '予約投稿',
      WP_POST_STATUS_DELETED: '削除済み',
      WP_POST_SYNC_SUCCESS: 'WordPressの投稿状態を更新しました。',
      WP_POST_SYNC_FAILED: 'WordPressの投稿状態の確認に失敗しました。',
      WP_POST_STATUS_UPDATE_SUCCESS: '投稿ステータスを更新しました。',
      WP_POST_STATUS_UPDATE_FAILED: '投稿ステータスの更新に失敗しました。',
      WP_RELAY_STATUS_REQUIRES_URL: 'ステータスを変更するには、先に投稿記事URLを保存してください。',
      WP_RELAY_STATUS_SELECT_HINT: '下書きまたは公開済みを選択し、投稿記事URLとあわせて保存してください。',
      WP_RELAY_URL_STATUS_SAVE_SUCCESS: '投稿記事URLとステータスを保存しました。',
      WP_RELAY_URL_STATUS_SAVE_FAILED: '投稿記事URLまたはステータスの保存に失敗しました。',
      INDEX_REQUEST_REQUIRES_PUBLISHED: 'WordPressの記事が公開済みになるとインデックス申請ができます。',
      ARTICLES_HEADER_CATEGORY_TOOLTIP: 'この記事に割り当てられたCMSカテゴリーです。',
      ARTICLES_HEADER_MEMO_TOOLTIP: 'このエントリに関する内部メモやコメントです。',
      ARTICLES_HEADER_CREATED_AT_TOOLTIP: 'このレコードが最初に作成された日時です。',
      ARTICLES_HEADER_QUEUED_AT_TOOLTIP: '記事作成タスクが処理キューに追加された時刻です。',
      ARTICLES_HEADER_CMS_INTEGRATION_TOOLTIP: 'CMSへの記事連携ステータスです。',
      ARTICLES_HEADER_BBS_INTEGRATION_TOOLTIP: 'MEOへの記事連携ステータスです。',
      ARTICLES_HEADER_STARTED_AT_TOOLTIP: '記事作成開始日時です',
      ARTICLES_HEADER_COMPLETED_AT_TOOLTIP: '記事作成完了日時です。',
      ARTICLES_HEADER_LOCATION_TOOLTIP: '記事作成したロケーション名です。',
      ARTICLES_HEADER_INPUT_TYPE_TOOLTIP: 'メイン/サブキーワードのどちらから取得されたかを示します。',
      ARTICLES_HEADER_CHARACTER_COUNT_TOOLTIP: '作成された記事の総文字数です。',
      ARTICLES_HEADER_SELECTED_CHARACTER_COUNT_TOOLTIP: '記事作成時に選択した指定文字数です。',
      BACKLINKS_HEADER_ID_TOOLTIP: 'このレコードの一意識別子です。',
      BACKLINKS_HEADER_TITLE_TOOLTIP: 'WebサイトURLのタイトルです。',
      BACKLINKS_HEADER_WEBSITE_TOOLTIP: 'WebサイトURLです。',
      BACKLINKS_HEADER_DOMAIN_TOOLTIP: 'WebサイトURLのドメインです。',
      BACKLINKS_HEADER_DOMAIN_RATE_TOOLTIP: 'Webサイトのドメインの強さを示す指標です。',
      BACKLINKS_HEADER_INTERSECTION_COUNT_TOOLTIP:
        'リスト作成時に参照したサイトのうち、各行のドメインに対してリンクしていた参照サイトの数です。',
      BACKLINKS_HEADER_NUMBER_OF_WEBSITES_TOOLTIP:
        'Webサイトが自動で取得されたか、CSVアップロードによって手動で追加されたかを示します。',
      BACKLINKS_HEADER_PROGRESSED_AT_TOOLTIP: '自動/手動フォームアタック開始日時です。',
      BACKLINKS_HEADER_COMPLETED_AT_TOOLTIP: '自動/手動フォームアタック完了日時です。',
      BACKLINKS_HEADER_SUBJECT_TOOLTIP: '受信したメール件名です。',
      BACKLINKS_HEADER_REPLY_FROM_TOOLTIP: '受信メールの送信元アドレスです。',
      BACKLINKS_HEADER_INITIAL_SENTIMENT_TOOLTIP:
        '受信メールをAIで分析し、返信内容が承諾/質問/拒否なのか判別した結果を示します。上段の承諾/質問などのフィルターボタンでフィルターすることができます。',
      BACKLINKS_HEADER_GENERAL_SENTIMENT_TOOLTIP: 'メール送受信全体をAIで分析し、総合的な判別結果を示します。',
      BACKLINKS_HEADER_MEMO_TOOLTIP: 'ユーザーが任意で追加できるメモ欄です。',
      BACKLINKS_HEADER_OWN_TOOLTIP: '自分が相手サイトのリンクを掲載したか管理します。',
      BACKLINKS_HEADER_OTHER_TOOLTIP: '相手が自社サイトのリンクを掲載したか管理します。',
      BACKLINKS_HEADER_SAVE_TOOLTIP: 'この被リンクレコードを保存します。',
      BACKLINKS_HEADER_OPEN_TOOLTIP: '被リンク元のURLを開きます。',
      BACKLINKS_HEADER_PHONE_TOOLTIP: '連絡先に関連付けられた電話番号です。',
      BACKLINKS_HEADER_ADDRESS_TOOLTIP: '連絡先に関連付けられた住所です。',
      BACKLINKS_HEADER_DOMAIN_TYPE_TOOLTIP: 'ドメインのタイプまたはカテゴリーです。',
      BACKLINKS_HEADER_REPLIED_AT_TOOLTIP: 'メール返信を受信した日時です。',
      BACKLINKS_HEADER_ACTIONS_TOOLTIP: 'この被リンクに対して可能な操作です。',
      BACKLINKS_HEADER_NOTES_TOOLTIP: '一般的なメモまたは備考です。',
      BACKLINKS_HEADER_SL_NO_TOOLTIP: 'ソート用の通し番号です。',
      BACKLINKS_HEADER_FILE_NAME_TOOLTIP: 'ソースファイルの名前です。',
      BACKLINKS_HEADER_STATUS_TOOLTIP: 'フォームアタックの失敗理由です。',
      BACKLINKS_HEADER_DATE_TIME_TOOLTIP: 'イベントの日付と時刻です。',
      BACKLINKS_HEADER_KEYWORD_TOOLTIP: '被リンク調査に関連付けられたキーワードです。',
      BACKLINKS_HEADER_EMAIL_TOOLTIP: 'アウトリーチに使用されたメールアドレスです。',
      BACKLINKS_HEADER_EMAIL_TYPE_TOOLTIP: '受信メールが自動応答か人手（Webサイトオーナーなど）かを示します。',
      BACKLINKS_HEADER_HISTORY_TOOLTIP: 'この被リンクの通信履歴です。',
      BACKLINKS_HEADER_SEO_RANK_TOOLTIP: 'ドメインのSEOランキング指標です。',
      BACKLINKS_HEADER_FORM_STATUS_TOOLTIP: 'フォームアタックのステータスです。',
      BACKLINKS_HEADER_NG_WORD_STATUS_TOOLTIP:
        '問い合わせフォームでNGワード（営業お断りなど）が検知されたかを示します。',
      BACKLINKS_HEADER_FORM_URL_TOOLTIP: 'お問い合わせフォームのURLです。',
      FORECAST_SUGGESTIONS: 'Webサイトのサジェスト候補一覧',
      ONLY_HIDDEN: '非表示を表示',
      HIDDEN_REPLIES: '非表示の受信メール',
      SHOW: '表示',
      SHOW_REPLY: '表示する',
      ARE_YOU_SURE_YOU_WANT_TO_SHOW_THIS_REPLY: 'この返信を再表示してもよろしいですか？',
      ARE_YOU_SURE_YOU_WANT_TO_HIDE_THIS_REPLY:
        'このメールを非表示にしてもよろしいですか？（非表示後は非表示リストとしてフィルターして確認することができ、再表示することも可能です。）',
      HIDE_REPLY: '非表示にする',
      SHOW_HIDDEN_EMAILS_TOOLTIP: '有効にすると、以前に非表示にしたメールのみが表示されます。',
      EMAIL_REPLY_SUCCESSFULLY_RESTORED: 'メール返信が正常に復元されました。',

      // GO TO PAGE
      GO_TO_PAGE: 'ページへ移動:',
      GO: '移動',

      // Manual Form Submission Iframe
      IFRAME_UNAVAILABLE: '{url}のウェブページは一時的に停止しているか、新しいURLに移動した可能性があります。',
      IFRAME_RESTRICTION: 'もしくはWebサイト側の制限によりツール内で表示することができませんでした。',
      IFRAME_ACCESS_DIRECTLY:
        '問い合わせフォームを入力したい場合はご自身でWebサイトにアクセスし、そちらの画面から入力をお願いします。',
      IFRAME_USE_RIGHT_VALUES: '問い合わせフォームに入力するテキストは本画面右側の各項目値をご利用ください。',
      IFRAME_UPDATE_STATUS:
        'また、本ツール以外で問い合わせフォームを送信する場合は本画面に戻り、右側下段の送信ステータスを更新してください。',
      IFRAME_X_FRAME_BLOCKED: 'このウェブサイトはiframeで表示できません。',
      IFRAME_X_FRAME_BLOCKED_DESC: 'ウェブサイトのセキュリティ設定により埋め込み表示ができません。',
      OPEN_WEBSITE_DIRECTLY: 'ウェブサイトを直接開く',
      IFRAME_TIMEOUT: 'ウェブサイトの応答がタイムアウトしました。',
      IFRAME_TIMEOUT_DESC: 'ウェブサイトの読み込みに時間がかかりすぎています。',
      IFRAME_INVALID_URL: '無効なウェブサイトアドレスです。',
      IFRAME_INVALID_URL_DESC: '指定されたURLが正しくないか、アクセスできません。',
      THE_WEBSITE: 'ウェブサイト',

      // WORDPRESS POST TYPE
      NAME: '名前',
      SLUG: 'スラッグ',
      DESCRIPTION: '説明',
      NO_POST_TYPES_FOUND: '投稿タイプが見つかりません',
      ADD_POST_TYPE: '投稿タイプを追加',
      EDIT_POST_TYPE: '投稿タイプを編集',
      ENTER_POST_TYPE_NAME: '投稿タイプ名を入力してください',
      ENTER_SLUG: 'スラッグを入力してください（例: blog-post）',
      SLUG_WILL_BE_USED_IN_URL: 'スラッグはURLで使用されます',
      ENTER_DESCRIPTION: '説明を入力してください（任意）',
      DELETE_POST_TYPE: '投稿タイプを削除',
      ARE_YOU_SURE_DELETE_POST_TYPE: 'この投稿タイプを削除してもよろしいですか？',
      FUTURE: '予定',
      UNKNOWN: '不明',
      FAILED_TO_LOAD_WEBSITES: 'Webサイトの読み込みに失敗しました',
      WORDPRESS_CREDENTIALS_REGISTERED_SUCCESSFULLY: 'WordPress認証情報が正常に登録されました',
      FAILED_TO_SAVE_POST_TYPE: '投稿タイプの保存に失敗しました',
      FAILED_TO_DELETE_POST_TYPE: '投稿タイプの削除に失敗しました',
      SAVING: '保存中...',
      SLUG_IS_REQUIRED: 'スラッグは必須です',
      ENTER_LABEL: 'ラベルを入力してください（例: ブログ投稿）',
      LABEL: 'ラベル',
      INACTIVE_POST_TYPES_WILL_NOT_BE_AVAILABLE: '非アクティブな投稿タイプは選択肢に表示されません',
      POST_TYPE_CREATED: '投稿タイプを作成しました。',
      POST_TYPE_DELETED: '投稿タイプを削除しました。',
      POST_TYPE_UPDATED: '投稿タイプを更新しました。',
      EDIT_INTEGRATION: '連携設定を編集',
      NEW_AUTO_INTEGRATION: '新規自動連携',
      CONFIGURE_AUTO_INTEGRATION_SETTINGS: '自動連携設定を構成',
      AUTO_INTEGRATION_ENABLED_DESC: '自動連携が有効になり、自動的に実行されます',
      AUTO_INTEGRATION_DISABLED_DESC: '切り替えて自動連携を有効にします',
      POST_TYPES: '投稿タイプ',
      SELECT_POST_TYPES: '投稿タイプを選択...',
      NO_POST_TYPES_AVAILABLE: '利用可能な投稿タイプがありません',
      LOADING_POST_TYPES: '投稿タイプを読み込み中...',
      SELECT_AT_LEAST_ONE_POST_TYPE: '少なくとも1つの投稿タイプを選択してください',
      NO_POST_TYPES_CREATED: '投稿タイプがまだ作成されていません。最初に作成してください。',
      SELECTED_POST_TYPES: '選択された投稿タイプ',
      PLEASE_SELECT_AT_LEAST_ONE_POST_TYPE: '少なくとも1つの投稿タイプを選択してください',
      SELECT_AT_LEAST_ONE_STATUS: '少なくとも1つのステータスを選択してください',
      ARTICLES_PER_RUN: '記事/回',
      SELECT_AT_LEAST_ONE_DAY: '少なくとも1つの曜日を選択してください',
      ARTICLE_STATUS: '記事ステータス',
      TOGGLE_TO_ENABLE_AUTO_INTEGRATION: '切り替えて自動連携を有効にします',
      NO_ACTIVE_POST_TYPES: 'アクティブな投稿タイプが存在しません',
      POSTS_WILL_BE_USED_AS_DEFAULT: '「投稿」がデフォルトとして使用されます',
      SCHEDULE_TYPE: 'スケジュールタイプ',
      SELECT_SCHEDULE_TYPE: 'スケジュールタイプを選択してください',
      DEFAULT_POST_TYPE: 'デフォルト投稿タイプ',
      WP_POST_TYPE_POSTS_LABEL: '投稿（Posts）',
      NO_OPTIONS_AVAILABLE: '選択可能なオプションがありません',
      DESTINATION: '投稿先',
      DESTINATION_TYPE: '投稿先タイプ',
      RECURRENCE: '繰り返し',
      POSTING_DESTINATION: '投稿先',
      SELECT_DESTINATION: '投稿先を選択',
      SELECT_PARENT_TYPE: '親タイプを選択',
      SELECT_PARENT_TYPE_OPTIONAL: '親タイプを選択（任意）',
      SELECT_CATEGORY_ID: 'カテゴリIDを選択',
      SELECT_CATEGORY_ID_OPTIONAL: 'カテゴリIDを選択（任意）',
      SELECT_CATEGORY: 'カテゴリを選択',
      SELECT_CATEGORY_OPTIONAL: 'カテゴリを選択（任意）',
      SELECT_TAG: 'タグを選択',
      SELECT_TAG_OPTIONAL: 'タグを選択（任意）',
      SELECT_ARTICLE_ID: '記事IDを選択',
      PARENT_TYPE_REQUIRED: '親タイプは必須です',
      CATEGORY_REQUIRED: 'カテゴリは必須です',
      ARTICLE_ID_REQUIRED: '記事IDは必須です',
      PLEASE_SELECT_POSTING_DESTINATION: '投稿先を選択してください',
      PLEASE_SELECT_AT_LEAST_ONE_DESTINATION: '少なくとも1つの投稿先を選択してください',
      AUTO_POSTING_SCHEDULE_SETTINGS: '記事自動投稿スケジュール設定',
      IPP_SCHEDULE_DESC: 'IPPへの予約公開を含む自動投稿スケジュールを設定します',
      AST_SCHEDULE_DESC: 'ASTへの予約公開を含む自動投稿スケジュールを設定します',
      NEW_SCHEDULE_SETTING: '新規自動投稿スケジュール',
      EDIT_SCHEDULE_SETTING: '自動投稿スケジュールの編集',
      NEW_SCHEDULE: '新規スケジュール設定',
      RESERVATION: '公開予約',
      RESERVATION_OFFSET_DAYS: '予約日数（後）',
      RESERVATION_TIME: '予約時間',
      ENABLE_DISABLE_AUTO_SCHEDULE: '記事自動投稿スケジュールを有効または無効にする',
      SCHEDULE_TIME: 'スケジュール時間',
      MAX_ARTICLES: '1回の最大記事数',
      FUTURE_RESERVATION_SETTING: '将来の公開予約設定',
      FUTURE_RESERVATION_ENABLED_DESC: '将来の公開予約が有効です',
      FUTURE_RESERVATION_DISABLED_DESC: '予約設定なしで即時公開されます',
      FUTURE_RESERVATION_HELP: '投稿された記事は、指定された日数および時間後に公開予約されます。',
      SCHEDULE_SAVED_SUCCESSFULLY: 'スケジュール設定が正常に保存されました',
      FAILED_TO_SAVE_SCHEDULE: 'スケジュールの保存に失敗しました',
      SCHEDULE_ACTIVATED: 'スケジュールが有効化されました',
      SCHEDULE_DEACTIVATED: 'スケジュールが無効化されました',
      FAILED_TO_TOGGLE_SCHEDULE: 'スケジュールステータスの切り替えに失敗しました',
      DELETE_SCHEDULE_CONFIRMATION: 'スケジュール設定の削除',
      ARE_YOU_SURE_DELETE_SCHEDULE: 'このスケジュール設定を削除してもよろしいですか？',
      AI_CONTENT_DISCLAIMER_TITLE: 'AI生成コンテンツに関する注意事項',
      PROCEED_AND_SAVE: '確認して保存',
      MAIN_KEYWORD_REQUIRED: 'メインキーワードを選択してください',
      NO_SCHEDULE_SETTINGS: 'スケジュール設定が登録されていません',
      SELECT_MAIN_KEYWORD_OPTIONAL: 'メインキーワードを選択（任意）',
      EMAIL_RECIPIENT_ALL : '全て（メール返信先を選択してください）'
    },
  },
};

// Get saved language from localStorage or default to 'jp'
let savedLanguage = 'jp';
try {
  savedLanguage = localStorage.getItem('seolanguage') ?? (localStorage.setItem('seolanguage', 'jp'), 'jp');
} catch (error) {
  savedLanguage = 'jp';
}

i18n
  .use(initReactI18next) // Passes i18n instance to react-i18next
  .init({
    resources,
    lng: savedLanguage, // Default language
    fallbackLng: 'jp', // Fallback language
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;
